<template>
  <VUEModalCaricamentoDati v-if="CaricamentoDatiModuli"
                        :PathGif="require('@/assets/images/CaricamentoDatiGif.gif')"
                        :VisualizzaBottoneAnnulla="true"
                        :OggettoModalCaricamentoDati="OggettoModalCaricamentoDati"
                        @onClickAnnullaCaricamentoDati="OnClickAnnullaCaricamentoDati"/>

  <VUEModalCaricamentoDati v-if="CaricamentoDatiCatena"
                          :PathGif="require('@/assets/images/CaricamentoDatiGif.gif')"/>

  <VUEPopupDatiStorici v-if="PopupStorici" 
                      :Titolo="this.GetTraduzioneLabel('Generic','TKN_DMS_EW',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_V_POPUP_STORICO',this.LinguaUtente) + ']'" 
                      :AltezzaPopup="(AltezzaPagina * 0.6) + 'px'" 
                      :VettoreModuli="VettoreModuli" 
                      :ObjCatena="Catena"                      
                      @OnClickChiudiPopup="OnClickChiudiPopup"/>

  <VUEPopupEsportaXLSXStorici v-if="PopupXLSXStorici"
                              :Titolo="this.GetTraduzioneLabel('Generic','TKN_DMS_EW',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('VUEPopupDatiStorici',ObjXLSXStorico.IsCampioniRilevati ? 'TKN_ESPORTAZIONE_XLSX_CAMPIONI_RILEVATI' : 'TKN_ESPORTAZIONE_XLSX_SPOSTAMENTI',this.LinguaUtente) + ']'"
                              :AltezzaPopup="(AltezzaPagina * 0.6) + 'px'"
                              :ChiaveSito="Catena.DatiCatena.CHIAVE_SITO"
                              :ChiaveCatena="ChiaveCatena"
                              :ObjXLSX="ObjXLSXStorico"
                              :DatiGenerici="ObjEsportazione.Generale"                              
                              :IsEstensimetroPresente="Catena.EstensimetroPresente"    
                              :DataCalibrazione="Catena.DataCalibrazione"                          
                              @OnClickChiudiPopup="ChiudiPopupXLSXStorici"/>
  
  <VUEPopupStazioneMeteo v-if="PopupStazioneMeteo" 
                        :Titolo="this.GetTraduzioneLabel('Generic','TKN_DMS_EW',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_V_POPUP_METEO',this.LinguaUtente) + ']'" 
                        :AltezzaPopup="(AltezzaPagina * 0.6) + 'px'" 
                        :VettoreModuli="VettoreModuli"
                        :ObjCatena="Catena"
                        @OnClickChiudiPopup="OnClickChiudiPopupStazioneMeteo"/>
  
  <VUEPopupModulazioneGrafici v-if="PopupModulazioneGrafici" 
                              :Titolo="this.GetTraduzioneLabel('Generic','TKN_DMS_EW',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_V_POPUP_MOD_GRAFICI',this.LinguaUtente) + ']'" 
                              :AltezzaPopup="(AltezzaPagina * 0.6) + 'px'" 
                              :ObjCatena="Catena"
                              :AltezzaPagina="AltezzaPagina"
                              :VettoreModuli="VettoreModuli"
                              :ObjListaModelli="ObjListaModelli"
                              :IsEstensimetroPresente="Catena.EstensimetroPresente"
                              :JSONGraficiModulari="JSONGraficiModulari"
                              @OnClickChiudiPopup="OnClickChiudiPopupModulazioneGrafici"/>
                    
  <VUEPopupTensioneAssorbimento v-if="PopupTensioneAssorbimento" 
                                :Titolo="this.GetTraduzioneLabel('Generic','TKN_DMS_EW',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_V_POPUP_SENS_GRAF',this.LinguaUtente) + ']'" 
                                :AltezzaPopup="(AltezzaPagina * 0.5) + 'px'" 
                                :VettoreModuli="VettoreModuli"
                                :ObjCatena="Catena"
                                @OnClickChiudiPopup="OnClickChiudiPopupTensioneAssorb"/>
                               
  <VUEPopupDatiAssistenza :PopupDatiAssistenza="PopupDatiAssistenza"
                           @OnClickChiudiPopup="PopupDatiAssistenza = false" />
  
  <VUEModal v-if="PopupSelezioneAllineamento" :Titolo="GetTraduzioneLabel('Generic', 'TKN_SELEZ_DATA_ALL', LinguaUtente)" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaAllineamento()">
    <template v-slot:Body>
      <div style="font-size:14px; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items: center; margin-top: 30px">
        <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between;">
          <p style="width: 100px; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_SCEGLI_DATA',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%" type="date" step="1" v-model="ObjAllineamento.DataAllineamento" @change="OnChangeNuovaDataAllineamento()">     
          <button v-if="ObjAllineamento.DataAllineamento != null" type="button" class="btn btn-info" style="font-weight:bold;width:32%" @click="TrovaCampioniAllineamento()">{{ this.GetTraduzioneLabel('Generic','TKN_CERCA_CAMP',this.LinguaUtente) }}</button>
          <div v-else style="width: 32%">&nbsp;</div>
        </div>
        <div v-if="ObjAllineamento.ListaOre.length > 0" style="width: 100%; margin-top: 10px; display: flex; flex-flow: row wrap; justify-content: space-between; align-items: center;">
          <select class="form-control" style="float:left; width:20%;" v-model="ObjAllineamento.OrarioAllineamento">
            <option v-for="Ora in ObjAllineamento.ListaOre" :key="Ora" :value="Ora">{{Ora}}</option>
          </select>
        </div>
        <div v-if="RicercaInCorso" style="margin-top: 10px;" :style="{'color' : Arancione}">
          <p style="width: 100%; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_RICERCA_IN_CORSO',this.LinguaUtente) }}...</p>
        </div>
        <div v-if="!ObjAllineamento.Trovato && !RicercaInCorso" style="margin-top: 10px; color: red">
          <p style="width: 100%; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_DATA_ALL_NON_TROVATO',this.LinguaUtente) }}</p>
        </div>         
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaAllineamento()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="ObjAllineamento.DataAllineamento != null && ObjAllineamento.OrarioAllineamento != null && ObjAllineamento.Trovato && ObjAllineamento.ListaOre.length > 0" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaAllineamento()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>
  
  <VUEModal v-if="PopupAllarmi" :Titolo="GetTraduzioneLabel('VUEAppContentGraficiVerticali', 'TKN_APP_CON_GRAF_V_MENU_ALLARMI', LinguaUtente)" Altezza="500px" Larghezza="600px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="ChiudiAllarmi()">
    <template v-slot:Body>
          
        <div v-for="Allarme in Catena.TipiAllarmiAttivi" :key="Allarme">
          <div width="100%" class="table table-bordered table-striped sortable ZMSeparatoreScheda" style="color:white;padding-left: 1%; margin-bottom: 1%;margin-top: 1%;">{{ Allarme.TIPO }}</div>
          <table cellpadding="0" cellspacing="0" width="100%" class="table table-bordered table-striped sortable">
            <thead style="background-color:#60604d;color:white">
              <tr>
                <th width="8%" style="vertical-align:middle;text-align: center;">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_V_MODULO',this.LinguaUtente) }}</th>
                <th width="26%" style="vertical-align:middle;text-align: center;">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_GRANDEZZA_ALLARME',this.LinguaUtente) }}</th>
                <th width="17%" style="vertical-align:middle;text-align: center;">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_V_VALORE',this.LinguaUtente) + ' [' + Allarme.UDM +']'  }}</th>
                <th width="22%" style="vertical-align:middle;text-align: center;">{{ this.GetTraduzioneLabel('Generic','TKN_DATA',this.LinguaUtente) }}</th>
                <th width="16%" style="vertical-align:middle;text-align: center;">{{ this.GetTraduzioneLabel('Generic','TKN_ORA',this.LinguaUtente) }}</th>
                <th width="11%" style="vertical-align:middle;text-align: center;">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_V_LIVELLO',this.LinguaUtente) }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="Modulo in Allarme.ListaModuli" :key="Modulo">
                <td style="vertical-align:middle;text-align: center;">{{ Modulo.MODULO }}</td>
                <td style="vertical-align:middle;text-align: center;">{{Modulo.GRANDEZZA}}</td>
                <td style="vertical-align:middle;text-align: center;">{{ Modulo.VALORE }}</td>
                <td style="vertical-align:middle;text-align: center;">{{ FormattaSoloData(Modulo.DATA_INIZIO) }}</td>
                <td style="vertical-align:middle;text-align: center;">{{ FormattaOra(Modulo.DATA_INIZIO) }}</td>
                <td style="vertical-align:middle;text-align: center;">{{Modulo.LIVELLO}}</td>
              </tr>
            </tbody>
          </table>
        </div>

    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="ChiudiAllarmi()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>
  
  <VUEModal v-if="PopupAbbinatiPerMobile" :Titolo="GetTraduzioneLabel('VUEAppContentGraficiVerticali', 'TKN_MOBILE_GRAFICI_ABBINATI', LinguaUtente)" Altezza="100px" Larghezza="400px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="ChiudiPopupAbbinamentoMobile()">
    <template v-slot:Body>
      <div>{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_SCEGLI_GRAFICI_ABBINATI',this.LinguaUtente)}}</div>
      <div class="col-md-12" style="display: flex; justify-content: space-between; margin-top: 20px;">        
        <button type="button" class="btn btn-info" style="font-weight:bold; width: 24%" @click="ChiudiPopupAbbinamentoMobile(AggiungiNuovoGrafico(1, true))">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_24H',this.LinguaUtente) }}</button>
        <button type="button" class="btn btn-info" style="font-weight:bold; width: 24%" @click="ChiudiPopupAbbinamentoMobile(AggiungiNuovoGrafico(2, true))">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_48H',this.LinguaUtente) }}</button>
        <button type="button" class="btn btn-info" style="font-weight:bold; width: 24%" @click="ChiudiPopupAbbinamentoMobile(AggiungiNuovoGrafico(7, true))">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_SETT',this.LinguaUtente) }}</button>
        <button type="button" class="btn btn-info" style="font-weight:bold; width: 24%" @click="ChiudiPopupAbbinamentoMobile(ApriPopupGraficiAbbinati())">{{ this.GetTraduzioneLabel('Generic','TKN_ALTRO',this.LinguaUtente) }}</button>    
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="ChiudiPopupAbbinamentoMobile()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEModal v-if="PopupMedia" :Titolo="GetTraduzioneLabel('VUEAppContentGraficiVerticali', 'TKN_APP_CON_GRAF_V_SEL_DATI_MEDIA', LinguaUtente)" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupMedia()">
    <template v-slot:Body>
      <div class="ZMColumn" style="font-size:14px; align-content: center; justify-content: center; align-items: center; margin-top: 10px;">
        <div class="ZMRow" style="width: 300px; justify-content: space-between;">
          <p style="width: 30px; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_DAL',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:140px; margin-right: 10px" type="date" step="1" v-model="ObjMedia.Data">
          <select class="form-control" style="width:100px;" v-model="ObjMedia.Ora">
            <option v-for="Ora in ListaOreStandard" :key="Ora" :value="Ora">{{Ora}}</option>
          </select>
        </div>
        <div class="ZMRow" style="width: 300px; margin-top: 10px; justify-content: space-between">
          <p style="width: 100px; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_V_N_ORE',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:140px; text-align: right" type="number" step="1" v-model="ObjMedia.Intervallo">
        </div>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupMedia()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="ObjMedia.Data != null" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupMedia()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEModal v-if="ObjFiltroAzimuth.Popup && !Mobile" :Titolo="GetTraduzioneLabel('VUEAppContentGraficiVerticali', 'TKN_APP_CON_GRAF_V_MOD_FILTRO_AZIMUTH', LinguaUtente)" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaModificaFiltroAzimuth()">
    <template v-slot:Body>
      <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: center; align-items: center; margin-top: 30px">
        <p style="width: 30%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_VAL_FILTRO',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:40%" type="number" step="1" v-model="ObjFiltroAzimuth.Filtro">
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaModificaFiltroAzimuth()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="ObjFiltroAzimuth.Filtro != null" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaModificaFiltroAzimuth()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEModal v-if="ObjDatiPDFGrafico.Popup && !Mobile" :Titolo="GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_V_IMP_PDF', LinguaUtente)" Altezza="320px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupPDF()">
    <template v-slot:Body>
      <div style="margin-left: 5%;margin-right: 5%;">
        <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: space-between; align-items: center; margin-top: 10px;">
          <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_ID_REPORT',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:40%" type="text" v-model="ObjDatiPDFGrafico.IdReport">
        </div>
  
        <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: space-between; align-items: center; margin-top: 10px;">
          <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_TABELLE_DX_GRAFICI',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:5%;" type="checkbox" v-model="ObjDatiPDFGrafico.ShowTabelleDx">
        </div>
  
        <div v-if="ShowCumulativoDifferenziale()" class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: space-between; align-items: center; margin-top: 10px;">
          <p style="width: 40%; margin: 0px;">{{ this.GetTraduzioneLabel('Generic','TKN_CUM_E_DIFF',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:5%;margin-left: 5%;" type="checkbox" v-model="ObjDatiPDFGrafico.StampaCumDif">
        </div>
  
        <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: space-between; align-items: center; margin-top: 10px">
          <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_STAMPA_PRIMA_PAGINA',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:5%;margin-left: 5%;" type="checkbox" v-model="ObjDatiPDFGrafico.PrimaPagina">
        </div>
  
        <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: space-between; align-items: center; margin-top: 10px">
          <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_NOME_OPERATORE',this.LinguaUtente) }}</p>
          <input :disabled="!ObjDatiPDFGrafico.PrimaPagina" class="form-control" style="width:40%" type="text" v-model="ObjDatiPDFGrafico.NomeOperatore">
        </div>
        <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: space-between; align-items: center; margin-top: 10px">
          <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_TESTO',this.LinguaUtente) }}</p>
          <input :disabled="!ObjDatiPDFGrafico.PrimaPagina" class="form-control" style="width:40%" type="text" v-model="ObjDatiPDFGrafico.Testo">
        </div>
  
        <!-- <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: center; align-items: center; margin-top: 20px">
          <label type="button" class="btn btn-info" style="float:left;font-weight:bold;width:50%">test !!      
            <input style="display:none;" type="file" id="InputImmagine" @change="LoadImmagineFromFile(elemento)" accept="image/*">
          </label>
        </div> -->
      </div>

    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupPDF()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupPDF()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEModal v-if="ObjAllDatiPDFGrafico.Popup && !Mobile" :Titolo="GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_V_IMP_PDF', LinguaUtente)" Altezza="320px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupAllPDF()">
    <template v-slot:Body>
      <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: center; align-items: center; margin-top: 20px">
        <p style="width: 30%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_ID_REPORT',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:40%" type="text" v-model="ObjAllDatiPDFGrafico.IdReport">
      </div>

      <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: center; align-items: center; margin-top: 20px;">
        <p style="margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_TABELLE_DX_GRAFICI',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:5%;margin-left: 5%;" type="checkbox" v-model="ObjAllDatiPDFGrafico.ShowTabelleDx">
        <p v-if="ObjAllDatiPDFGrafico.TipoGrafico != TipiGrafici.Piezometro" style="margin: 0px; margin-left: 10%;">{{ this.GetTraduzioneLabel('Generic','TKN_CUM_E_DIFF',this.LinguaUtente) }}</p>
        <input v-if="ObjAllDatiPDFGrafico.TipoGrafico != TipiGrafici.Piezometro" class="form-control" style="width:5%;margin-left: 5%;" type="checkbox" v-model="ObjAllDatiPDFGrafico.StampaCumDif">
      </div>
      <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: center; align-items: center; margin-top: 20px;">
        <p style=" margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_STAMPA_PRIMA_PAGINA',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:5%; margin-left: 5%;" type="checkbox" v-model="ObjAllDatiPDFGrafico.PrimaPagina">
      </div>

      <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: center; align-items: center; margin-top: 20px">
        <p style="width: 30%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_NOME_OPERATORE',this.LinguaUtente) }}</p>
        <input :disabled="!ObjAllDatiPDFGrafico.PrimaPagina" class="form-control" style="width:40%" type="text" v-model="ObjAllDatiPDFGrafico.NomeOperatore">
      </div>
      <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: center; align-items: center; margin-top: 20px">
        <p style="width: 30%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_TESTO',this.LinguaUtente) }}</p>
        <input :disabled="!ObjAllDatiPDFGrafico.PrimaPagina" class="form-control" style="width:40%" type="text" v-model="ObjAllDatiPDFGrafico.Testo">
      </div>

    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupAllPDF()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaEsportaComePDF()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEModal v-if="PopupEsportaExcel && !Mobile" :Titolo="GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_IMPOSTAZIONI_XLSX', LinguaUtente)" Altezza="180px" Larghezza="400px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="ChiudiPopupEsportaExcel()">
    <template v-slot:Body>
      <div style="margin-left: 5%;margin-right: 5%;">
        <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: space-between; align-items: center; margin-top: 10px;">
          <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_ID_REPORT',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:50%" type="text" v-model="ObjXlsxReport.ReportXlsx">
        </div>
        <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: space-between; align-items: center; margin-top: 10px;">
          <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_NOME_OPERATORE',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:50%;" type="text" v-model="ObjXlsxReport.ValutatoDa">
        </div>
        <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: space-between; align-items: center; margin-top: 10px">
          <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_TESTO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:50%" type="text" v-model="ObjXlsxReport.Testo">
        </div>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="ChiudiPopupEsportaExcel()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupEsportaExcel()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEModal v-if="ObjDirezioneGrafico.Popup && !Mobile" :Titolo="GetTraduzioneLabel('VUEAppContentGraficiVerticali', 'TKN_APP_CON_GRAF_V_MOD_FILTRO_AZIMUTH', LinguaUtente)" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaModificaDirezioneGrafico()">
    <template v-slot:Body>
      <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: center; align-items: center; margin-top: 30px">
        <p style="width: 50%; margin: 0px">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TNK_INS_ORIENTAZ_DES',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:20%" type="number" step="1" v-model="ObjDirezioneGrafico.DirezioneGraficoTotale">
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaModificaDirezioneGrafico()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="ObjDirezioneGrafico.DirezioneGraficoTotale != null" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaModificaDirezioneGrafico()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEModal v-if="ObjModificaAssi.PopupAperto && !Mobile" :Titolo="GetTraduzioneLabel('VUEAppContentGraficiVerticali', 'TKN_APP_CON_GRAF_V_SEL_DIM_ASSI', LinguaUtente)" Altezza="170px" :Larghezza="(ObjModificaAssi.TipoGrafico != TipiGrafici.Polare ? '800px' : '450px')" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaModificaAssi()">
      <template v-slot:Body>      
        <div style="display: flex; flex-flow: row nowrap;" :style="ObjModificaAssi.TipoGrafico != TipiGrafici.Polare ? {'justify-content' : 'space-between'} : {'justify-content' : 'center'}" >
          <div style="display: flex; flex-flow: column wrap;" :style="ObjModificaAssi.TipoGrafico != TipiGrafici.Polare ? {'width' : '45%'} : {'width' : '65%'}">
            <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 10px">
              <h4 style="margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_X',this.LinguaUtente) }}</h4>
            </div>
            <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
              <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
              <input class="form-control" style="width:45%; text-align: right;" type="number" step="1" v-model="ObjModificaAssi.X.Min">
              <p style="width: 15%; margin: 0px">&nbsp;{{ ObjModificaAssi.X.LabelUdm }}</p>
            </div>
            <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
              <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
              <input class="form-control" style="width:45%; text-align: right;" type="number" step="1" v-model="ObjModificaAssi.X.Max">
              <p style="width: 15%; margin: 0px">&nbsp;{{ ObjModificaAssi.X.LabelUdm }}</p>
            </div>
            <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
              <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
              <input class="form-control" style="width:45%; text-align: right;" type="number" step="1" v-model="ObjModificaAssi.X.Udm">
              <p style="width: 15%; margin: 0px">&nbsp;{{ ObjModificaAssi.X.LabelUdm }}</p>
            </div>
          </div>
          <div v-if="ObjModificaAssi.TipoGrafico != TipiGrafici.Polare" style="display: flex; flex-flow: column wrap; width: 45%">
            <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 10px">
              <h4 style="margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_Y',this.LinguaUtente) }}</h4>
            </div>
            <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
              <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
              <input class="form-control" style="width:45%; text-align: right;" type="number" step="1" v-model="ObjModificaAssi.Y.Min">
              <p style="width: 15%; margin: 0px">&nbsp;{{ ObjModificaAssi.Y.LabelUdm }}</p>
            </div>
            <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
              <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
              <input class="form-control" style="width:45%; text-align: right;" type="number" step="1" v-model="ObjModificaAssi.Y.Max">
              <p style="width: 15%; margin: 0px">&nbsp;{{ ObjModificaAssi.Y.LabelUdm }}</p>
            </div>
            <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
              <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
              <input class="form-control" style="width:45%; text-align: right;" type="number" step="1" v-model="ObjModificaAssi.Y.Udm">
              <p style="width: 15%; margin: 0px">&nbsp;{{ ObjModificaAssi.Y.LabelUdm }}</p>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:Footer>
        <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaModificaAssi()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
        <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaModificaAssi()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
      </template>
  </VUEModal>

  <VUEModal v-if="PopupGraficiAbbinati && !Mobile" :Titolo="GetTraduzioneLabel('VUEAppContentGraficiVerticali', 'TKN_APP_CON_GRAF_V_MOD_GRAF_ABB', LinguaUtente)" Altezza="350px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaModificaAbbinati()">
    <template v-slot:Body>
      <div style="font-size:14px; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items: center; margin-top: 30px">
        <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between;">
          <p style="width: 22%; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_SCEGLI_DATA',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:32%" type="date" step="1" v-model="ObjAbbinati.NuovaDataAbbinato" @change="OnChangeNuovaDataAbbinato()"> 
          <div v-if="ObjAbbinati.ListaOre.length > 0" style="float:left; width:2%;">&nbsp;</div>
          <select v-if="ObjAbbinati.ListaOre.length > 0" class="form-control" style="float:left; width:18%;" v-model="ObjAbbinati.NuovoOrarioAbbinato">
            <option v-for="Ora in ObjAbbinati.ListaOre" :key="Ora" :value="Ora">{{Ora}}</option>
          </select>
          <div v-if="ObjAbbinati.ListaOre.length > 0" style="float:left; width:2%;">&nbsp;</div>
          <button type="button" class="btn btn-info" style="font-weight:bold;width:24%;padding: 2px;font-size: 12px;" @click="TrovaCampioniPerData()">{{ this.GetTraduzioneLabel('Generic','TKN_CERCA_CAMP',this.LinguaUtente) }}</button>
        </div>
        <div v-if="ObjAbbinati.ListaOre.length > 0" style="width: 100%; margin-top: 10px; display: flex; flex-flow: row wrap; justify-content: end; align-items: right;">
          <button class="btn btn-success" style="font-weight:bold;width:24%;color: green;height: 34px;font-size: 12px;" :title="this.GetTraduzioneLabel('Generic','TKN_AGGIUNGI',this.LinguaUtente)" @click="AggiungiDataAbbinato()">{{ this.GetTraduzioneLabel('Generic','TKN_AGGIUNGI',this.LinguaUtente) }}</button>
        </div>
      </div>
      <div v-if="ObjAbbinati.LsGraficiAbbinatiTmp.length > 0" style="width: 100%; margin-top: 10px; overflow-x: auto">
        <table cellpadding="0" cellspacing="0" width="100%" style="margin-top: 5px; margin-bottom: 5px; min-width: 400px; max-height: 200px; overflow-y: auto" class="table table-bordered sortable">
          <thead style="background-color: #f2f2f2; font-weight: bold;">
            <tr>
              <th width="30%" style="padding: 2px;">{{ this.GetTraduzioneLabel('Generic','TKN_DATA',this.LinguaUtente) }}</th>
              <th width="25%" style="padding: 2px;">{{ this.GetTraduzioneLabel('Generic','TKN_ORA',this.LinguaUtente) }}</th>
              <th width="20%" style="padding: 2px;">{{ this.GetTraduzioneLabel('Generic','TKN_COLORE',this.LinguaUtente) }}</th>
              <th width="5%"  style="padding: 2px;"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="Grafico in ObjAbbinati.LsGraficiAbbinatiTmp" :key="Grafico">                        
              <td style="vertical-align: middle;">
                {{Grafico.PrettyData}}
              </td>
              <td style="vertical-align: middle;">
                {{Grafico.Ora}}
              </td>  
              <td>
                <label class="ZMColorPickerDiv" @click="CambiaColoreGrafico(Grafico)" style="width: 80%; margin-left: 10%; margin-top: 5px;" :style="{'background-color' : Grafico.Colore}">&nbsp;</label>
              </td>  
              <td>                
                <i class="fa fa-trash-o text-danger ZMIconButton" style="cursor:pointer" @click="RimuoviElemento(Grafico)"></i>
              </td>                                      
            </tr>
          </tbody>
        </table>
      </div>
      <div style="display: flex; align-items: center; justify-content: center; height: 100px" v-else>
        <label>{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_NO_GRAFICO',this.LinguaUtente) }}</label>  
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaModificaAbbinati()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button type="button" v-if="ObjAbbinati.ListaOre.length <= 0" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaAbbinati()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEPopupWarning v-if="!Mobile" style="z-index: 9999;" :Popup="PopupWarning" :Richiesta="TestoWarning" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiPopup="PopupWarning = false">
  </VUEPopupWarning>

  <VUEColorPicker :Popup="PopupColorPicker" Programma="DMSEW" :Colore="ObjColore" @OnClickConfermaPopup="ConfermaColore()" @OnClickChiudiPopup="AnnullaColore()"></VUEColorPicker>

  <VUEColorPicker :Popup="ColorPickerAbbinati" Programma="DMSEW" :Colore="ObjColoreAbbinati" @OnClickConfermaPopup="ConfermaColoreAbbinati()" @OnClickChiudiPopup="AnnullaColoreAbbinati()"></VUEColorPicker>

  <div ref="Container" style="width: 100%;">
    <div v-if="DatiNonCaricati" style="display: flex; justify-content: center;">
      DATI NON PRESENTI
    </div>
    <div v-show="!(PopupGraficiAbbinati && Mobile) &&
                 !(PopupSelezioneAllineamento && Mobile) &&
                 !(ObjModificaAssi.PopupAperto && Mobile) &&
                 !ObjIngrandimento.Ingrandito && 
                 !(ObjFiltroAzimuth.Popup && Mobile)" style="width: 100%">
      <div style="width:100%">
        <div v-for="(Banda, IndiceBanda) in ObjPosizioneGrafici" :key="Banda" style="width: calc(100%); display: flex;" ref="Container">
          <div v-for="(Elemento, IndiceGrafico) in Banda.MODULO_GRAFICO" :key="Elemento" :ref="'Grafico_' + IndiceBanda + '_' + IndiceGrafico" style="display: flex; justify-content: left;overflow-y: auto;" :style="{ width: Elemento.LARGHEZZA + '%', display : Banda.NASCOSTO ? 'none' : 'flex'}">
            <div v-if="Elemento.ELEMENTO == ModuliGrafici.Allineamento" style=" width: 100%;" :style="{'--colore-spaziatore': ColoreSpaziatoreModuli, '--altezza-titolo': '20px'}" :class="['bordo-separatore', {'bordo-spaziatore-moduli': (IndiceBanda == 0 && IndiceGrafico != 0)}]">
              <div style="display:flex; flex-flow: column nowrap;height: 50%;">
                <div style="width:100%; display: flex; justify-content: center;align-items: center;height:20px" :style="{'background-color': Banda.COLORE_BANDA}">
                    <label style="font-weight: bold; color: white;margin: 0px;"> {{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_DATA_ULT_CAMP',this.LinguaUtente) }} </label>
                </div>
                <div class="col-md-12" style="display: flex; justify-content: center; margin-top: 5px">              
                  <label>{{PrettyUltimaData}}</label>
                </div>
              </div>

              <div style="display:flex; flex-flow: column nowrap; justify-content: center;align-items: center;">
                <div style="width:94%; display: flex; justify-content: center;align-items: center;height:20px" :style="{'background-color': Banda.COLORE_BANDA}">
                    <label style="font-weight: bold; color: white;margin: 0px"> {{ Elemento.NOME_ELEMENTO }} </label>
                </div>
                <div class="col-md-12" style="display: flex; flex-flow: column wrap; justify-content: center;" :style="{'margin-bottom' : Mobile ? '10px' : '0px'}">
                  <div style="display:flex; justify-content: center; width: 100%; margin-top: 5px">
                    <label v-if="ObjAllineamento.DataAllineamento != null">{{ObjAllineamento.PrettyDataAllineamento}}</label>
                    <label v-else>{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_NO_DATA',this.LinguaUtente) }}</label>
                  </div>
                  <div style="width: 100%; display: flex; justify-content: center; margin-top: 10px">
                    <button type="button" :disabled="Catena.DatiCatena.Spostamenti.Date.length == 0" class="btn btn-info" style="font-weight:bold;width:45%; margin-right: 5px" @click="PopupSelezioneAllineamento = true">{{ this.GetTraduzioneLabel('Generic','TKN_INSERISCI',this.LinguaUtente) }}</button>
                    <button type="button" :disabled="Catena.DatiCatena.Spostamenti.Date.length == 0" class="btn btn-info" style="font-weight:bold;width:45%" @click="RimuoviAllineamento()">{{ this.GetTraduzioneLabel('Generic','TKN_RIMUOVI',this.LinguaUtente) }}</button>
                  </div>
                  <div style="width: 100%; display: flex; justify-content: center; margin-top: 5px" v-if="ObjAllineamento.DataAllineamento != null">                
                    <label style="margin: 0px; margin-right: 5px;">{{ this.GetTraduzioneLabel('Generic','TKN_ALLINEA_TEMPERATURA',this.LinguaUtente) }}</label>
                    <input class="form-control" style="margin:0px; height: 22px; width: 25px; text-align: left" type="checkbox" v-model="ObjAllineamento.AllineaTemperatura">
                  </div>
                </div>
              </div>

            </div>

            <div v-if="Elemento.ELEMENTO == ModuliGrafici.Immagine" style="width: 100%;" :style="{'--colore-spaziatore': ColoreSpaziatoreModuli, '--altezza-titolo': '20px'}" :class="['bordo-separatore', {'bordo-spaziatore-moduli': (IndiceBanda == 0 && IndiceGrafico != 0)}]">
              <div style="width:100%; display: flex; justify-content: center;align-items: center;height:20px" :style="{'background-color': Banda.COLORE_BANDA}">
                <label style="font-weight: bold; color: white;margin: 0px;">&nbsp;{{ Elemento.NOME_ELEMENTO }}</label>
              </div>
              <div>
                <div style="width:100%; display: flex; justify-content: center">
                  <img v-if="Catena.DatiCatena.IMMAGINE_CATENA" :src="Catena.DatiCatena.IMMAGINE_CATENA" :style="{height: (Banda.ALTEZZA_BANDA * 0.88 - 1 ) + 'vh', width: Elemento.LARGHEZZA + 'vw' }" style="background:white" @dblclick="IngrandisciImmagine(Catena.DatiCatena.IMMAGINE_CATENA)"/>
                  <!-- <img v-else src="/DMSEWServer/Images/ImmagineDefaultBianco.jpeg" :style="{height: (Banda.ALTEZZA_BANDA * 0.88 - 1 ) + 'vh', width: Elemento.LARGHEZZA + 'vw' }" style="background:white"/> -->
                </div>
                <div v-if="ImmagineIngrandita" @click="ChiudiIngrandimento" style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.7); display: flex; justify-content: center; align-items: center; z-index: 99999; cursor: zoom-out;">
                  <img :src="ImmagineIngrandita" style="max-height: 90vh; max-width: 90vw; box-shadow: 0 0 10px white;"/>
                </div>
              </div>
            </div>
            
            <div v-if="Elemento.ELEMENTO == ModuliGrafici.InfoGenerali" style="width: 100%;" :style="{'--colore-spaziatore': ColoreSpaziatoreModuli, '--altezza-titolo': '20px'}" :class="['bordo-separatore', {'bordo-spaziatore-moduli': (IndiceBanda == 0 && IndiceGrafico != 0)}]">
              <div style="width:100%; display: flex; justify-content: center;align-items: center;height:20px" :style="{'background-color': Banda.COLORE_BANDA}">
                <label style="font-weight: bold; color: white;margin: 0px;">{{ Elemento.NOME_ELEMENTO }}</label>
              </div>
              <div class="col-md-12" style="padding: 0px; display:flex; flex-flow: column wrap">
                <div class="col-md-12" style="margin-top: 5px;">
                  <div v-for="Info in Catena.LsInfoCatenaLeft" :key="Info" style="display: flex; flex-flow: row;">
                    <label style="font-weight: bold; width: 100%; margin-bottom: 1px; margin-top: 1px;">{{Info.Descrizione}}:  <span style="font-weight: normal;"> {{Info.Valore}} </span></label>
                  </div>
                  <div v-for="Info in Catena.LsInfoCatenaRight" :key="Info">
                    <label style="font-weight: bold; width: 100%; margin-bottom: 1px; margin-top: 1px;">{{Info.Descrizione}}:  <span style="font-weight: normal;"> {{Info.Valore}} </span> </label>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="Elemento.ELEMENTO == ModuliGrafici.MontaggioGV" style="width: 100%; overflow: hidden" :style="{'--colore-spaziatore': ColoreSpaziatoreModuli, '--altezza-titolo': '20px'}" :class="['bordo-separatore', {'bordo-spaziatore-moduli': (IndiceBanda == 0 && IndiceGrafico != 0)}]">
              <div style="width:100%; display: flex; justify-content: center;align-items: center;height:20px" :style="{'background-color': Banda.COLORE_BANDA}">
                <label style="font-weight: bold; color: white;margin: 0px;"> {{ Elemento.NOME_ELEMENTO + AggiungiDicituraDifferenziale(Elemento.ELEMENTO)}} </label>
              </div>
              <div class="col-md-12" style="padding:0px;border-bottom:solid 1px;border-left:solid 1px;border-right:solid 1px">
                <VUEComponenteGraficoGV :OggettoMontaggioGV="Elemento.CONFIGURAZIONE_GRAFICO_GV == undefined? OggettoDefaultMontaggioGV : Elemento.CONFIGURAZIONE_GRAFICO_GV" 
                                        :CatenaInfo="Catena" 
                                        :AddDatiPDF="AddDatiPDF"
                                        :VisualizzaSoloImmagine="true"
                                        :VettoreModuli = "VettoreModuli"
                                        :Differenziale = ObjDifferenziale.Differenziale
                                        :AltezzaImpostata="GetAltezzaGrafico(Elemento.ELEMENTO, Banda.ALTEZZA_BANDA * 0.88, Elemento.LARGHEZZA) - 21"/>
              </div>
            </div>

            <div v-if="Elemento.ELEMENTO == ModuliGrafici.Spacer" style="width: 100%;" :style="{'--colore-spaziatore': ColoreSpaziatoreModuli, '--altezza-titolo': '20px'}" :class="['bordo-separatore', {'bordo-spaziatore-moduli': (IndiceBanda == 0 && IndiceGrafico != 0)}]">
              <div style="width:100%; display: flex; justify-content: center;align-items: center;height:20px" :style="{'background-color': Banda.COLORE_BANDA}">
                <label style="font-weight: bold; color: white;margin: 0px;"> &nbsp;{{ Elemento.NOME_ELEMENTO }} </label>
              </div> 
            </div>

            <div v-if="Elemento.ELEMENTO == ModuliGrafici.Abbinati" style="width: 100%;" :style="{'--colore-spaziatore': ColoreSpaziatoreModuli, '--altezza-titolo': '20px'}" :class="['bordo-separatore', {'bordo-spaziatore-moduli': (IndiceBanda == 0 && IndiceGrafico != 0)}]">
              <div style="width:100%; display: flex; justify-content: center;align-items: center;height:20px" :style="{'background-color': Banda.COLORE_BANDA}">
                <label style="font-weight: bold; color: white;margin: 0px;"> {{ Elemento.NOME_ELEMENTO }} </label>
              </div>
              <div v-if="ObjAbbinati.LsGraficiAbbinati.length != 0" class="col-md-12">
                <div style="width: 100%; overflow-x: auto; overflow-y: auto; max-height: 115px; margin-top: 5px;">
                  <table class="table table-bordered sortable" cellpadding="0" cellspacing="0" width="100%" style="margin-bottom: 5px;">
                    <thead style="background-color: #f2f2f2; font-weight: bold;">
                      <tr>
                        <th width="24%" style="padding: 2px;">{{ this.GetTraduzioneLabel('Generic','TKN_VISIBILE',this.LinguaUtente) }}</th>
                        <th width="31%" style="padding: 2px;">{{ this.GetTraduzioneLabel('Generic','TKN_DATA',this.LinguaUtente) }}</th>
                        <th width="21%" style="padding: 2px;">{{ this.GetTraduzioneLabel('Generic','TKN_ORA',this.LinguaUtente) }}</th>
                        <th width="19%" style="padding: 2px;">{{ this.GetTraduzioneLabel('Generic','TKN_COLORE',this.LinguaUtente) }}</th>
                        <th width="5%"  style="padding: 2px;"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="Grafico in ObjAbbinati.LsGraficiAbbinati" :key="Grafico">
                        <td @click="CambiaVisibile(Grafico)" style="padding: 10px; user-select: none; vertical-align: middle;">
                          <div style="display: flex; justify-content: center; cursor: pointer;">&nbsp; {{ Grafico.Visibile ? 'X' : '' }} &nbsp;</div>
                        </td>                        
                        <td style="padding: 10px; vertical-align: middle;">
                          {{Grafico.PrettyData}}
                        </td>
                        <td style="padding: 10px; vertical-align: middle;">
                          {{Grafico.Ora}}
                        </td>  
                        <td style="padding: 10px;">
                          <label @click="CambiaColoreGrafico(Grafico)" style="width: 80%; margin-left: 10%; margin-top: 5px; cursor: pointer;" :style="{'background-color' : Grafico.Colore}">&nbsp;</label>
                        </td>      
                        <td style="padding: 10px; vertical-align: middle;">
                          <i class="fa fa-trash-o text-danger ZMIconButton" style="cursor:pointer" @click="RimuoviElementoDaTabella(Grafico)"></i>
                        </td>                            
                      </tr>
                    </tbody>
                  </table>
                </div> 
              </div>
              <label style="display:flex; justify-content: center; width: 100%; margin-top: 5px" v-if="ObjAbbinati.LsGraficiAbbinati.length == 0">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_NO_GRAF_ABB',this.LinguaUtente) }}</label>
              <div v-if="ObjAbbinati.LsGraficiAbbinati.length == 0" style="margin-top: 14px;"></div>
              <div v-if="!Mobile" class="col-md-12" style="display: flex; justify-content: space-between; margin-top: 5px;">        
                <button type="button" class="btn btn-info" style="font-weight:bold; width: 24%" @click="AggiungiNuovoGrafico(1, true)">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_24H',this.LinguaUtente) }}</button>
                <button type="button" class="btn btn-info" style="font-weight:bold; width: 24%" @click="AggiungiNuovoGrafico(2, true)">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_48H',this.LinguaUtente) }}</button>
                <button type="button" class="btn btn-info" style="font-weight:bold; width: 24%" @click="AggiungiNuovoGrafico(7, true)">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_SETT',this.LinguaUtente) }}</button>
                <button type="button" class="btn btn-info" style="font-weight:bold; width: 24%" @click="ApriPopupGraficiAbbinati()">{{ this.GetTraduzioneLabel('Generic','TKN_ALTRO',this.LinguaUtente) }}</button>    
              </div>
              <div v-else class="col-md-12" style="display: flex; justify-content:center; margin-top: 5px;">
                <button type="button" class="btn btn-info" style="font-weight:bold; width: 70%" @click="ApriPopupAbbinamentoMobile()">+</button>
              </div>
              <div class="col-md-12" style="display: flex; flex-flow: row wrap; justify-content: space-between; align-items: center; margin-bottom: 15px">
                <div style="margin-top: 10px; width:170px; display: flex">
                  <label style="font-weight: bold; margin-bottom: 0px; margin-right: 20px">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_REC',this.LinguaUtente) }}</label>          
                  <input class="form-control" v-model="MostraUltimo" style="margin:0px; height: 22px; width: 25px;" type="checkbox" @change="ToggleUltimaData()">
                </div>
                
                <div style="width: 100%">
                  <div style="display: flex; padding-top: 12px;">
                    <label style="font-weight: bold; margin-bottom: 0px;margin-top: -5px; margin-right: 16px;">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_RINFR_AUTO',this.LinguaUtente) }}</label>          
                    <input class="form-control" v-model="FlagAbilitaRefreshDati" style="margin:0px; margin-top: -5px; height: 22px; width: 25px;" type="checkbox">
                  </div>
                </div>

                <div style="display: flex; justify-content: flex-end; margin-top: 5px;" v-if="MostraUltimo">
                  <label style="font-weight: bold; margin-bottom: 0px; margin-right: 20px; margin-top: -1px;">{{ this.GetTraduzioneLabel('Generic','TKN_COLORE',this.LinguaUtente) }}</label>
                  <div class="ZMColorPickerDiv" :style="{'background-color' : ObjColore.ColoreScelto, 'width' : '50px'}" @click="CambiaColoreUltimo()">&nbsp;</div>
                </div>
              </div>
            </div>
            <div v-if="Elemento.ELEMENTO == ModuliGrafici.Polare ||
                       Elemento.ELEMENTO == ModuliGrafici.SpostEst ||
                       Elemento.ELEMENTO == ModuliGrafici.SpostNord ||
                       Elemento.ELEMENTO == ModuliGrafici.SpostTot ||
                       Elemento.ELEMENTO == ModuliGrafici.SpostAzimuth ||
                       Elemento.ELEMENTO == ModuliGrafici.Temperatura ||
                       Elemento.ELEMENTO == ModuliGrafici.Deformazione ||
                       Elemento.ELEMENTO == ModuliGrafici.Piezometro" style="width: 100%;" :style="{'--colore-spaziatore': ColoreSpaziatoreModuli, '--altezza-titolo': '20px'}" :class="['bordo-separatore', {'bordo-spaziatore-moduli': (IndiceBanda == 0 && IndiceGrafico != 0)}]">
              <div style="width:100%; display: flex; justify-content: center;align-items: center;height:20px" :style="{'background-color': Banda.COLORE_BANDA}">
                <label style="font-weight: bold; color: white;margin: 0px;"> {{ Elemento.NOME_ELEMENTO + AggiungiDicituraDifferenziale(Elemento.ELEMENTO) }} </label>
              </div>
                <VUEComponenteGraficoGenerico style="display: flex; justify-content: center" :style="{'z-index': 998 - IndiceGrafico}"
                                              v-if="MostraGrafici" 
                                              @ApriDettaglio="ApriDettaglio" 
                                              :CatenaInfo="Catena" 
                                              :StatoAbbinati="StatoAbbinati"
                                              :StatoAbbinatiPiezometri="StatoAbbinatiPiezometri" 
                                              :AltezzaPopup="AltezzaSchermo * 0.6" 
                                              :OnDashboard="false" :Contatore="0" 
                                              :MostraGrafici="true"
                                              :UltimaData = "UltimaData"
                                              :AllineamentoSelezionato="(Elemento.ELEMENTO == ModuliGrafici.Polare) ? ObjAllineamento.DataAllineamento : null"
                                              :GraficiChange="GraficiChange" :GraficiAdatta="GraficiAdatta" 
                                              :Zoom="1"
                                              :TipoGrafico="GetTipoGrafico(Elemento.ELEMENTO)" 
                                              :LarghezzaGrafico="GetLarghezzaGrafico(Elemento.ELEMENTO, Banda.ALTEZZA_BANDA * 0.88, Elemento.LARGHEZZA* 0.99)" 
                                              :AltezzaGrafico="GetAltezzaGrafico(Elemento.ELEMENTO, Banda.ALTEZZA_BANDA * 0.88, Elemento.LARGHEZZA)" 
                                              :ObjModificaAssi="ObjModificaAssi" :Differenziale="ObjDifferenziale.Differenziale"
                                              :AddDatiPDF="AddDatiPDF" :ModificaGraficiAll="ModificaGraficiAll" :ObjEsportazione="(Elemento.ELEMENTO == ModuliGrafici.Polare) ? ObjEsportazione : null" 
                                              :ParentData="{Refs: $refs, Indice: 'Grafico_' + IndiceBanda + '_' + IndiceGrafico}"
                                              @ApriPopupFiltroAzimuth="ApriPopupFiltroAzimuth" 
                                              @ApriPopupPDF="ApriPopupPDF" 
                                              @ApriPopupModificaDirezioneGrafico="ApriPopupModificaDirezioneGrafico" 
                                              :AllineaTemperatura="(Elemento.ELEMENTO == ModuliGrafici.Temperatura) ? ObjAllineamento.AllineaTemperatura : null">
                </VUEComponenteGraficoGenerico>
            </div>

            <!-- GRAFICI ORIZZONTALI -->
            <div v-if="Elemento.ELEMENTO == ModuliGrafici.ProfiloLong ||
                       Elemento.ELEMENTO == ModuliGrafici.DeformazioneO ||
                       Elemento.ELEMENTO == ModuliGrafici.TemperaturaO ||
                       ((Elemento.ELEMENTO == ModuliGrafici.ProfiloLongAll) && (ObjAllineamento.PrettyDataAllineamento != '')) ||
                       ((Elemento.ELEMENTO == ModuliGrafici.DeformazioneOAll) && (ObjAllineamento.PrettyDataAllineamento != ''))" style="width: 100%;" :style="{'--colore-spaziatore': ColoreSpaziatoreModuli, '--altezza-titolo': '20px'}" :class="['bordo-separatore', {'bordo-spaziatore-moduli': (IndiceBanda == 0 && IndiceGrafico != 0)}]">
              <div style="width:100%; display: flex; justify-content: center;align-items: center;height:20px" :style="{'background-color': Banda.COLORE_BANDA}">
                <label style="font-weight: bold; color: white;margin: 0px;"> {{ Elemento.NOME_ELEMENTO }} </label>
              </div>
              <VUEComponenteGraficoGenerico style="display: flex; justify-content: center"
                                            v-if="MostraGrafici" 
                                            @ApriDettaglio="ApriDettaglio" 
                                            :CatenaInfo="Catena" 
                                            :StatoAbbinati="StatoAbbinati"
                                            :StatoAbbinatiPiezometri = "StatoAbbinatiPiezometri" 
                                            :AltezzaPopup="AltezzaSchermo * 0.6" 
                                            :OnDashboard="false" 
                                            :Contatore="0" 
                                            :MostraGrafici="true"
                                            :UltimaData = "UltimaData"
                                            :AllineamentoSelezionato="Elemento.ELEMENTO == ModuliGrafici.TemperaturaO ? ObjAllineamento.DataAllineamento : null" 
                                            :GraficiChange="GraficiChange" 
                                            :GraficiAdatta="GraficiAdatta" 
                                            :Zoom="1" 
                                            :TipoGrafico="GetTipoGrafico(Elemento.ELEMENTO)"
                                            :LarghezzaGrafico="GetLarghezzaGrafico(Elemento.ELEMENTO, Banda.ALTEZZA_BANDA * 0.88, Elemento.LARGHEZZA * 0.99)" 
                                            :AltezzaGrafico="GetAltezzaGrafico(Elemento.ELEMENTO, Banda.ALTEZZA_BANDA * 0.88, Elemento.LARGHEZZA)" 
                                            :ObjModificaAssi="ObjModificaAssi" 
                                            :Differenziale="false" 
                                            :LabelCumulativo="LabelCumulativo"
                                            :AddDatiPDF="AddDatiPDF"
                                            :ParentData="{Refs: $refs, Indice: 'Grafico_' + IndiceBanda + '_' + IndiceGrafico}"
                                            @CambiaTipoCumulazione="CambiaTipoCumulazione"
                                            @ApriPopupPDF="ApriPopupPDF" 
                                            :ObjEsportazione="Elemento.ELEMENTO == ModuliGrafici.TemperaturaO ? ObjEsportazione : null" 
                                            :ModificaGraficiAll="ModificaGraficiAll"
                                            :AllineaTemperatura="(Elemento.ELEMENTO == ModuliGrafici.ProfiloLongAll || Elemento.ELEMENTO == ModuliGrafici.DeformazioneOAll) ? 
                                                                 ObjAllineamento.AllineaTemperatura : null">
                </VUEComponenteGraficoGenerico>
            </div>
            
            <div v-if="Elemento.ELEMENTO == ModuliGrafici.CampRilevati" style="width: 100%;" :style="{'--colore-spaziatore': ColoreSpaziatoreModuli, '--altezza-titolo': '20px'}" :class="['bordo-separatore', {'bordo-spaziatore-moduli': (IndiceBanda == 0 && IndiceGrafico != 0)}]">
              <div style="width:100%; display: flex; justify-content: center;align-items: center;height:20px" :style="{'background-color': Banda.COLORE_BANDA}">
                <label style="font-weight: bold; color: white;margin: 0px;"> {{ Elemento.NOME_ELEMENTO }} </label>
              </div>
              <VUEComponenteGraficoCampioniRilevati v-if="Elemento.ObjGrafico"
                                            :WidthGrafico="GetLarghezzaGrafico(Elemento.ELEMENTO, Banda.ALTEZZA_BANDA * 0.84, Elemento.LARGHEZZA)"
                                            :HeightGrafico="GetAltezzaGrafico(Elemento.ELEMENTO, Banda.ALTEZZA_BANDA * 0.84, Elemento.LARGHEZZA)"
                                            :Modulo="Elemento.MODULI[0].Dati[0]"
                                            :ObjDal="Elemento.ObjDal"
                                            :ObjAl="ObjAl"
                                            :TipoGrafico="GetTipoGrafico(Elemento.ELEMENTO)"
                                            :PropsGrafico="Elemento.ObjGrafico"
                                            :Repaint="Repaint"
                                            :GraficiChange="GraficiChange"
                                            :PressAdatta="PressAdatta"
                                            :ColorePitch="Elemento.COLORE_PITCH"
                                            :ColoreRoll="Elemento.COLORE_ROLL"
                                            :ColoreTemp="Elemento.COLORE_TEMP"
                                            :ColorePiezo="Elemento.COLORE_PIEZO"
                                            :ColoreDef="Elemento.COLORE_EST"
                                            :IsPiezometro="Elemento.MOSTRA_PIEZO && Elemento.MODULI[0].Piezometro"
                                            :IsEstensimetro="Elemento.MOSTRA_EST && Elemento.MODULI[0].Estensimetro"
                                            :ShowHintRoll="Elemento.ObjGrafico.Roll"
                                            :ShowHintPitch="Elemento.ObjGrafico.Pitch"
                                            :ShowHintTemp="Elemento.ObjGrafico.Temp"
                                            :ShowRoll="Elemento.MOSTRA_ROLL"
                                            :ShowPitch="Elemento.MOSTRA_PITCH"
                                            :ShowTemp="Elemento.MOSTRA_TEMP"
                                            :VisualizzaMarkup="Elemento.MOSTRA_MARKUP"
                                            :CatenaInfo="this.Catena" 
                                            :AddDatiPDF="AddDatiPDF"
                                            :OggettoDati="ObjDati"
                                            :DescrizioneSitoPDF="this.Catena.Descrizione"
                                            :IsGraficoModulabile="true"/>
            </div>
            
            <div v-if="Elemento.ELEMENTO == ModuliGrafici.Spostamenti ||
                       Elemento.ELEMENTO == ModuliGrafici.Velocità ||
                       Elemento.ELEMENTO == ModuliGrafici.Accelerazione" style="width: 100%;" :style="{'--colore-spaziatore': ColoreSpaziatoreModuli, '--altezza-titolo': '20px'}" :class="['bordo-separatore', {'bordo-spaziatore-moduli': (IndiceBanda == 0 && IndiceGrafico != 0)}]">
              <div style="width:100%; display: flex; justify-content: center;align-items: center;height:20px" :style="{'background-color': Banda.COLORE_BANDA}">
                <label style="font-weight: bold; color: white;margin: 0px;"> {{ Elemento.NOME_ELEMENTO }} </label>
              </div>
              <VUEComponenteGraficoSpostamenti v-if="Elemento.ObjGrafico" 
                                               :WidthGrafico="GetLarghezzaGrafico(Elemento.ELEMENTO, Banda.ALTEZZA_BANDA * 0.84, Elemento.LARGHEZZA)"
                                               :HeightGrafico="GetAltezzaGrafico(Elemento.ELEMENTO, Banda.ALTEZZA_BANDA * 0.84, Elemento.LARGHEZZA)"
                                               :Modulo="Elemento.MODULI[0].Dati[0]"
                                               :ObjDal="Elemento.ObjDal"
                                               :ObjAl="ObjAl"
                                               :TipoGrafico="GetTipoGrafico(Elemento.ELEMENTO, Elemento.IS_GIORNALIERO)"
                                               :PropsGrafico="Elemento.ObjGrafico"
                                               :Repaint="Repaint"
                                               :GraficiChange="GraficiChange"
                                               :PressAdatta="PressAdatta"
                                               :IsVelocita="Elemento.ELEMENTO == ModuliGrafici.Velocità && !Elemento.IS_GIORNALIERO"
                                               :IsAccelerazione="Elemento.ELEMENTO == ModuliGrafici.Accelerazione && !Elemento.IS_GIORNALIERO"
                                               :IsVelocitaGiornaliera="Elemento.ELEMENTO == ModuliGrafici.Velocità && Elemento.IS_GIORNALIERO"
                                               :IsAccelerazioneGiornaliera="Elemento.ELEMENTO == ModuliGrafici.Accelerazione && Elemento.IS_GIORNALIERO"
                                               :AbilitaDisegnaVelocita="false"
                                               :ListaFaldeChange="ListaFaldeChange"
                                               :ListaFalde="ListaFaldeSelezionate"
                                               :ListaSegmenti="ListaSegmenti"
                                               :OggettoDati="ObjDati"
                                               :CatenaInfo="this.Catena" 
                                               :AddDatiPDF="AddDatiPDF"
                                               :ColoreModulo="Elemento.MOSTRA_TOTALE ? Elemento.COLORE_TOTALE : Elemento.MODULI[0].Colore"
                                               :OggettoTotaleSpostamento="Elemento.MOSTRA_TOTALE ? Elemento.ObjTotale : null"
                                               :DescrizioneSitoPDF="this.Catena.Descrizione"
                                               :ListaModuli="Elemento.MODULI"
                                               :IsGraficoModulabile="true"/>
            </div>
            
            <div v-if="Elemento.ELEMENTO == ModuliGrafici.Assorbimento ||
                       Elemento.ELEMENTO == ModuliGrafici.TensAlim" style="width: 100%;" :style="{'--colore-spaziatore': ColoreSpaziatoreModuli, '--altezza-titolo': '20px'}" :class="['bordo-separatore', {'bordo-spaziatore-moduli': (IndiceBanda == 0 && IndiceGrafico != 0)}]">
              <div style="width:100%; display: flex; justify-content: center;align-items: center;height:20px" :style="{'background-color': Banda.COLORE_BANDA}">
                <label style="font-weight: bold; color: white;margin: 0px;"> {{ Elemento.NOME_ELEMENTO }} </label>
              </div>
              <VUEComponenteGraficoTensioneAssorbimento v-if="Elemento.ObjGrafico" 
                                                        :WidthGrafico="GetLarghezzaGrafico(Elemento.ELEMENTO, Banda.ALTEZZA_BANDA * 0.84, Elemento.LARGHEZZA)" 
                                                        :HeightGrafico="GetAltezzaGrafico(Elemento.ELEMENTO, Banda.ALTEZZA_BANDA * 0.84, Elemento.LARGHEZZA)"
                                                        :ListaModuli="Elemento.MODULI[0].Dati"
                                                        :Modulo="Elemento.MODULI[0].Dati[0]"
                                                        :ObjDal="Elemento.ObjDal"
                                                        :ObjAl="ObjAl"
                                                        :TipoGrafico="GetTipoGrafico(Elemento.ELEMENTO)"
                                                        :PropsGrafico="Elemento.ObjGrafico"
                                                        :Repaint="Repaint"
                                                        :OggettoDati="ObjDati"
                                                        :CatenaInfo="this.Catena" 
                                                        :AddDatiPDF="AddDatiPDF"
                                                        :DescrizioneSitoPDF="this.Catena.Descrizione"
                                                        :IsGraficoModulabile="true"
                                                        :GraficiChange="GraficiChange"/>
            </div>
            
            <div v-if="Elemento.ELEMENTO == ModuliGrafici.EvAccAmpiezza ||
                       Elemento.ELEMENTO == ModuliGrafici.EvAccFrequenza" style="width: 100%;" :style="{'--colore-spaziatore': ColoreSpaziatoreModuli, '--altezza-titolo': '20px'}" :class="['bordo-separatore', {'bordo-spaziatore-moduli': (IndiceBanda == 0 && IndiceGrafico != 0)}]">
              <div style="width:100%; display: flex; justify-content: center;align-items: center;height:20px" :style="{'background-color': Banda.COLORE_BANDA}">
                <label style="font-weight: bold; color: white;margin: 0px;"> {{ Elemento.NOME_ELEMENTO }} </label>
              </div>
              <VUEComponenteGraficoAccelerometri  v-if="Elemento.ObjGrafico"
                                                  :WidthGrafico="GetLarghezzaGrafico(Elemento.ELEMENTO, Banda.ALTEZZA_BANDA * 0.84, Elemento.LARGHEZZA)" 
                                                  :HeightGrafico="GetAltezzaGrafico(Elemento.ELEMENTO, Banda.ALTEZZA_BANDA * 0.84, Elemento.LARGHEZZA)"
                                                  :Sensore="Elemento.MODULI[0].Dati[0]"
                                                  :ObjDal="Elemento.ObjDal"
                                                  :ObjAl="ObjAl"
                                                  :CatenaInfo="this.Catena" 
                                                  :AddDatiPDF="AddDatiPDF"
                                                  :TipoGrafico="GetTipoGrafico(Elemento.ELEMENTO)"
                                                  :PropsGrafico="Elemento.ObjGrafico"
                                                  :Repaint="Repaint"
                                                  :RepaintDeep="RepaintDeep"
                                                  :ColoreFreq="Elemento.MODULI[0].Colore"
                                                  :DescrizioneSitoPDF="this.Catena.Descrizione"
                                                  :OggettoDati="ObjDati"
                                                  :IsGraficoModulabile="true"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="PopupGraficiAbbinati && Mobile" style="width: 84%; margin-left: 8%">
      <div style="display: flex; justify-content: center">
        <h3>{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_TIT_GRAF_ABBINATI',this.LinguaUtente) }}</h3>
      </div>
      <div v-if="Mobile && PopupWarning" style="width: 100%; font-size:14px; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items: center; margin-top: 10px">
        <label style="color: red">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_DATA_PRESENTE',this.LinguaUtente) }}</label>
      </div>
      <div style="width: 100%; font-size:14px; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items: center; margin-top: 30px">
        <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between;">
          <div style="width: 350px; display: flex; flex-flow: row wrap; justify-content: space-between;">
            <p style="width: 100px; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_SCEGLI_DATA',this.LinguaUtente) }}</p>
            <input class="form-control" style="width:200px" type="date" step="1" v-model="ObjAbbinati.NuovaDataAbbinato">
          </div>        
          <div v-if="ObjAbbinati.ListaOre.length > 0" style="display: flex; flex-flow: row wrap; justify-content: space-between; align-items: center;" :style="Mobile ? {'width': '140px', 'margin-top' : '10px'} : {'width': '180px'}">
            <select class="form-control" style="float:left; width:70%;" v-model="ObjAbbinati.NuovoOrarioAbbinato">
              <option v-for="Ora in ObjAbbinati.ListaOre" :key="Ora" :value="Ora">{{Ora}}</option>
            </select>
            <i class="fa fa-plus" style="color: green" :title="this.GetTraduzioneLabel('Generic','TKN_AGGIUNGI',this.LinguaUtente)" @click="AggiungiDataAbbinato()"></i>
          </div>  
          <button type="button" class="btn btn-info" :style="Mobile ? {'margin-top' : '10px'} : {'width': '32%'}" style="font-weight:bold;" @click="TrovaCampioniPerData()">{{ this.GetTraduzioneLabel('Generic','TKN_CERCA_CAMP',this.LinguaUtente) }}</button>
        </div>    
      </div>
      <div v-if="ObjAbbinati.LsGraficiAbbinatiTmp.length > 0" style="margin-top: 10px; overflow-x: auto" :style="Mobile ? {'width': '100%'} : {'width': '80%', 'margin-left': '10%'}">
        <table cellpadding="0" cellspacing="0" width="100%" style="margin-top: 5px; margin-bottom: 5px; min-width: 400px; max-height: 200px; overflow-y: auto" class="table table-bordered sortable">
          <thead>
            <tr>
              <th width="30%">{{ this.GetTraduzioneLabel('Generic','TKN_DATA',this.LinguaUtente) }}</th>
              <th width="25%">{{ this.GetTraduzioneLabel('Generic','TKN_ORA',this.LinguaUtente) }}</th>
              <th width="20%">{{ this.GetTraduzioneLabel('Generic','TKN_COLORE',this.LinguaUtente) }}</th>
              <th width="5%"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="Grafico in ObjAbbinati.LsGraficiAbbinatiTmp" :key="Grafico">                        
              <td style="padding: 10px;">
                {{Grafico.PrettyData}}
              </td>
              <td style="padding: 10px;">
                {{Grafico.Ora}}
              </td>  
              <td style="padding: 10px;">
                <label style="width:100%; margin: 0px;" :style="{'background-color' : Grafico.Colore}">&nbsp;</label>
              </td>  
              <td style="padding: 10px;">                
                <i class="fa fa-trash-o text-danger ZMIconButton" style="cursor:pointer" @click="RimuoviElemento(Grafico)"></i>
              </td>                                      
            </tr>
          </tbody>
        </table>
      </div>
      <div style="display: flex; align-items: center; justify-content: center; height: 100px" v-else>
        <label>{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_NO_GRAFICO',this.LinguaUtente) }}</label>  
      </div>
      <div style="margin-top: 30px;">
        <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;" @click="AnnullaModificaAbbinati()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
        <button type="button" class="btn btn-success" style="float:right;font-weight:bold;" @click="ConfermaAbbinati()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
      </div>
    </div>
    <div v-show="PopupSelezioneAllineamento && Mobile" style="width: 100%">
      <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: center; align-items: center; margin-top: 30px">
        <p style="float:left; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_SCEGLI_DATA',this.LinguaUtente) }}</p>
      </div>
      <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: center; align-items: center; margin-top: 30px">
        <input class="form-control" style="float:left;width:60%" type="datetime-local" step="1" v-model="ObjAllineamento.NuovaDataAllineamento">
      </div>
      <div style="margin-top : 20px; display: flex; align-content: center; justify-content: center; align-items: center">
        <button type="button" class="btn btn-danger" style="margin-right:10px;font-weight:bold;" @click="AnnullaModificaAllineamento()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
        <button v-if="ObjAllineamento.NuovaDataAllineamento != ''" type="button" class="btn btn-success" style="font-weight:bold;" @click="ConfermaModificaAllineamento()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
      </div>
    </div>
    <div v-if="ObjFiltroAzimuth.Popup && Mobile" style="width: 100%">
      <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: center; align-items: center; margin-top: 30px">
        <p style="width: 30%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_VAL_FILTRO',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:40%" type="number" step="1" v-model="ObjFiltroAzimuth.Filtro">
      </div>
      <div style="display: flex; flex-flow: row wrap; margin-top: 20px; justify-content: center">
        <button type="button" class="btn btn-danger" style="margin-right:10px;font-weight:bold;" @click="AnnullaModificaFiltroAzimuth()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
        <button v-if="ObjFiltroAzimuth.Filtro != null" type="button" class="btn btn-success" style="font-weight:bold;" @click="ConfermaModificaFiltroAzimuth()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>        
      </div>
    </div>
    <div v-if="ObjModificaAssi.PopupAperto && Mobile" style="display: flex; flex-flow: column nowrap;">
      <div style="display: flex; flex-flow: column wrap; width: 90%; margin-left: 5%">
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 10px; margin-top: 10px">
          <h4 style="margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_X',this.LinguaUtente) }}</h4>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:45%; text-align: right;" type="number" step="1" v-model="ObjModificaAssi.X.Min">
          <p style="width: 15%; margin: 0px">{{ ObjModificaAssi.X.LabelUdm }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:45%; text-align: right;" type="number" step="1" v-model="ObjModificaAssi.X.Max">
          <p style="width: 15%; margin: 0px">{{ ObjModificaAssi.X.LabelUdm }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:45%; text-align: right;" type="number" step="1" v-model="ObjModificaAssi.X.Udm">
          <p style="width: 15%; margin: 0px">{{ ObjModificaAssi.X.LabelUdm }}</p>
        </div>
      </div>
      <div style="display: flex; flex-flow: column wrap; width: 90%; margin-left: 5%">
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 10px; margin-top: 10px">
          <h4 style="margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_Y',this.LinguaUtente) }}</h4>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:45%; text-align: right;" type="number" step="1" v-model="ObjModificaAssi.Y.Min">
          <p style="width: 15%; margin: 0px">{{ ObjModificaAssi.Y.LabelUdm }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:45%; text-align: right;" type="number" step="1" v-model="ObjModificaAssi.Y.Max">
          <p style="width: 15%; margin: 0px">{{ ObjModificaAssi.Y.LabelUdm }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:45%; text-align: right;" type="number" step="1" v-model="ObjModificaAssi.Y.Udm">
          <p style="width: 15%; margin: 0px">{{ ObjModificaAssi.Y.LabelUdm }}</p>
        </div>
      </div>
      <div style="display: flex; flex-flow: row wrap; margin-top: 20px; margin-left: 5%; width: 90%">
        <button type="button" class="btn btn-danger" style="margin-right:10px;font-weight:bold;" @click="AnnullaModificaAssi()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
        <button type="button" class="btn btn-success" style="font-weight:bold;" @click="ConfermaModificaAssi()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
      </div>
    </div>
    <div v-if="ObjIngrandimento.Ingrandito">
      <div style="display: flex; flex-flow: row wrap; margin: 10px">
        <button type="button" class="btn btn-info" style="font-weight:bold;" @click="TornaAllaVisualizzazione()">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_TORNA_VIS',this.LinguaUtente) }}</button>        
      </div>
      <div style="display: flex; flex-flow: row wrap">      
        <div style="display: flex; flex-flow: column wrap; width: 50%">
          <VUEComponenteGraficoGenerico v-if="MostraGrafici" @ApriDettaglio="null" :CatenaInfo="Catena" :StatoAbbinati="StatoAbbinati" :StatoAbbinatiPiezometri="StatoAbbinatiPiezometri" :AltezzaPopup="AltezzaSchermo" :OnDashboard="false" :Contatore="0" :MostraGrafici="true"
                                                                                :AllineamentoSelezionato="null" :GraficiChange="GraficiChange" :GraficiAdatta="GraficiAdatta" :Zoom="1" :TipoGrafico="ObjIngrandimento.TipoGrafico"
                                                                                :LarghezzaGrafico="ObjIngrandimento.Larghezza" :AltezzaGrafico="ObjIngrandimento.Altezza" :ObjModificaAssi="ObjModificaAssi" :Differenziale="ObjDifferenziale.Differenziale"
                                                                                :Ingrandito="true" :AllineaTemperatura="ObjAllineamento.AllineaTemperatura" :DirezioneGraficoTotaleIngrandito="DirezioneGraficoTotaleIngrandito" :UltimaData ="UltimaData" 
                                                                                :FiltroAzimuthIngrandito="ObjIngrandimento.FiltroAzimuth" :AssiModificatiIngranditi="ObjIngrandimento.AssiModificatiIngranditi">
          </VUEComponenteGraficoGenerico>      
        </div>

        <div style="display: flex; flex-flow: column; width: 49%; overflow-y: auto; margin-left: 1%" :style="{'max-height' : ObjIngrandimento.Altezza - 66 + 'px'}">
          <!-- <table cellpadding="0" cellspacing="0" width="100%" style="margin-top: 5px; margin-bottom: 5px; min-width: 400px; overflow-y: auto" class="table table-bordered sortable">
            <thead style="position: sticky; top: 0; left: 0; background-color: white;">
              
              <tr>
                <th v-for="Campo in ObjIngrandimento.Campi" :key="Campo" :width="Campo.Dimensione">{{ Campo.Campo }}</th>
              </tr>
             
            </thead>
            <tbody>
              
              <tr v-for="Dato in ObjIngrandimento.Dati" :key="Dato">        
                <td v-for="Voce in Dato.Voci" :key="Voce" :colspan="Dato.Separatore ? 99 : 1" style="text-align: right; vertical-align: middle;"
                  :style="Dato.Separatore ? {'background-color' : Arancione, 'font-weight' : 'normal', 'color' : 'black', 'height' : '25px'} : {}">
                  {{ Dato.Separatore ? (this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_DATI_RIF_AL',this.LinguaUtente) + ': ' + Voce) : Voce}}
                </td>                                   
              </tr>

            </tbody>
          </table> -->

          <div style="width:98%; margin-top: 40px; margin-bottom: 5px; min-width: 400px; overflow-y: auto">
            <div v-for="Dati in ObjIngrandimentiFiltrati" :key="Dati">

              <div v-for="Titolo in Dati.Dati" :key="Titolo" style="margin-top: 0; margin-bottom: 2px;">
                <div v-if="Titolo.Separatore" style="text-align: left; vertical-align: middle;">
                  <span v-if="(ObjIngrandimento.TipoGrafico == TipiGrafici.Piezometro) && Titolo.Separatore && (Catena.DatiCatena.TIPO_GRAFICO_PIEZOMETRO == 'P')" >
                    &nbsp; 
                  </span>
                  <input v-if="(ObjIngrandimento.TipoGrafico == TipiGrafici.Piezometro) && Titolo.Separatore && (Catena.DatiCatena.TIPO_GRAFICO_PIEZOMETRO == 'P')" v-model="Dati.Visibile" class="form-control" style="height: 15px; width: 15px; text-align: center; display: unset;" type="checkbox" @change="VisualizzaPiezo(Titolo, Dati)">
                  &nbsp; {{ (this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_DATI_RIF_AL',this.LinguaUtente) + ': ' + Titolo.Voci[0])}} &nbsp;
                </div>
              </div>

              <table cellpadding="0" cellspacing="0" class="table table-bordered sortable" style="margin-bottom: 0">
                <tbody>
                  <tr>
                    <td v-for="Campo in ObjIngrandimento.Campi" :key="Campo" style="text-align: center; font-weight: normal;" :style="{'width': (Campo.Dimensione ? Campo.Dimensione : '')}">{{ Campo.Campo }}</td>
                  </tr>
                  <tr v-for="SingoloDato in Dati.Dati.slice().reverse()" :key="SingoloDato">        
                    <td v-for="Voce in SingoloDato.Voci" :key="Voce" style="text-align: center; vertical-align: middle;">
                      {{!SingoloDato.Separatore ? Voce : null}}
                    </td>                                   
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>

      </div>
    </div>
    <div style="position:fixed; bottom:0; left:0; width:100%; display:flex; align-items:center; z-index: 999999;">
      <div style="flex-basis:75%; text-align:center;">
       <VUELegalFooter />
      </div>
      <div style="flex-basis:25%; text-align:right; position:relative; margin-right:30px; margin-bottom:7px">
        <img src="@/assets/images/LogoCSG.png"
            alt="Logo"
            @click="PopupDatiAssistenza = true"
            style="height:25px; width:auto; cursor:pointer;" />
      </div>
    </div>
  </div>
</template>

<script>

import XLSX from 'xlsx-js-style/dist/xlsx.min.js'
import {
         SystemInformation, TTools, TIPI_MODULI,
         COLORI_PANTONE, COLORE_GRAFICI_VERTICALI, 
         TIPI_GRAFICI, COLORI_DEFAULT_GRAFICI, GIORNI_CARICA_GV,
         TInfoGraficiStorici, LOCALSTORAGE, TIPOLOGIA_GRAFICI_STORICI,
         TIPO_ELEMENTO_PDF, PRETTY_GRANDEZZE_ALLARME, TIPI_GRANDEZZE_ALLARME,
         TIPOLOGIA_ALLARME_TO_UI, COLORE_SPAZIATORE_MODULI
       }
       from '../../SystemInformation.js'
import { TZGenericFunct } from '@/utils/ZGenericFunct.js'
import { TSchedaGenerica } from '@/utils/ZSchedaGenerica.js';
import VUEModal from '@/utils/VUEModal.vue';
import VUEPopupWarning from '@/components/Popups/VUEPopupWarning.vue';
import VUEColorPicker from '@/utils/VUEColorPicker.vue' 
import VUEComponenteGraficoGenerico from '../../components/Slots/VUEComponenteGraficoGenerico.vue';
import VUEPopupDatiStorici from '../../components/Popups/VUEPopupDatiStorici.vue';
import VUEPopupStazioneMeteo from '../../components/Popups/VUEPopupStazioneMeteo.vue';
import VUEPopupModulazioneGrafici from '../../components/Popups/VUEPopupModulazioneGrafici.vue';
import VUEPopupTensioneAssorbimento from '../../components/Popups/VUEPopupTensioneAssorbimento.vue';
import VUEModalCaricamentoDati, { TOggettoModalCaricamentoDati } from '@/utils/VUEModalCaricamentoDati.vue'
import { TZDateFunct } from '@/utils/ZDateFunct.js';
import { TZMathFunct } from '@/utils/ZMathFunct.js';
import { TZStringConvFunct } from '@/utils/ZStringConvFunct';
import { saveAs } from 'file-saver';
import VUEComponenteGraficoCampioniRilevati from '../../components/Slots/VUEComponenteGraficoCampioniRilevati.vue'
import VUEComponenteGraficoTensioneAssorbimento from '../../components/Slots/VUEComponenteGraficoTensioneAssorbimento.vue'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import VUEComponenteGraficoSpostamenti from '../../components/Slots/VUEComponenteGraficoSpostamenti.vue'
import MixInsDoubleClickHandler from './MixInsDoubleClickHandler.js';
import MixInsGraficiStorici from './MixInsGraficiStorici.js';
import VUEComponenteGraficoGV, { TMontaggioGV } from '../../components/Slots/VUEComponenteGraficoGV.vue';
import VUEComponenteGraficoAccelerometri from '../../components/Slots/VUEComponenteGraficoAccelerometri.vue'
import VUEPopupEsportaXLSXStorici from '@/components/Popups/VUEPopupEsportaXLSXStorici.vue';
import VUELegalFooter from '@/components/FrameComponentsMultiPurpose/VUELegalFooter.vue';
import VUEPopupDatiAssistenza from '@/components/Popups/VUEPopupDatiAssistenza.vue';
import { TGraficoAttuale, TGraficoFittizio } from '../../GraficoAttuale.js'

export default
{
    emits: ['onCatenaCambiata', 'onListaCateneCaricata'],
    components: 
    {
      VUEModal,
      VUEComponenteGraficoGenerico,
      VUEPopupWarning,
      VUEColorPicker,
      VUEPopupDatiStorici,
      VUEPopupEsportaXLSXStorici,
      VUEModalCaricamentoDati,
      VUEPopupTensioneAssorbimento,
      VUEPopupStazioneMeteo,
      VUEPopupModulazioneGrafici,
      VUEComponenteGraficoCampioniRilevati,
      VUEComponenteGraficoGV,
      VUEComponenteGraficoSpostamenti,
      VUEComponenteGraficoTensioneAssorbimento,
      VUEComponenteGraficoAccelerometri,
      VUELegalFooter,
      VUEPopupDatiAssistenza
    },
    props: ["AltezzaPagina", "ObjPresenzaMenu"],
    mixins: [MixInsDoubleClickHandler, MixInsGestioneTraduzioni, MixInsGraficiStorici],
    data() 
    {
      return  {
                Mobile                       : TZGenericFunct.IsClientMobile(),
                CaricamentoDatiCatena        : false,
                DatiNonCaricati              : false,
                AltezzaSchermo               : 0,
                Marrone                      : COLORI_PANTONE.Marrone,
                Arancione                    : COLORI_PANTONE.Arancione,
                GiorniDaCaricare             : GIORNI_CARICA_GV,
                Catena                       : {},
                CatenaStorici                : {},
                ObjDal                       : {},
                ObjAl                        : {},
                GraficiChange                : 0,
                GraficiAdatta                : 0,
                IndexCalcolatiSpostamenti    : 0,
                SommaSpostamenti             : 0,
                ListaFaldeChange             : 0,
                PressAdatta                  : 0,
                Stacking                     : 10,
                Repaint                      : 0,
                RepaintDeep                  : 0,
                VettoreStartValueSpost       : [],
                VettoreStartValueVelGG       : [],
                VettoreStartValueVelH        : [],
                VettoreStartValueAccGG       : [],
                VettoreStartValueAccH        : [],
                ListaSegmenti                : [],
                ListaFaldeSelezionate        : [],
                VettoreModuli                : [],
                ModuliMostrati               : [],
                VettorePorzioniDiDate        : [], 
                ObjGrafico                   : {
                                                 Pitch  : true,
                                                 Roll   : true,
                                                 Temp   : true,
                                                 AxisY  : {
                                                             Min : 0,
                                                             Max : 0,
                                                             Udm : 0,
                                                             Modificato : false,
                                                         },
                                                 AxisX  : {
                                                             TipoUdmX : 0,
                                                             Max : 0,
                                                             UdmX : 0,
                                                             Modificato : false,
                                                         },
                                                 AxisYTemp : {
                                                               Min        : 0.0,
                                                               Max        : 30.0,
                                                               Ampiezza   : 5.00,
                                                               Modificato : false
                                                             },
                                                 AxisYDef : {
                                                               Min        : 0.0,
                                                               Max        : 30.0,
                                                               Ampiezza   : 5.00,
                                                               Modificato : false
                                                             },
                                                 AxisYPress : {
                                                               Min        : 0.0,
                                                               Max        : 30.0,
                                                               Ampiezza   : 5.00,
                                                               Modificato : false
                                                             }
                                               },
                ObjAbbinati                  : {
                                                 LsGraficiAbbinati    : [],
                                                 LsGraficiAbbinatiTmp : [],
                                                 NuovaDataAbbinato    : this.GetDataOdierna(),
                                                 NuovoOrarioAbbinato  : null,
                                                 DatiTrovati          : true,
                                                 ListaOre             : []
                                               },
                MostraUltimo                 : true,
                ObjAllineamento              : {
                                                 DataAllineamento       : null,
                                                 OrarioAllineamento     : null,
                                                 ListaOre               : [],
                                                 DataOraAllineamento    : null, 
                                                 PrettyDataAllineamento : '',
                                                 NuovaDataAllineamento  : '',
                                                 AllineaTemperatura     : false,
                                                 Trovato                : true
                                               },
                OggettoImmaginiReport        : {
                                                 Immagine1 : '',
                                                 Immagine2  : '',
                                               },
                ObjXlsxReport                : {
                                                 ReportXlsx : '',
                                                 ValutatoDa : '',
                                                 Testo      : '',
                                               },
                PopupEsportaExcel            : false,
                PopupSelezioneAllineamento   : false,
                PopupAllarmi                 : false,
                PopupGraficiAbbinati         : false,
                CaricamentoDatiModuli        : false,
                PopupSelezioneNuovaData      : false,
                OperazioneAnnullata          : false,
                IsEstensimetro               : false,
                IsVelocita                   : false,
                IsVelocitaGiornaliera        : false,
                IsAccelerazione              : false,
                IsAccelerazioneGiornaliera   : false,
                IsPiezometro                 : false,
                CatenaInCaricamento          : false,
                ModuliConsideratiTotaleSpost : null,
                ModuliConsideratiTotaleVelGG : null,
                ModuliConsideratiTotaleVelH  : null,
                ModuliConsideratiTotaleAccGG : null,
                ModuliConsideratiTotaleAccH  : null,
                ImmagineIngrandita           : null,
                ChiaveCatena                 : -1,
                ChiaveSito                   : -1,
                ListaCatene                  : [],
                Falde                        : null,
                ObjDati                      : null,
                MostraGrafici                : false,   
                UltimaData                   : null,
                ColoreGrafico                : COLORE_GRAFICI_VERTICALI,
                TipiGrafici                  : TIPI_GRAFICI,
                TipiStorici                  : TIPOLOGIA_GRAFICI_STORICI,
                PopupWarning                 : false,
                PopupAbbinatiPerMobile       : false,
                TestoWarning                 : false,
                PopupColorPicker             : false,
                InDownloadDatiAcquisiti      : false,
                TipoGrafico                  : -1,
                ColorPickerAbbinati          : false,
                ObjColore                    : {Colore: COLORE_GRAFICI_VERTICALI.Grafico, ColoreScelto: COLORE_GRAFICI_VERTICALI.Grafico},
                ObjColoreAbbinati            : {Colore: COLORE_GRAFICI_VERTICALI.Grafico, ColoreScelto: COLORE_GRAFICI_VERTICALI.Grafico},
                ObjDimensioni                : {},
                ObjModificaAssi              : {
                                                 PopupAperto : false,
                                                 TipoGrafico : -1,
                                                 ModificaEffettuata : false,
                                                 X : {Min : 0, Max : 0, Udm : 0, LabelUdm : ''},
                                                 Y : {Min : 0, Max : 0, Udm : 0, LabelUdm : ''}
                                               },
                ObjIngrandimento             : {
                                                 Ingrandito        : false,
                                                 TipoGrafico       : -1,
                                                 ProprietaGrafiche : null,
                                                 Campi             : []
                                               },
                ObjFiltroAzimuth             : {
                                                 Popup  : false,
                                                 Filtro : 0,
                                                 ObjGrafico : null 
                                               },
                ObjDatiPDFGrafico            : {
                                                 Popup               : false,
                                                 StampaCumDif        : false,
                                                 PrimaPagina         : false,
                                                 ShowTabelleDx       : true,
                                                 InfoCatena          : null,
                                                 ObjParametri        : null,
                                                 ObjParametriCumDiff : null,
                                                 TipoGrafico         : null,
                                                 IdReport            : '',
                                                 Testo               : '',
                                                 NomeOperatore       : ''
                                               },
                ObjAllDatiPDFGrafico         : {
                                                 Popup               : false,
                                                 StampaCumDif        : false,
                                                 PrimaPagina         : false,
                                                 ShowTabelleDx       : true,
                                                 InfoCatena          : null,
                                                 ObjParametri        : null,
                                                 ObjParametriCumDiff : null,
                                                 TipoGrafico         : null,
                                                 IdReport            : '',
                                                 Testo               : '',
                                                 NomeOperatore       : ''
                                               },
                ObjDirezioneGrafico          : {
                                                 Popup  : false,
                                                 DirezioneGraficoTotale : null,
                                                 ObjGrafico : null 
                                               },
                ObjDifferenziale             : {
                                                 Differenziale  : false
                                               },
                ObjTotaleSpostamento         : null,
                ObjTotaleVelocitaGG          : null,
                ObjTotaleVelocitaH           : null,
                ObjTotaleAccelerazioneGG     : null,
                ObjTotaleAccelerazioneH      : null,
                MaxMinGraph                  : 0,
                AddDatiPDF                   : 0,
                // AltezzaGrafici               : 300,
                LarghezzaSchermo             : 0,
                PrettyUltimaData             : '',
                ObjEsportazione              : {},
                MenuTrigger                  : SystemInformation.MenuTrigger,
                PopupStorici                 : false,
                PopupTensioneAssorbimento    : false,
                PopupStazioneMeteo           : false,
                OggettoModalCaricamentoDati  : new TOggettoModalCaricamentoDati(),
                PopupModulazioneGrafici      : false,
                JSONGraficiModulari          : {},
                ModificaGraficiAll           : 0,
                GraficoSelezionato           : null,
                ObjMedia                     : {Data : '', Ora: '00:00', Intervallo: 24},
                ObjXLSXStorico               : {
                                                  Dal                 : {Data : '', Ora : ''},
                                                  Al                  : {Data : '', Ora : ''},
                                                  Moduli              : [],
                                                  OrientazioneAsse    : 0,
                                                  SoloTotale          : false,
                                                  ObjAllineamentoInc  : {Data : '', Ora : ''},
                                                  ObjAllineamentoDef  : {Data : '', Ora : ''},
                                                  ObjAllineamentoTemp : {Data : '', Ora : ''},
                                                  TuttiIDati          : true,
                                                  IntervalloMedia     : 24,
                                                  IsEstensimetri      : false,
                                                  IsPiezometri        : false,
                                                  MediaOraria         : true,
                                                  IsCampioniRilevati  : false
                                               },
                PopupXLSXStorici             : false,
                MediaAttiva                  : false,
                PopupMedia                   : false,
                LabelCumulativo              : '',
                StatoAbbinati                : [],
                StatoAbbinatiPiezometri      : [],
                RicercaInCorso               : false,
                ColoreSpaziatoreModuli       : COLORE_SPAZIATORE_MODULI,
                IntervalIDRefreshDati        : false,
                FlagAbilitaRefreshDati       : false,
                LinguaUtente                 : SystemInformation.UserInformation.Lingua,
                ObjPosizioneGrafici          : {},
                ObjListaModelli              : {},
                ModuliGrafici                : TIPI_MODULI,
                OggettoDefaultMontaggioGV    : new TMontaggioGV(),
                ObjModuliConsideratiCampioniRilevati : {},         
                ObjModuliConsideratiStorici          : {},         
                ObjModuliConsideratiAssorbTens       : {},  
                PopupDatiAssistenza                  : false,
                DirezioneGraficoTotaleIngrandito     : null,
                ObjSommario                          : null
            };        
    },
    methods: 
    {
      GrandezzaAllarmeToTipologia(Grandezza)
      {
        return PRETTY_GRANDEZZE_ALLARME[Grandezza]
      },

      ShowCumulativoDifferenziale()
      {
        let GraficiDaEscludere  = [
                                    this.TipiGrafici.Piezometro,
                                    this.TipiGrafici.Temperatura, 
                                    this.TipiGrafici.Deformazione,
                                    this.TipiGrafici.TemperaturaO,
                                    this.TipiGrafici.ProfiloLong,
                                    this.TipiGrafici.DeformazioneO,
                                    this.TipiGrafici.ProfiloLongAll,
                                    this.TipiGrafici.DeformazioneOAll
                                  ]
        return !GraficiDaEscludere.includes(this.ObjDatiPDFGrafico.TipoGrafico)
      },

      VisualizzaPiezo(Titolo, Dati)
      {
        let Data = Titolo.Voci[0]

        let [data, ora] = Data.split(" ")
        let [anno, mese, giorno] = data.split('-')

        Data = `${giorno}-${mese}-${anno} ${ora}`;

        let Index = this.StatoAbbinatiPiezometri.findIndex(Elemento => Elemento.Data === Data);

        if(Index != -1)
        {
          this.StatoAbbinatiPiezometri[Index].Visibile = Dati.Visibile
        }

        else
        {
          this.StatoAbbinatiPiezometri.push({Data: Data, Visibile: Dati.Visibile})
        }

        this.GraficiChange++
      },

      OnChangeNuovaDataAbbinato()
      {
        this.ObjAbbinati.ListaOre = [];
      },

      OnChangeNuovaDataAllineamento()
      {
        this.ObjAllineamento.ListaOre = [];
      },

      AggiungiDicituraDifferenziale(Elemento)
      {
        let PossibiliDifferenziali =  [
                                        this.ModuliGrafici.Polare,
                                        this.ModuliGrafici.SpostEst,
                                        this.ModuliGrafici.SpostNord,
                                        this.ModuliGrafici.SpostTot,
                                        this.ModuliGrafici.SpostAzimuth,
                                        this.ModuliGrafici.MontaggioGV
                                      ]
        if (PossibiliDifferenziali.includes(Elemento))
        {
          if (this.ObjDifferenziale.Differenziale)
          {
            return " - diff."  
          }
          else return " - cum."          
        }        

        return ""
      },

      IngrandisciImmagine(Src) 
      {
        this.ImmagineIngrandita = Src
      },

      ChiudiIngrandimento() 
      {
        this.ImmagineIngrandita = null
      },

      CambiaVisibile(Grafico)
      {
        let Index = this.StatoAbbinatiPiezometri.findIndex(Elemento => Elemento.Data === Grafico.DataCompleta)
        if(Index != -1)
        {
          this.StatoAbbinatiPiezometri[Index].Visibile = !Grafico.Visibile   
        }        
        
        Grafico.Visibile = !Grafico.Visibile
        this.StatoAbbinati = []
        for (let  i = 0; i < this.ObjAbbinati.LsGraficiAbbinati.length; i++)
        {
          let SingleGraph = this.ObjAbbinati.LsGraficiAbbinati[i]
          this.StatoAbbinati.push({Data: SingleGraph.DataCompleta, Visibile: SingleGraph.Visibile})
        }

        this.GraficiChange++
      },

      GetDataOdierna() 
      {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      },

      ApriPopupMedia()
      {
        if (!this.MediaAttiva)
        {
          this.ObjMedia.Data = TZDateFunct.FormatDateTime('yyyy-mm-dd', new Date(this.UltimaData.Data))
          this.ObjMedia.Ora  = TZDateFunct.FormatDateTime('hh:nn', new Date(this.UltimaData.Data))
          this.ObjMedia.Intervallo = 24
          this.PopupMedia = true
        }
        else
        {
          this.MediaAttiva = false
          this.CaricaDatiCatena()
        }
      },

      ApriPopupXLSXStorici(IsCampioniRilevati)
      {
        this.ObjXLSXStorico.IsCampioniRilevati = IsCampioniRilevati
        this.ObjXLSXStorico.Moduli = []
        this.ObjXLSXStorico.Dal.Data = TZDateFunct.FormatDateTime('yyyy-mm-dd', TZDateFunct.ChangeDate(new Date(), 'day', -7))
        this.ObjXLSXStorico.Dal.Ora  = 0
        this.ObjXLSXStorico.Al.Data = TZDateFunct.FormatDateTime('yyyy-mm-dd', new Date())
        this.ObjXLSXStorico.Al.Ora  = 23
        
        for(let i = 0; i < this.Catena.Moduli.length; i++)
        {
          let OggettoModulo          = {}
          OggettoModulo.Id           = this.Catena.Moduli[i].MODULO
          OggettoModulo.Catena       = this.Catena.Moduli[i].CATENA
          OggettoModulo.Profondita   = (this.Catena.Moduli[i].PROFONDITA_CODA / 100).toFixed(2)
          OggettoModulo.Lunghezza    = (this.Catena.Moduli[i].LUNGHEZZA_SPEZZONE / 100).toFixed(2)
          OggettoModulo.Piezometro   = TSchedaGenerica.DisponiFromBoolean(this.Catena.Moduli[i].PIEZOMETRO)
          OggettoModulo.Estensimetro = TSchedaGenerica.DisponiFromBoolean(this.Catena.Moduli[i].ESTENSIMETRO)
          OggettoModulo.Selezionato  = false

          this.ObjXLSXStorico.Moduli.push(OggettoModulo)
        }

        this.PopupXLSXStorici = true
      },

      ChiudiPopupXLSXStorici()
      {
        this.PopupXLSXStorici = false
      },

      AnnullaPopupMedia()
      {
        this.PopupMedia = false
      },

      ConfermaPopupMedia()
      {
        this.MediaAttiva = true
        this.PopupMedia = false
        this.CaricamentoDatiCatena = true 
        this.CaricaDatiCatena(()=>
        {
          this.CaricamentoDatiCatena = false
        })
      },

      CambiaColoreGrafico(Grafico)
      {
        this.GraficoSelezionato = Grafico
        this.ObjColoreAbbinati.ColoreScelto = Grafico.Colore 
        this.ObjColoreAbbinati.Colore = Grafico.Colore
        this.ColorPickerAbbinati   = true        
      },

      CambiaColoreUltimo()
      {
        this.GraficoSelezionato = null
        this.ObjColore.Colore = this.UltimaData.Colore
        this.PopupColorPicker   = true          
      },

      CambiaScaleAll()
      {
        this.ObjModificaAssi.TipoGrafico = -1
        this.ObjModificaAssi.ModificaEffettuata = false
        this.ModificaGraficiAll++
      },

      PreparaDatiExcel(Valore, Decimali)
      {
        let Return = parseFloat(Valore).toFixed(Decimali) 
        if (isNaN(Return))
          Return = "-"
        return Return
      },

      ApriPopupEsportaExcel()
      {
        this.PopupEsportaExcel = true
      },

      ChiudiPopupEsportaExcel()
      {
        this.PopupEsportaExcel        = false
        this.ObjXlsxReport.ReportXlsx =  ''
        this.ObjXlsxReport.ValutatoDa =  ''
        this.ObjXlsxReport.Testo      =  ''
      },

      ConfermaPopupEsportaExcel()
      {
        this.EsportaExcel()
        this.ChiudiPopupEsportaExcel()
      },

      EsportaExcel()
      {
        const wb = XLSX.utils.book_new();
        let DeformazionePresente = false
        let SpostNordPresente    = false
        let SpostEstPresente     = false
        let SpostTotalePresente  = false
        let AzimuthPresente      = false
        let TemperaturaPresente  = false
        let ProfiloLongPresente  = false
        let ArrayContenitore = []
        let DatiGenerali = this.ObjEsportazione.Generale
        let RigaIntestazione = [{v: this.GetTraduzioneLabel('Generic','TKN_DMS',this.LinguaUtente) + " " + DatiGenerali.DESCRIZIONE, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
        ArrayContenitore.push(RigaIntestazione)
        let TestoReport = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_REPORT_DEL',this.LinguaUtente) + " " + TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', new Date(DatiGenerali.DataCampione))
        if(this.ObjXlsxReport.ReportXlsx != '')
          TestoReport = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_REPORT_NR',this.LinguaUtente) + " " + this.ObjXlsxReport.ReportXlsx + " - " + TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', new Date(DatiGenerali.DataCampione))
        RigaIntestazione = [{v: TestoReport, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
        ArrayContenitore.push(RigaIntestazione)
        RigaIntestazione = [{v: this.GetTraduzioneLabel('Generic','TKN_COMMITTENTE',this.LinguaUtente) + " " + DatiGenerali.CLIENTE, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
        ArrayContenitore.push(RigaIntestazione)
        RigaIntestazione = [{v: this.GetTraduzioneLabel('Generic','TKN_SITO',this.LinguaUtente) + " " + DatiGenerali.SITO, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
        ArrayContenitore.push(RigaIntestazione)
        RigaIntestazione = [{v: this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_PROGETTO',this.LinguaUtente) + " : " + DatiGenerali.PROGETTO, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
        ArrayContenitore.push(RigaIntestazione)
        // RigaIntestazione = [{v: this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_CALIBRAZIONE',this.LinguaUtente) + " : " + this.Catena.DataCalibrazione, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
        // ArrayContenitore.push(RigaIntestazione)
        RigaIntestazione = [{v: this.GetTraduzioneLabel('Generic','TKN_VALUTATO_DA',this.LinguaUtente) + " " + this.ObjXlsxReport.ValutatoDa, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
        ArrayContenitore.push(RigaIntestazione)
        RigaIntestazione = [{v: this.ObjXlsxReport.Testo, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
        ArrayContenitore.push(RigaIntestazione)
        RigaIntestazione = [{v: this.ObjDifferenziale.Differenziale ? this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_REPORT_DIFFERENZIALE',this.LinguaUtente) : this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_REPORT_CUMULATIVO',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
        ArrayContenitore.push(RigaIntestazione)
        RigaIntestazione = [{v: ' ', t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
        ArrayContenitore.push(RigaIntestazione)

        if (this.ObjAllineamento.DataAllineamento != null)
        {
          RigaIntestazione = [{v: this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_ALLINEAMENTO',this.LinguaUtente) + " " + this.ObjAllineamento.PrettyDataAllineamento, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
          ArrayContenitore.push(RigaIntestazione)
        }
        
        // if (this.Catena.EstensimetroPresente)
          for (let i = 0; i < this.ObjPosizioneGrafici.length; i++)
          {
            for (let j = 0; j < this.ObjPosizioneGrafici[i].MODULO_GRAFICO.length; j++)
            {
              let Grafico = this.ObjPosizioneGrafici[i].MODULO_GRAFICO[j]
              switch (Grafico.ELEMENTO)
              {
                case this.ModuliGrafici.Deformazione      : DeformazionePresente = true;
                                                            break;
                case this.ModuliGrafici.DeformazioneO     :
                case this.ModuliGrafici.DeformazioneOAll  : DeformazionePresente = true;
                                                            TemperaturaPresente  = true;
                                                            break;
                case this.ModuliGrafici.Polare            : SpostNordPresente = true;
                                                            SpostEstPresente  = true;
                                                            break;
                case this.ModuliGrafici.ProfiloLong       :
                case this.ModuliGrafici.ProfiloLongAll    : ProfiloLongPresente = true;
                                                            TemperaturaPresente = true;
                                                            break;
                case this.ModuliGrafici.SpostTot          : SpostTotalePresente = true;
                                                            break;
                case this.ModuliGrafici.Temperatura       :
                case this.ModuliGrafici.TemperaturaO      : TemperaturaPresente = true;
                                                            break;
                case this.ModuliGrafici.SpostAzimuth      : AzimuthPresente = true;
                                                            break;
                default                                   : break;
              }
            }
          }

          // messo così in via temporanea per accertarmi che tutti i grafici abbiano la temperatura
          TemperaturaPresente = true
        
        var wscols = [];

        let Row = 
        [
          { v: this.GetTraduzioneLabel('Generic','TKN_PROF',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}}
        ];
        wscols.push({wch:40})
        
        if (SpostNordPresente)
        {
          Row.push({ v: this.GetTraduzioneLabel('Generic','TKN_SPOST_NORD',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}})
          wscols.push({wch:20})
        }
        if (SpostEstPresente)
        {
          Row.push({ v: this.GetTraduzioneLabel('Generic','TKN_SPOST_EST',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}})
          wscols.push({wch:20})
        }
        if (SpostTotalePresente)
        {
          Row.push({ v: this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_MOD_SPOST',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}})
          wscols.push({wch:35})
        }
        if (ProfiloLongPresente)
        {
          Row.push({ v: this.GetTraduzioneLabel('Generic','TKN_QUOTA',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}})
          wscols.push({wch:20})
        }
        if (AzimuthPresente)
        {
          Row.push({ v: this.GetTraduzioneLabel('Generic','TKN_AZIMUT',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}})
          wscols.push({wch:20})
        }
        if (TemperaturaPresente)
        {
          Row.push({ v: this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}})        
          wscols.push({wch:20})
        }
        if (DeformazionePresente)
        {
          Row.push({ v: this.GetTraduzioneLabel('Generic','TKN_DEFORMAZIONE',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}})
          wscols.push({wch:25})
        }

        ArrayContenitore.push(Row)

        let Self = this
        for (let i = this.ObjEsportazione.Punti.length - 1; i >= 0; i--)
        {
          let elemento = this.ObjEsportazione.Punti[i];
          let RowElemento = 
          [
            { v: (Self.PreparaDatiExcel(elemento.Profondita != null ? elemento.Profondita : elemento.Distanza, 1)), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' }}},
          ];
          
          if (SpostNordPresente)
            RowElemento.push({ v: (Self.PreparaDatiExcel(elemento.SpostNord, 1)), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}})
          if (SpostEstPresente)
            RowElemento.push({ v: (Self.PreparaDatiExcel(elemento.SpostEst, 1)), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}})
          if (SpostTotalePresente)
            RowElemento.push({ v: (Self.PreparaDatiExcel(elemento.SpostTotale, 1)), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}})
          if (ProfiloLongPresente)
            RowElemento.push({ v: (Self.PreparaDatiExcel(elemento.SpostamentoOrizz, 1)), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}})
          if (AzimuthPresente)
            RowElemento.push({ v: (Self.PreparaDatiExcel(elemento.Azimuth, 1)), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}})
          if (TemperaturaPresente)
            RowElemento.push({ v: (Self.PreparaDatiExcel(elemento.Temperatura, 1)), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}})
          if (DeformazionePresente)
            RowElemento.push({ v: (Self.PreparaDatiExcel(elemento.Deformazione, 1)), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' }}})

          ArrayContenitore.push(RowElemento)
        } 

        const ws = XLSX.utils.aoa_to_sheet(ArrayContenitore);
        XLSX.utils.book_append_sheet(wb, ws, "REPORT_" + (DatiGenerali.Differenziale ? this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_V_EXC_DIFF',this.LinguaUtente) : this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_V_EXC_CUM',this.LinguaUtente)));
                      
        ws['!cols'] = wscols;

        XLSX.writeFile(wb, this.ObjEsportazione.Generale.DESCRIZIONE + '_' + this.ObjEsportazione.Generale.DataCampione + ".xlsx");
      },

      AdattaGrafici(Adatta = true)
      {
        let MaxMinGraph = 0
        for (let j = 0; j < this.Catena.DatiCatena.Spostamenti.Date.length; j++)
        { 
          let SumSpostEst  = 0
          let SumSpostNord = 0
          let SumSpostAllineatoNord = 0
          let SumSpostAllineatoEst  = 0
          let Spostamenti = this.Catena.DatiCatena.Spostamenti.Date[j].Moduli
          for (let k = 0; k < Spostamenti.length; k++)
          {
            let Spostamento = Spostamenti[k]
            let Allineamento = null
            if (this.Catena.DatiCatena.Allineamento != null && this.Catena.DatiCatena.Allineamento.Moduli != null)
              Allineamento = this.Catena.DatiCatena.Allineamento.Moduli[k]
            
            if (!this.ObjDifferenziale.Differenziale)
            {
              SumSpostEst  = SumSpostEst - Spostamento.SpostamentoEst / 1000
              SumSpostNord = SumSpostNord - Spostamento.SpostamentoNord / 1000
            }
            else
            {
              SumSpostEst  = Spostamento.SpostamentoEst / 1000
              SumSpostNord = Spostamento.SpostamentoNord / 1000
            }
            
            if (Allineamento != null)
            {
              SumSpostAllineatoNord = SumSpostAllineatoNord - Allineamento.SpostamentoNord / 1000
              SumSpostAllineatoEst  = SumSpostAllineatoEst - Allineamento.SpostamentoEst / 1000
              if (Math.abs(SumSpostEst - SumSpostAllineatoEst) > MaxMinGraph)
                MaxMinGraph = Math.abs(SumSpostEst - SumSpostAllineatoEst)
              if (Math.abs(SumSpostNord - SumSpostAllineatoNord) > MaxMinGraph)
                MaxMinGraph = Math.abs(SumSpostNord - SumSpostAllineatoNord)
            }
            else
            {
              if (Math.abs(SumSpostEst) > MaxMinGraph)
                MaxMinGraph = Math.abs(SumSpostEst)
              if (Math.abs(SumSpostNord) > MaxMinGraph)
                MaxMinGraph = Math.abs(SumSpostNord)
            }
          }
        }
        
        TTools.AdattaScaleGrafici([this.Catena], MaxMinGraph, MaxMinGraph, this.ObjDifferenziale.Differenziale, this.Catena.DatiCatena.MinProfondita, this.Catena.DatiCatena.MaxProfondita,
                                  this.UltimaData.MinTemperatura / 10, this.UltimaData.MaxTemperatura / 10,
                                  this.UltimaData.MinDeformazione, this.UltimaData.MaxDeformazione, Adatta)        
        
        this.AdattaGraficiOrizzontali()
        
        this.GraficiAdatta++
      },

      AdattaGraficiOrizzontali()
      {
        let MaxMinGraphAllineato = 0
        let MaxMinGraph = 0
        for (let j = 0; j < this.Catena.DatiCatena.Spostamenti.Date.length; j++)
        { 
          let SumSpostNord = 0
          let SumSpostAllineatoNord = 0
          let Spostamenti = this.Catena.DatiCatena.Spostamenti.Date[j].Moduli
          for (let k = 0; k < Spostamenti.length; k++)
          {
            let Spostamento = Spostamenti[k]
            let Allineamento = null
            if (this.Catena.DatiCatena.Allineamento != null && this.Catena.DatiCatena.Allineamento.Moduli != null)
              Allineamento = this.Catena.DatiCatena.Allineamento.Moduli[k]
            
            SumSpostNord = SumSpostNord + Spostamento.SpostamentoNord / 1000
            Spostamento.ProfLong = parseFloat(Spostamento.SpostamentoNord)
            
            if (Allineamento != null)
            {
              SumSpostAllineatoNord = SumSpostAllineatoNord + Allineamento.SpostamentoNord / 1000
              if (Math.abs(SumSpostNord - SumSpostAllineatoNord) > Math.abs(MaxMinGraphAllineato))
                MaxMinGraphAllineato = SumSpostNord - SumSpostAllineatoNord
            }
            if (Math.abs(SumSpostNord) > Math.abs(MaxMinGraph))
              MaxMinGraph = SumSpostNord
          }
        }
        let MinTemperatura  = this.Catena.DatiCatena.Spostamenti.Date[0].MinTemperatura / 10
        let MaxTemperatura  = this.Catena.DatiCatena.Spostamenti.Date[0].MaxTemperatura / 10
        let MinDeformazione = this.Catena.DatiCatena.Spostamenti.Date[0].MinDeformazione
        let MaxDeformazione = this.Catena.DatiCatena.Spostamenti.Date[0].MaxDeformazione
        let MinProfondita   = this.Catena.DatiCatena.MinProfondita
        let MaxProfondita   = this.Catena.DatiCatena.MaxProfondita

        TTools.AdattaScaleOrizzontali([this.Catena], MaxMinGraph, MaxMinGraphAllineato, MinTemperatura, MaxTemperatura, MinDeformazione, MaxDeformazione, MinProfondita, MaxProfondita)
      },

      TornaAllaVisualizzazione()
      {
        this.ObjIngrandimento.Ingrandito = false
        if(this.StatoAbbinatiPiezometri && this.StatoAbbinatiPiezometri[0])
          this.StatoAbbinatiPiezometri[0].Visibile = true
        setTimeout(()=>{this.GraficiChange++}, 50)
      },

      ResizeGraphs()
      {
        this.AltezzaSchermo = window.innerHeight
        this.LarghezzaSchermo = window.innerWidth
        this.Repaint++
      },

      EsportaComePDF()
      {
        this.ObjAllDatiPDFGrafico.Popup = true 
      },

      AnnullaPopupAllPDF()
      {
        this.ObjAllDatiPDFGrafico.Popup               = false
        this.ObjAllDatiPDFGrafico.StampaCumDif        = false
        this.ObjAllDatiPDFGrafico.PrimaPagina         = false
        this.ObjAllDatiPDFGrafico.ShowTabelleDx       = true
        this.ObjAllDatiPDFGrafico.IdReport            = ''
        this.ObjAllDatiPDFGrafico.NomeOperatore       = ''
        this.ObjAllDatiPDFGrafico.Testo               = ''
      },

      ConfermaEsportaComePDF()
      {
        let VettoreGrafici = []
        let DataOdierna = new Date()
        let NomeGrafico = this.Catena.DatiCatena.DESCRIZIONE.replace('-', '') + '_' + TZDateFunct.FormatDateTime('yyyy_mm_dd', DataOdierna) + '.pdf'
        let StrReport = this.GetTraduzioneLabel('Generic','TKN_REPORT',this.LinguaUtente) + ' - ' + this.PrettyUltimaData
        this.Catena.DatiPDF = []
        this.Catena.DatiPDFCumDiff = []
        this.AddDatiPDF++

        if(this.ObjAllDatiPDFGrafico.StampaCumDif)
        {
          this.Catena.DatiPDF = []
          this.Catena.DatiPDF = this.Catena.DatiPDFCumDiff
        }

        if(this.ObjAllDatiPDFGrafico.IdReport != '')
        {
          StrReport = this.GetTraduzioneLabel('Generic','TKN_REPORT',this.LinguaUtente) + ' nr. ' + this.ObjAllDatiPDFGrafico.IdReport + ' - ' + this.PrettyUltimaData
        }


        let Data = this.Catena.DatiCatena.Spostamenti.Date[0].Data
        for (let i = 0; i < this.Catena.DatiCatena.Spostamenti.Date.length; i++)
        {
          if (Data < this.Catena.DatiCatena.Spostamenti.Date[i].Data)
            Data = this.Catena.DatiCatena.Spostamenti.Date[i].Data
        }
        
        setTimeout(() => 
        {
          if(this.ObjAllDatiPDFGrafico.PrimaPagina)
          {            
            let ObjGrafico  =  {
                                  Catena          : this.Catena.DatiCatena.CHIAVE,
                                  TipoElementoPDF : TIPO_ELEMENTO_PDF.PRIMA_PAGINA,
                                  Data            : Data,
                                  Testo           : this.ObjAllDatiPDFGrafico.Testo,
                                  NomeOperatore   : this.ObjAllDatiPDFGrafico.NomeOperatore != '' ? this.GetTraduzioneLabel('Generic','TKN_VALUTATO_DA',this.LinguaUtente) + ' ' + this.ObjAllDatiPDFGrafico.NomeOperatore : '',
                                  Grafici         : [JSON.parse(JSON.stringify(this.Catena.DatiPDF[0]))],
                              }

            ObjGrafico.Grafici[0].Intestazione.IdReport = StrReport
            ObjGrafico.Grafici[0].Titolo = this.GetTraduzioneLabel('Generic','TKN_DMS',this.LinguaUtente) + ' ' + this.Catena.DatiCatena.DESCRIZIONE
                          
            VettoreGrafici.push(ObjGrafico)
          }

          // let Index = this.Catena.DatiPDF.findIndex((Elemento) => {return Elemento.TipoElementoPDF == TIPO_ELEMENTO_PDF.ELEMENTO_VERTICALE})
          // if (Index == -1)
          // {
          //   this.Catena.DatiPDF = this.Catena.DatiPDF.filter(Elemento => {return Elemento.TipoElementoPDF !== TIPO_ELEMENTO_PDF.ELEMENTO_STORICO})
          // }

          for (let i = 0; i < this.Catena.DatiPDF.length; i++)
          {
            let ObjGrafico = {}
            if (this.Catena.DatiPDF[i].Intestazione != null)
              this.Catena.DatiPDF[i].Intestazione.IdReport = StrReport

            switch (this.Catena.DatiPDF[i].TipoElementoPDF)
            {
              case TIPO_ELEMENTO_PDF.ELEMENTO_STORICO :
              {                
                ObjGrafico =  {
                                ChiaveCatena    : this.Catena.DatiCatena.CHIAVE,
                                TipoElementoPDF : this.Catena.DatiPDF[i].TipoElementoPDF,
                                Dati            : this.Catena.DatiPDF[i]
                              }
                break
              }
              case TIPO_ELEMENTO_PDF.ELEMENTO_ATTUALE : 
              {
                ObjGrafico =  {
                                Catena          : this.Catena.DatiCatena.CHIAVE,
                                Data            : Data,
                                TipoElementoPDF : this.Catena.DatiPDF[i].TipoElementoPDF,
                                Grafici         : [this.Catena.DatiPDF[i]],
                                ShowTabelleDx   : this.ObjAllDatiPDFGrafico.ShowTabelleDx
                              }
                break
              }
              case TIPO_ELEMENTO_PDF.ELEMENTO_VERTICALE : 
              {
                ObjGrafico =  {
                                Catena          : this.Catena.DatiCatena.CHIAVE,
                                Data            : Data,
                                TipoElementoPDF : this.Catena.DatiPDF[i].TipoElementoPDF,
                                Grafici         : [this.Catena.DatiPDF[i]]
                              }
                break
              }
              case TIPO_ELEMENTO_PDF.ELEMENTO_ORIZZONTALE : 
              {
                ObjGrafico =  {
                                Catena          : this.Catena.DatiCatena.CHIAVE,
                                Data            : Data,
                                TipoElementoPDF : this.Catena.DatiPDF[i].TipoElementoPDF,
                                Grafici         : [this.Catena.DatiPDF[i]]
                              }
                break
              }
              case TIPO_ELEMENTO_PDF.ELEMENTO_INTESTAZIONE : 
              {
                break
              }
              // case TIPO_ELEMENTO_PDF.ELEMENTO_SOMMARIO :
              // {
              //   break
              // }
            }
            VettoreGrafici.push(ObjGrafico)
          }

          let DatiSommario = []
          let DataSommario = ""

          if (this.ObjSommario != null && this.ObjSommario.Visibile)
          {
            let IntestazioneSommario = []
            for (let i = 0; i < this.ObjSommario.DatiMostrati.length; i++)
            {
              let SingleDato = this.ObjSommario.DatiMostrati[i]
              switch (SingleDato.Id)
              {
                // case 'PROFONDITA'   : break
                // case 'MODULO'       : break
                // case 'PITCH'        : break
                // case 'ROLL'         : break
                case 'SPOST_NORD'   : (new TGraficoAttuale(this.Catena, new TGraficoFittizio, this.ObjDifferenziale.Differenziale, [], [])).CompilaGraficoSpostNord()
                                      break
                case 'SPOST_EST'    : (new TGraficoAttuale(this.Catena, new TGraficoFittizio, this.ObjDifferenziale.Differenziale, [], [])).CompilaGraficoSpostEst()
                                      break
                case 'SPOST_TOT'    : (new TGraficoAttuale(this.Catena, new TGraficoFittizio, this.ObjDifferenziale.Differenziale, [], [])).CompilaGraficoSpostTot()
                                      break
                case 'AZIMUT'       : (new TGraficoAttuale(this.Catena, new TGraficoFittizio, this.ObjDifferenziale.Differenziale, [], [])).CompilaGraficoSpostAzimuth()
                                      break
                // case 'TEMPERATURA'  : break
                default             : break
              }
              IntestazioneSommario.push(SingleDato.Name)
            }

            DatiSommario.push(IntestazioneSommario)

            let UltimaData = this.Catena.DatiCatena.Spostamenti.Date.find((element) => {return element.Ultima})
            if (UltimaData != undefined)
            {
              DataSommario = TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', new Date(UltimaData.Data))
              for (let i = 0; i < UltimaData.Moduli.length; i++)
              {
                let VoceSommario = []
                let Modulo = UltimaData.Moduli[i]
                for (let j = 0; j < this.ObjSommario.DatiMostrati.length; j++)
                {
                  let SingleDato = this.ObjSommario.DatiMostrati[j]
                  
                  switch (SingleDato.Id)
                  {
                    case 'PROFONDITA'   : VoceSommario.push(Modulo.Profondita)
                                          break
                    case 'MODULO'       : VoceSommario.push(Modulo.Modulo)
                                          break
                    case 'PITCH'        : VoceSommario.push(Modulo.Pitch.toFixed(3))
                                          break
                    case 'ROLL'         : VoceSommario.push(Modulo.Roll.toFixed(3))
                                          break
                    case 'SPOST_NORD'   : VoceSommario.push(Modulo.SpostNord)
                                          break
                    case 'SPOST_EST'    : VoceSommario.push(Modulo.SpostEst)
                                          break
                    case 'SPOST_TOT'    : VoceSommario.push(Modulo.SpostTotale)
                                          break
                    case 'AZIMUT'       : VoceSommario.push(Modulo.Azimuth)
                                          break
                    case 'TEMPERATURA'  : VoceSommario.push(Modulo.Temperatura.toFixed(2))
                                          break
                    default             : break
                  }   
                }
                DatiSommario.push(VoceSommario)
              }
            }
          }

          SystemInformation.AdvQuerySiti.ExecuteExternalScript('StampaPDFAll',  { 
                                                                                  // Grafici : this.Catena.DatiPDF
                                                                                  Differenziale : this.ObjDifferenziale.Differenziale,
                                                                                  ChiaveSito : this.Catena.DatiCatena.CHIAVE_SITO,
                                                                                  VettoreDati : VettoreGrafici,
                                                                                  IsVerticaliModulabili : true,
                                                                                  DatiSommario: DatiSommario,
                                                                                  DataSommario : DataSommario
                                                                                },
                                                                function(Result)
                                                                {
                                                                  saveAs(TZStringConvFunct.Base64AsBlob(Result.PDF), NomeGrafico)
                                                                },
                                                                function(HTTPError,SubHTTPError,Response)
                                                                {
                                                                  SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
                                                                })
         this.AnnullaPopupAllPDF()
        }, 50);
        
      },

      CambiaDifferenziale()
      {
        this.ObjDifferenziale.Differenziale = !this.ObjDifferenziale.Differenziale
        this.AdattaGrafici()
      },

      ConfermaColoreAbbinati()
      {
        this.ObjColoreAbbinati.ColoreScelto = TZGenericFunct.GetHexColorFromRGB(this.ObjColoreAbbinati.Colore)
        this.ColorPickerAbbinati = false
        this.GraficoSelezionato.Colore = this.ObjColoreAbbinati.ColoreScelto
        let ObjData = this.Catena.DatiCatena.Spostamenti.Date.find((element) => {return element.Data == this.GraficoSelezionato.DataCompleta})
        if (ObjData != undefined)
        {
          ObjData.Colore = this.ObjColoreAbbinati.ColoreScelto
          ObjData.Markup = SystemInformation.GetBlobSVGMarkup('CerchioPieno', ObjData.Colore, this.Catena.DatiGrafici.MARKUP_WIDTH)
          ObjData.MarkupHighlighted = SystemInformation.GetBlobSVGMarkup('CerchioPieno', 'red', this.Catena.DatiGrafici.MARKUP_WIDTH)            
        }
        this.GraficiChange++
      },

      AnnullaColoreAbbinati()
      {
        this.ObjColoreAbbinati.Colore = this.ObjColoreAbbinati.ColoreScelto
        this.ColorPickerAbbinati = false
        this.GraficoSelezionato = null
      },

      ConfermaColore()
      {
        this.ObjColore.ColoreScelto = TZGenericFunct.GetHexColorFromRGB(this.ObjColore.Colore)
        this.PopupColorPicker = false
        this.UltimaData.Colore = this.ObjColore.ColoreScelto
        let ObjUltimaData = this.Catena.DatiCatena.Spostamenti.Date.find((element) => {return element.Ultima})
        if (ObjUltimaData != undefined)
        {
          ObjUltimaData.Colore = this.ObjColore.ColoreScelto
          ObjUltimaData.Markup = SystemInformation.GetBlobSVGMarkup('CerchioPieno', ObjUltimaData.Colore, this.Catena.DatiGrafici.MARKUP_WIDTH)
          ObjUltimaData.MarkupHighlighted = SystemInformation.GetBlobSVGMarkup('CerchioPieno', 'red', this.Catena.DatiGrafici.MARKUP_WIDTH)   
        }
        this.GraficiChange++
      },

      AnnullaColore()
      {
        this.ObjColore.Colore = this.ObjColore.ColoreScelto
        this.PopupColorPicker = false
        this.GraficoSelezionato = null
      },

      ApriDettaglio(TipoGrafico, ObjGraficoCompilato)
      {
        this.ObjIngrandimento.FiltroAzimuth = this.ObjFiltroAzimuth.Filtro
        this.ObjIngrandimento.TipoGrafico = TipoGrafico
        this.ObjIngrandimento.ProprietaGrafiche = ObjGraficoCompilato

        if(this.ObjModificaAssi.ModificaEffettuata)
          this.ObjIngrandimento.AssiModificatiIngranditi = this.ObjModificaAssi
        
        this.ObjIngrandimento.CatenaInfo = TZGenericFunct.GetCopyOfObject(this.Catena)
        this.ObjIngrandimento.Altezza   = this.Mobile ? 500 : (window.innerHeight  - 110)
        
        if(TipoGrafico == this.TipiGrafici.Polare)
          this.ObjIngrandimento.Larghezza   = this.ObjIngrandimento.Altezza
        else this.ObjIngrandimento.Larghezza = (window.innerWidth / 2)
        
        this.ObjIngrandimento.Ingrandito = true
        
        this.GetDatiTableIngrandimento()
      },

      ApriPopupFiltroAzimuth(ObjGrafico)
      {
        this.ObjFiltroAzimuth.ObjGrafico = ObjGrafico
        this.ObjFiltroAzimuth.Filtro = ObjGrafico.FiltroAzimuth
        this.ObjFiltroAzimuth.Popup = true 
      },

      AnnullaModificaFiltroAzimuth()
      {
        this.ObjFiltroAzimuth.Popup = false
        this.ObjFiltroAzimuth.ObjGrafico = null
        this.ObjFiltroAzimuth.Filtro = 0
      },

      ConfermaModificaFiltroAzimuth()
      {
        this.ObjFiltroAzimuth.ObjGrafico.FiltroAzimuth = this.ObjFiltroAzimuth.Filtro
        this.ObjFiltroAzimuth.Popup = false
      },

      ApriPopupPDF(InfoCatena, ObjParametri, ObjParametriCumDiff, TipoGrafico)
      {
        this.ObjDatiPDFGrafico.Popup               = true 
        this.ObjDatiPDFGrafico.InfoCatena          = InfoCatena 
        this.ObjDatiPDFGrafico.ObjParametri        = ObjParametri 
        this.ObjDatiPDFGrafico.ObjParametriCumDiff = ObjParametriCumDiff 
        this.ObjDatiPDFGrafico.TipoGrafico         = TipoGrafico 
      },

      AnnullaPopupPDF()
      {
        this.ObjDatiPDFGrafico.Popup               = false
        this.ObjDatiPDFGrafico.InfoCatena          = null
        this.ObjDatiPDFGrafico.ObjParametri        = null
        this.ObjDatiPDFGrafico.ObjParametriCumDiff = null
        this.ObjDatiPDFGrafico.TipoGrafico         = null
        this.ObjDatiPDFGrafico.StampaCumDif        = false
        this.ObjDatiPDFGrafico.PrimaPagina         = false
        this.ObjDatiPDFGrafico.ShowTabelleDx       = true
        this.ObjDatiPDFGrafico.IdReport            = ''
        this.ObjDatiPDFGrafico.NomeOperatore       = ''
        this.ObjDatiPDFGrafico.Testo               = ''
      },

      ConfermaPopupPDF()
      {
        let InfoCatena   = this.ObjDatiPDFGrafico.InfoCatena
        let ObjParametri = this.ObjDatiPDFGrafico.ObjParametri
        let ObjParametriCumDiff = this.ObjDatiPDFGrafico.ObjParametriCumDiff
        let DataOdierna  = new Date()
        let NomeGrafico  = InfoCatena.DatiCatena.DESCRIZIONE.replace('-', '') + '_' + TZDateFunct.FormatDateTime('yyyy_mm_dd', DataOdierna) + ObjParametri.NomePDF + '.pdf'
        
        let VettoreGrafici = []

        if(this.ObjDatiPDFGrafico.IdReport != '')
        {
          let StrReport = ' nr. ' + this.ObjDatiPDFGrafico.IdReport + ' - ' + this.PrettyUltimaData
          ObjParametri.Intestazione.IdReport += StrReport

          if(this.ObjDatiPDFGrafico.StampaCumDif)
            ObjParametriCumDiff.Intestazione.IdReport += StrReport
        }

        if(this.ObjDatiPDFGrafico.PrimaPagina)
        {

          let ObjGrafico  =  {
                                Catena          : InfoCatena.DatiCatena.CHIAVE,
                                Data            : ObjParametri.Data,
                                TipoElementoPDF : TIPO_ELEMENTO_PDF.PRIMA_PAGINA,
                                Testo           : this.ObjDatiPDFGrafico.Testo,
                                NomeOperatore   : this.ObjDatiPDFGrafico.NomeOperatore != '' ? this.GetTraduzioneLabel('Generic','TKN_VALUTATO_DA',this.LinguaUtente) + ' ' + this.ObjDatiPDFGrafico.NomeOperatore : '',
                                Grafici         : [JSON.parse(JSON.stringify(ObjParametri))],
                                // Immagine        : this.OggettoImmaginiReport.Immagine1,
                                // Immagine2       : this.OggettoImmaginiReport.Immagine2
                            }
          if(this.ObjDatiPDFGrafico.IdReport == '')
            ObjGrafico.Grafici[0].Intestazione.IdReport += ' - ' + this.PrettyUltimaData
          ObjGrafico.Grafici[0].Titolo = this.GetTraduzioneLabel('Generic','TKN_DMS',this.LinguaUtente) + ' ' + InfoCatena.DatiCatena.DESCRIZIONE
                        
          VettoreGrafici.push(ObjGrafico)
        }

        let ObjGrafico  =  {
                            Catena          : InfoCatena.DatiCatena.CHIAVE,
                            Data            : ObjParametri.Data,
                            TipoElementoPDF : ObjParametri.TipoElementoPDF,
                            Grafici         : [ObjParametri],
                            ShowTabelleDx   : this.ObjDatiPDFGrafico.ShowTabelleDx
                          }
                      
        VettoreGrafici.push(ObjGrafico)

        if(this.ObjDatiPDFGrafico.StampaCumDif)
        {
          let ObjGraficoCumDif  =  {
                                    Catena          : InfoCatena.DatiCatena.CHIAVE,
                                    Data            : ObjParametriCumDiff.Data,
                                    TipoElementoPDF : ObjParametriCumDiff.TipoElementoPDF,
                                    Grafici         : [ObjParametriCumDiff],
                                    ShowTabelleDx   : this.ObjDatiPDFGrafico.ShowTabelleDx
                                  }
                        
          VettoreGrafici.push(ObjGraficoCumDif)
        }

        SystemInformation.AdvQuerySiti.ExecuteExternalScript('StampaPDFAll',  { 
                                                                                  ChiaveSito  : InfoCatena.DatiCatena.CHIAVE_SITO,
                                                                                  VettoreDati : VettoreGrafici,
                                                                                },
                                                          function(Result)
                                                          {                                              
                                                            saveAs(TZStringConvFunct.Base64AsBlob(Result.PDF), NomeGrafico)
                                                          },
                                                          function(HTTPError,SubHTTPError,Response)
                                                          {
                                                            SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
                                                          })
        this.AnnullaPopupPDF()
      },

      LoadImmagineFromFile()
      {
        let Self    = this;
        let Reader  = new FileReader()
        let ImgFile = document.getElementById('InputImmagine')
        
        Reader.readAsDataURL(ImgFile.files[0])

        Reader.onload = function (e) 
        {
          var Img = new Image()
          Img.onload = function () 
          {
            Img.onload                       = undefined;
            Self.OggettoImmaginiReport.Immagine1 = Img.src
            Self.OggettoImmaginiReport.Immagine2 = Img.src
          }
          Img.src = e.target.result
        } 
      },

      ApriPopupModificaDirezioneGrafico(ObjGrafico)
      {
        if(ObjGrafico.DirezioneGraficoTotale !== null && ObjGrafico.DirezioneGraficoTotale !== '')
        {
          this.ObjDirezioneGrafico.DirezioneGraficoTotale = null
          this.ConfermaModificaDirezioneGrafico()
        }
        else
        {
          this.ObjDirezioneGrafico.ObjGrafico = ObjGrafico
          this.ObjDirezioneGrafico.DirezioneGraficoTotale = 0
          this.ObjDirezioneGrafico.Popup = true 
        }
      },

      AnnullaModificaDirezioneGrafico()
      {
        this.ObjDirezioneGrafico.Popup = false
        this.ObjDirezioneGrafico.ObjGrafico = null
        this.ObjDirezioneGrafico.Direzione = null
      },

      ConfermaModificaDirezioneGrafico()
      {
        this.DirezioneGraficoTotaleIngrandito = this.ObjDirezioneGrafico.DirezioneGraficoTotale
        this.ObjDirezioneGrafico.ObjGrafico.DirezioneGraficoTotale = this.ObjDirezioneGrafico.DirezioneGraficoTotale
        this.ObjDirezioneGrafico.Popup = false
      },

      AnnullaModificaAssi()
      {
        this.ObjModificaAssi.PopupAperto = false
      },

      ConfermaModificaAssi()
      {
        this.ObjModificaAssi.PopupAperto = false
        this.ObjModificaAssi.ModificaEffettuata = true
      },

      GetDimensioniGraficiVerticali(Ridotto)
      {
        let Estensione = 15.6
        if (Ridotto)
          Estensione = 11
        if (!this.Catena.EstensimetroPresente)
          Estensione += Estensione / 6
        Estensione += '%'  
        return {'width' : this.Mobile ? '100%' : Estensione }
      },

      GetDimensioniVociMenu(Dimensione)
      {
        return {'width' : this.Mobile ? '100%' : Dimensione}
      },

      FormattaData(Data)
      {
        let [DatePart, Orario] = Data.split(' ');
        let [anno, mese, giorno] = DatePart.split('-');
        return `${giorno}-${mese}-${anno} ${Orario}`;
      },

      FormattaSoloData(Data)
      {
        // let DatePart = Data.split(' ')[0]
        // let [anno, mese, giorno] = DatePart.split('-')
        // return `${giorno}-${mese}-${anno}`
        return TZDateFunct.FormatDateTime('dd/mm/yyyy', new Date(Data))
      },

      FormattaOra(Data)
      {
        // let Orario = Data.split(' ')[1]
        // return `${Orario}`
        return TZDateFunct.FormatDateTime('hh:nn:ss', new Date(Data))
      },

      GetUdmAllarme(Tipologia)
      {
        let PropertyName = TIPOLOGIA_ALLARME_TO_UI[Tipologia]
        let Result = ''

        if (PropertyName == 'Termometro')
          Result = this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente)
        if (PropertyName == 'Pressione')
          Result = this.GetTraduzioneLabel('UdmGenerali','TKN_KILOPASCAL',this.LinguaUtente)
        if (PropertyName == 'Estensimetro')
          Result = this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente)
        if (PropertyName == 'Inclinometro' || PropertyName == 'Sghembo')
          Result = this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente)
        if (PropertyName == 'Accelerometro')
          Result = this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIGRAMMO',this.LinguaUtente)

        return Result
      },


      GetTipoGrafico(TipoGrafico, isGiornaliero = null)
      {
        let Result
        switch(TipoGrafico)
        {
          case (this.ModuliGrafici.Polare)       : {
                                                      Result = this.TipiGrafici.Polare
                                                      break
                                                    }
          case (this.ModuliGrafici.SpostEst)     : {
                                                      Result = this.TipiGrafici.SpostEst
                                                      break
                                                    }
          case (this.ModuliGrafici.SpostNord)    :  {
                                                      Result = this.TipiGrafici.SpostNord
                                                      break
                                                    }
          case (this.ModuliGrafici.SpostTot)     : {
                                                      Result = this.TipiGrafici.SpostTot
                                                      break
                                                    }
          case (this.ModuliGrafici.SpostAzimuth) : {
                                                      Result = this.TipiGrafici.SpostAzimuth
                                                      break
                                                    }
          case (this.ModuliGrafici.Temperatura)  :  {
                                                      Result = this.TipiGrafici.Temperatura
                                                      break
                                                    }
          case (this.ModuliGrafici.Deformazione) : {
                                                      Result = this.TipiGrafici.Deformazione
                                                      break
                                                    }
          case (this.ModuliGrafici.Piezometro)   : {
                                                      Result = this.TipiGrafici.Piezometro
                                                      break
                                                    }
          case (this.ModuliGrafici.CampRilevati)  : {
                                                      Result = this.TipiStorici.CAMPIONI_RILEVATI
                                                      break
                                                    }
          case (this.ModuliGrafici.Spostamenti)   : {
                                                      Result = this.TipiStorici.SPOSTAMENTI_GRAFICI_SEPARATI
                                                      break
                                                    }
          case (this.ModuliGrafici.Velocità)      : {
                                                      if(isGiornaliero)
                                                        Result = this.TipiStorici.VELOCITA_MEDIA_GIORNALIERA
                                                      else Result = this.TipiStorici.VELOCITA_MEDIA_ORARIA
                                                      break
                                                    }
          case (this.ModuliGrafici.Accelerazione) : {
                                                      if(isGiornaliero)
                                                        Result = this.TipiStorici.ACCELERAZIONE_MEDIA_GIORNALIERA
                                                      else Result = this.TipiStorici.ACCELERAZIONE_MEDIA_ORARIA
                                                      break
                                                    }
          case (this.ModuliGrafici.TensAlim)      : {
                                                      Result = this.TipiStorici.TENSIONE_ALIMENTAZIONE
                                                      break
                                                    }
          case (this.ModuliGrafici.Assorbimento)   : {
                                                      Result = this.TipiStorici.ASSORBIMENTO
                                                      break
                                                      }
          case (this.ModuliGrafici.TemperaturaO)  : {
                                                      Result = this.TipiGrafici.TemperaturaO
                                                      break
                                                    }
          case (this.ModuliGrafici.ProfiloLong)   : {
                                                      Result = this.TipiGrafici.ProfiloLong
                                                      break
                                                    }
          case (this.ModuliGrafici.DeformazioneO) : {
                                                      Result = this.TipiGrafici.DeformazioneO
                                                      break
                                                    }
          case (this.ModuliGrafici.ProfiloLongAll): {
                                                      Result = this.TipiGrafici.ProfiloLongAll
                                                      break
                                                    }
          case (this.ModuliGrafici.DeformazioneOAll):{
                                                      Result = this.TipiGrafici.DeformazioneOAll
                                                      break
                                                    }
          case (this.ModuliGrafici.EvAccAmpiezza)   : {
                                                      Result = this.TipiStorici.EV_ACCELEROMETRICI_SINTETICI_A
                                                      break
                                                    }
          case (this.ModuliGrafici.EvAccFrequenza)   : {
                                                      Result = this.TipiStorici.EV_ACCELEROMETRICI_SINTETICI_F
                                                      break
                                                    }
        }
        return Result
      },

      GetLarghezzaGrafico(TipoGrafico, AltezzaGrafico, LarghezzaGrafico)
      {
        let Result
        if(TipoGrafico != this.ModuliGrafici.Polare)
          Result = window.innerWidth / 100 * LarghezzaGrafico
        else 
        {
          let Altezza = window.innerWidth / 100 * LarghezzaGrafico
          let Larghezza = window.innerHeight / 100 * AltezzaGrafico
          if(Larghezza < Altezza)
            Result = Larghezza
          else Result = Altezza
        }
        return Result
      },

      GetAltezzaGrafico(TipoGrafico, AltezzaGrafico, LarghezzaGrafico)
      {
        let Result
        if(TipoGrafico != this.ModuliGrafici.Polare)
          Result = window.innerHeight / 100 * AltezzaGrafico
        else 
        {
          let Altezza = window.innerWidth / 100 * LarghezzaGrafico
          let Larghezza = window.innerHeight / 100 * AltezzaGrafico
          if(Larghezza < Altezza)
            Result = Larghezza
          else Result = Altezza
        }
        return Result
      },

      CostruisciRigaTabellaIngrandimento(Punto, ModelObjDato, ModuliConInclinometro, ModuliConTermometro, ModuliConEstensimetro)
      {
        let ObjDato = {Separatore : false, Voci : []}

        for (let Property in ModelObjDato)
        {
          if (this.ObjIngrandimento.TipoGrafico != TIPI_GRAFICI.Piezometro)
          {
            if (Punto.Interpolato)
            {
              let SpostValidi = Punto.Pitch != null && Punto.Roll != null
              switch(Property)
              {
                case 'Profondita'   : Punto[Property] != null && Punto[Property] != undefined ? ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(1)) : ObjDato.Voci.push('-'); break
                case 'Pitch'        : ModuliConInclinometro.some(Elemento => Elemento == Punto.Modulo) && Punto.Pitch != null ? ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(3)) : ObjDato.Voci.push('-'); break
                case 'Roll'         : ModuliConInclinometro.some(Elemento => Elemento == Punto.Modulo) && Punto.Roll != null ? ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(3)) : ObjDato.Voci.push('-'); break
                case 'SpostEst'     : ModuliConInclinometro.some(Elemento => Elemento == Punto.Modulo) && SpostValidi && Punto[Property] != null && Punto[Property] != undefined ? ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(2)) : ObjDato.Voci.push('-'); break
                case 'SpostNord'    : ModuliConInclinometro.some(Elemento => Elemento == Punto.Modulo) && SpostValidi && Punto[Property] != null && Punto[Property] != undefined ? ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(2)) : ObjDato.Voci.push('-'); break
                case 'SpostTotale'  : ModuliConInclinometro.some(Elemento => Elemento == Punto.Modulo) && SpostValidi && Punto[Property] != null && Punto[Property] != undefined ? ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(2)) : ObjDato.Voci.push('-'); break
                case 'Azimuth'      : Punto[Property] != null && Punto[Property] != undefined ? ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(2)) : ObjDato.Voci.push('-'); break
                case 'Temperatura'  : ModuliConTermometro.some(Elemento => Elemento == Punto.Modulo) && Punto.Temperatura != null ? ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(1)) : ObjDato.Voci.push('-'); break
                default             : ObjDato.Voci.push(Punto[Property] != null ? Punto[Property] : '-'); break
              }
            }
            else if (Punto.SoloProfSpost)
            {
              let SpostValidi = Punto.Pitch != null && Punto.Roll != null
              switch(Property)
              {
                case 'Profondita'   : Punto[Property] != null && Punto[Property] != undefined ? ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(1)) : ObjDato.Voci.push('-'); break
                case 'SpostEst'     : ModuliConInclinometro.some(Elemento => Elemento == Punto.Modulo) && SpostValidi && Punto[Property] != null && Punto[Property] != undefined ? ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(2)) : ObjDato.Voci.push('-'); break
                case 'SpostNord'    : ModuliConInclinometro.some(Elemento => Elemento == Punto.Modulo) && SpostValidi && Punto[Property] != null && Punto[Property] != undefined ? ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(2)) : ObjDato.Voci.push('-'); break
                case 'SpostTotale'  : ModuliConInclinometro.some(Elemento => Elemento == Punto.Modulo) && SpostValidi && Punto[Property] != null && Punto[Property] != undefined ? ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(2)) : ObjDato.Voci.push('-'); break
                case 'Azimuth'      : Punto[Property] != null && Punto[Property] != undefined ? ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(2)) : ObjDato.Voci.push('-'); break
                default             : ObjDato.Voci.push('-'); break
              }
            }
            else
            {
              let SpostValidi = Punto.Pitch != null && Punto.Roll != null
              switch(Property)
              {
                case 'Profondita'   : ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(1)); break
                case 'Pitch'        : ModuliConInclinometro.some(Elemento => Elemento == Punto.Modulo) && Punto.Pitch != null ? ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(3)) : ObjDato.Voci.push('-'); break
                case 'Roll'         : ModuliConInclinometro.some(Elemento => Elemento == Punto.Modulo) && Punto.Roll != null ? ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(3)) : ObjDato.Voci.push('-'); break
                case 'SpostEst'     : ModuliConInclinometro.some(Elemento => Elemento == Punto.Modulo) && SpostValidi ? ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(2)) : ObjDato.Voci.push('-'); break
                case 'SpostNord'    : ModuliConInclinometro.some(Elemento => Elemento == Punto.Modulo) && SpostValidi ? ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(2)) : ObjDato.Voci.push('-'); break
                case 'SpostTotale'  : ModuliConInclinometro.some(Elemento => Elemento == Punto.Modulo) && SpostValidi ? ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(2)) : ObjDato.Voci.push('-'); break
                case 'Azimuth'      : Punto[Property] != undefined ? ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(2)) : ObjDato.Voci.push('-'); break
                case 'Temperatura'  : ModuliConTermometro.some(Elemento => Elemento == Punto.Modulo) && Punto.Temperatura != null  ? ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(1)) : ObjDato.Voci.push('-'); break
                case 'Pressione'    : Punto.Pressione != null ? ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(1)) : ObjDato.Voci.push('-'); break
                case 'Deformazione' : ModuliConEstensimetro.some(Elemento => Elemento == Punto.Modulo) && Punto.Deformazione != null ? ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(2)) : ObjDato.Voci.push('-'); break
                default             : ObjDato.Voci.push(Punto[Property]); break
              }
            }
          }
          else
          {
            if(this.ObjIngrandimento.CatenaInfo.DatiCatena.PIEZOMETRO_DI_RIFERIMENTO != -1 || this.ObjIngrandimento.CatenaInfo.DatiCatena.TIPO_GRAFICO_PIEZOMETRO == 'P')
            {
              for (let k = 0; k < this.ObjIngrandimento.CatenaInfo.Moduli.length; k++)
              {
                let Modulo = this.ObjIngrandimento.CatenaInfo.Moduli[k]
                let LunghezzaModulo = (Modulo.PROFONDITA_CODA - Modulo.PROFONDITA_TESTA) / 100
                if(Modulo.MODULO == Punto.Modulo && Modulo.PIEZOMETRO == 'T')
                {
                  if(this.ObjIngrandimento.CatenaInfo.DatiCatena.TIPO_GRAFICO_PIEZOMETRO == 'P' || this.ObjIngrandimento.CatenaInfo.DatiCatena.PIEZOMETRO_DI_RIFERIMENTO == Punto.Modulo)
                  {
                    switch(Property)
                    {
                      case 'Profondita'         : ObjDato.Voci.push((parseFloat(Punto[Property]) + LunghezzaModulo).toFixed(1)); break
                      case 'Pressione'          : Punto[Property] != undefined ? ObjDato.Voci.push((parseFloat((Punto[Property]) / 1000 * 9.8064)).toFixed(2)) : ObjDato.Voci.push('-'); break
                      case 'MetriPianoCampagna' : Punto.Pressione !== null ? ObjDato.Voci.push(parseFloat((Punto[Property] + LunghezzaModulo) * -1).toFixed(2)): ObjDato.Voci.push('-'); break
                      default                   : ObjDato.Voci.push(Punto[Property]); break
                    }
                  }
                }
              }
            }
          }
        }

        return ObjDato
      },

      GetDatiTableIngrandimento()
      {
        let Campi = []
        let Dati  = []
        let ModelObjDato = {}
        const PERCENTUALE_DIMENSIONE_ID = 5
        if (this.ObjIngrandimento.TipoGrafico != TIPI_GRAFICI.Deformazione && this.ObjIngrandimento.TipoGrafico != TIPI_GRAFICI.Piezometro)
        {
          Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_ID',this.LinguaUtente), Dimensione: PERCENTUALE_DIMENSIONE_ID + '%'})
          ModelObjDato.Modulo = -1
          Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_PROF',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente) + ']', Dimensione: null})
          ModelObjDato.Profondita  = 0
          Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_PITCH',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) + ']', Dimensione: null})
          ModelObjDato.Pitch = 0
          Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_ROLL',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) + ']', Dimensione: null})
          ModelObjDato.Roll  = 0
        }
        switch (this.ObjIngrandimento.TipoGrafico)
        {
          case (TIPI_GRAFICI.Polare) :
          { 
            Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_SPOST_EST',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']', Dimensione: null})
            ModelObjDato.SpostEst = 0
            Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_SPOST_NORD',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']', Dimensione: null})
            ModelObjDato.SpostNord = 0
            break
          }
          case (TIPI_GRAFICI.SpostEst) :
          {
            Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_SPOST_EST',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']', Dimensione: null})
            ModelObjDato.SpostEst = 0
            break
          }
          case (TIPI_GRAFICI.SpostNord) :
          {
            Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_SPOST_NORD',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']', Dimensione: null})
            ModelObjDato.SpostNord = 0
            break
          }
          case (TIPI_GRAFICI.SpostTot) :
          {
            Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_SPOST_TOT',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']', Dimensione: null})
            ModelObjDato.SpostTotale = 0
            break
          }
          case (TIPI_GRAFICI.SpostAzimuth) :
          {
            Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_AZIMUT',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) + ']', Dimensione: null})
            ModelObjDato.Azimuth = 0
            break
          }
          case (TIPI_GRAFICI.Temperatura) :
          {
            break
          }
          case (TIPI_GRAFICI.Piezometro) :
          {
            let MostraIdValoriMedia = this.ObjIngrandimento.CatenaInfo.DatiCatena.MOSTRA_ID_PIEZOMETRI
            if(this.ObjIngrandimento.CatenaInfo.DatiCatena.PIEZOMETRO_DI_RIFERIMENTO == -1 && this.ObjIngrandimento.CatenaInfo.DatiCatena.TIPO_GRAFICO_PIEZOMETRO == 'S')
            {
              let DimendioneCampi = 100 / (MostraIdValoriMedia ? 3 : 2)
              if(MostraIdValoriMedia)
                Campi.push({Campo: ' ', Dimensione: DimendioneCampi})
              Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_PRESSIONE',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI_ACQUA',this.LinguaUtente) + ']', Dimensione: DimendioneCampi})
              ModelObjDato.Pressione = 0
              Campi.push({Campo: this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_V_LIVELLO',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI_PIANO_CAMPAGNA',this.LinguaUtente) + ']', Dimensione: DimendioneCampi})
              ModelObjDato.MetriPianoCampagna = 0
            }
            else
            {
              Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_ID',this.LinguaUtente), Dimensione: PERCENTUALE_DIMENSIONE_ID + '%'})
              ModelObjDato.Modulo = -1
              Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_PROFONDITA',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente) + ']', Dimensione: null})
              ModelObjDato.Profondita  = 0
              Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_PRESSIONE',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI_ACQUA',this.LinguaUtente) + ']', Dimensione: null})
              ModelObjDato.Pressione = 0
              Campi.push({Campo: this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_V_LIVELLO',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI_PIANO_CAMPAGNA',this.LinguaUtente) + ']', Dimensione: null})
              ModelObjDato.MetriPianoCampagna = 0
            }
            this.CalcolaMetriPianoCampagna()
            break    
          }
          case (TIPI_GRAFICI.Deformazione) :
          {
            Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_ID',this.LinguaUtente), Dimensione: PERCENTUALE_DIMENSIONE_ID + '%'})
            ModelObjDato.Modulo = -1
            Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_DEFORMAZIONI',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']', Dimensione: null})
            ModelObjDato.Deformazione = 0
            Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_TEMP',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente) + ']', Dimensione: null})
            ModelObjDato.Temperatura = 0
            Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_PROF',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente) + ']', Dimensione: null})
            ModelObjDato.Profondita = 0
            break              
          }
        }

        if (this.ObjIngrandimento.TipoGrafico != TIPI_GRAFICI.Deformazione && this.ObjIngrandimento.TipoGrafico != TIPI_GRAFICI.Piezometro)
        {
          Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_TEMP',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente) + ']', Dimensione: null})
          ModelObjDato.Temperatura  = 0
        }

        let Dimensione = ((100 - PERCENTUALE_DIMENSIONE_ID) / (Campi.length - 1)) + '%'
        Campi.forEach((element) => {element.Dimensione == null ? element.Dimensione = Dimensione : element.Dimensione = PERCENTUALE_DIMENSIONE_ID + '%'})
        this.ObjIngrandimento.Campi = Campi

        let ModuliConEstensimetro  = []
        let ModuliConInclinometro  = []
        let ModuliConTermometro    = []
        // let ModuliConPiezometro    = []
        // let ModuliConMagnetometro  = []
        // let ModuliConAccelerometro = []

        for (let i = 0; i < this.ObjIngrandimento.CatenaInfo.Moduli.length; i++)
        {
          let Modulo = this.ObjIngrandimento.CatenaInfo.Moduli[i]
          if(Modulo.ESTENSIMETRO == 'T')
            ModuliConEstensimetro.push(Modulo.MODULO)
          if(Modulo.INCLINOMETRO == 'T')
            ModuliConInclinometro.push(Modulo.MODULO)
          if(Modulo.TERMOMETRO == 'T')
            ModuliConTermometro.push(Modulo.MODULO)
          // if(Modulo.PIEZOMETRO == 'T')
          //   ModuliConPiezometro.push(Modulo.MODULO)
          // if(Modulo.MAGNETOMETRO == 'T')
          //   ModuliConMagnetometro.push(Modulo.MODULO)
          // if(Modulo.ACCELEROMETRO == 'T')
          //   ModuliConAccelerometro.push(Modulo.MODULO)
        }


        for (let i = 0; i < this.ObjIngrandimento.ProprietaGrafiche.__GruppiPunti.length; i++)
        {
          let GruppoPunti = this.ObjIngrandimento.ProprietaGrafiche.__GruppiPunti[i]
          Dati.push({Separatore : true, Voci : [this.FormattaData(GruppoPunti.__Data)]})  

          let IndexPressione          = 0
          let MediaPressione          = 0
          let IndexMetriPianoCampagna = 0
          let MediaMetriPianoCampagna = 0
          let LabelTextValoreMedio    = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_VALORE_MEDIO',this.LinguaUtente)

          for (let j = 0; j < GruppoPunti.__Punti.length; j++)
          {
            if (GruppoPunti.__PuntiInterpolati)
            {
              for (let ip = 0; ip < GruppoPunti.__PuntiInterpolati.length; ip++)
              {
                let PuntoInterpolato = GruppoPunti.__PuntiInterpolati[ip]
                if (PuntoInterpolato.insertBeforeIndex === j)
                  Dati.push(this.CostruisciRigaTabellaIngrandimento(PuntoInterpolato, ModelObjDato, ModuliConInclinometro, ModuliConTermometro, ModuliConEstensimetro))
              }
            }

            let Punto = GruppoPunti.__Punti[j]
            let HaInterpolazione = GruppoPunti.__PuntiInterpolati != null && GruppoPunti.__PuntiInterpolati.some((Elemento) => Elemento.insertBeforeIndex === j)
            if (HaInterpolazione)
              Punto = Object.assign({}, Punto, {SoloProfSpost : true})

            if(this.ObjIngrandimento.TipoGrafico === TIPI_GRAFICI.Piezometro && this.ObjIngrandimento.CatenaInfo.DatiCatena.PIEZOMETRO_DI_RIFERIMENTO === -1)
            {
              for (let k = 0; k < this.ObjIngrandimento.CatenaInfo.Moduli.length; k++)
              {
                let Modulo = this.ObjIngrandimento.CatenaInfo.Moduli[k]
                let LunghezzaModulo = (Modulo.PROFONDITA_CODA - Modulo.PROFONDITA_TESTA) / 100
                if(Punto.Pressione !== null && Modulo.MODULO == Punto.Modulo && Modulo.PIEZOMETRO == 'T')
                {
                  LabelTextValoreMedio += (k != 0 ? ',' : '') + ' ' + this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_MOD_PIEZO',this.LinguaUtente) + ' ' + Punto.Modulo 
                  MediaPressione += parseFloat(Punto.Pressione / 1000 * 9.8064)
                  IndexPressione++
                  MediaMetriPianoCampagna += parseFloat(Punto.MetriPianoCampagna + LunghezzaModulo) 
                  IndexMetriPianoCampagna++
                }
              }
            }

            Dati.push(this.CostruisciRigaTabellaIngrandimento(Punto, ModelObjDato, ModuliConInclinometro, ModuliConTermometro, ModuliConEstensimetro))
          }
          
          if(this.ObjIngrandimento.TipoGrafico === TIPI_GRAFICI.Piezometro && this.ObjIngrandimento.CatenaInfo.DatiCatena.PIEZOMETRO_DI_RIFERIMENTO === -1 && this.ObjIngrandimento.CatenaInfo.DatiCatena.TIPO_GRAFICO_PIEZOMETRO != 'P')
          {
            let ObjDatiPiezometro = {Separatore : false, Voci : []}
            if(this.ObjIngrandimento.CatenaInfo.DatiCatena.MOSTRA_ID_PIEZOMETRI)
              ObjDatiPiezometro.Voci.push(LabelTextValoreMedio)
            
            if(MediaPressione != 0)
            {
              MediaPressione = MediaPressione / IndexPressione
              ObjDatiPiezometro.Voci.push(MediaPressione.toFixed(2))
            }
            else
            {
              ObjDatiPiezometro.Voci.push('-')
            }
            
            if(MediaMetriPianoCampagna != 0)
            {
              MediaMetriPianoCampagna = MediaMetriPianoCampagna / IndexMetriPianoCampagna * -1
              ObjDatiPiezometro.Voci.push(MediaMetriPianoCampagna.toFixed(2))
            }
            else
            {
              ObjDatiPiezometro.Voci.push('-')
            }
            
            Dati.push(ObjDatiPiezometro)
          }
        }
        this.ObjIngrandimento.Dati = Dati
      },

      CalcolaMetriPianoCampagna()
      {
        for (let i = 0; i < this.ObjIngrandimento.ProprietaGrafiche.__GruppiPunti.length; i++)
        {
          let GruppoPunti = this.ObjIngrandimento.ProprietaGrafiche.__GruppiPunti[i]

          for (let j = 0; j < GruppoPunti.__Punti.length; j++)
          {
            let Punto = GruppoPunti.__Punti[j]
            if(Punto.Profondita != undefined)            
              Punto.MetriPianoCampagna = (Punto.Profondita - Punto.Pressione / 1000)
            else Punto.MetriPianoCampagna = (Punto.ProfonditaPiezo - Punto.Pressione / 1000)
          }
        }
      },

      RimuoviElemento(Elemento)
      {
        let index = this.ObjAbbinati.LsGraficiAbbinatiTmp.findIndex((element) => {return element.DataCompleta == Elemento.DataCompleta})
        if (index != -1)
          this.ObjAbbinati.LsGraficiAbbinatiTmp.splice(index, 1)
      },

      RimuoviElementoDaTabella(Elemento)
      {
        let index = this.ObjAbbinati.LsGraficiAbbinati.findIndex((element) => {return element.DataCompleta == Elemento.DataCompleta})
        this.ObjAbbinati.LsGraficiAbbinati[index]
        let IndiceAbbinato = this.StatoAbbinatiPiezometri.findIndex((element) => {return element.Data == this.ObjAbbinati.LsGraficiAbbinati[index].DataCompleta})

        if(IndiceAbbinato != -1)
        {
          this.StatoAbbinatiPiezometri.splice(IndiceAbbinato, 1)
        }

        if (index != -1)
        {
          this.ObjAbbinati.LsGraficiAbbinati.splice(index, 1)
          
          let SecondIndex = this.Catena.DatiCatena.Spostamenti.Date.findIndex((element) => {return element.Data == Elemento.DataCompleta})
          if (SecondIndex != -1)
          this.Catena.DatiCatena.Spostamenti.Date.splice(SecondIndex, 1) 
          // if (SecondIndex == -1)
          //   this.Catena.DatiCatena.Spostamenti.Date.splice(0, 1)        
        }
        // this.CaricaDatiCatena()
        this.GraficiChange++
      },

      RimuoviAllineamento()
      {
        this.ObjAllineamento.DataAllineamento = null
        this.ObjAllineamento.OrarioAllineamento = null
        this.ObjAllineamento.ListaOre = []
        this.ObjAllineamento.DataOraAllineamento = null
        this.ObjAllineamento.PrettyDataAllineamento = ''
        this.CaricaDatiCatena()
      },

      TrovaCampioniAllineamento()
      {
        if (!this.RicercaInCorso)
        {
          this.RicercaInCorso = true
          this.ObjAllineamento.ListaOre = []
          let Self = this
          let Dal = this.ObjAllineamento.DataAllineamento + ' 00:00:00' 
          let Al  = this.ObjAllineamento.DataAllineamento + ' 23:59:59'
          // SystemInformation.AdvQuerySiti.GetSQL("Catene",{Dal : Dal, Al : Al, DMSEWSito : this.ChiaveSito},
          //                                       function(Results)
          //                                       {
          //                                         let ArrayInfo = SystemInformation.AdvQuerySiti.FindResults(Results,"GetOrariAll");
          //                                         if(ArrayInfo != undefined)
          //                                         {
          //                                           Self.ObjAllineamento.Trovato = false
          //                                           if (ArrayInfo.length > 0)
          //                                           {
          //                                             for (let i = 0; i < ArrayInfo.length; i++)
          //                                             {
          //                                               let Data = new Date(ArrayInfo[i].DATA)
          //                                               let Ora = Data.getHours()
          //                                               if (Ora < 10)
          //                                                 Ora = '0' + Ora
          //                                               let Minuti = Data.getMinutes()
          //                                               if (Minuti < 10)
          //                                                 Minuti = '0' + Minuti
          //                                               Self.ObjAllineamento.ListaOre.push(Ora + ':' + Minuti)
          //                                             }
          //                                             if (Self.ObjAllineamento.ListaOre.length > 0)
          //                                             {
          //                                               Self.ObjAllineamento.OrarioAllineamento = Self.ObjAllineamento.ListaOre[0]
          //                                               Self.ObjAllineamento.Trovato = true
          //                                             }
          //                                           }
          //                                         }
          //                                         else SystemInformation.HandleError("Impossibile ottenere i dati della catena");
          //                                         Self.RicercaInCorso = false
          //                                       },
          //                                       function(HTTPError,SubHTTPError)
          //                                       {
          //                                         SystemInformation.HandleError(HTTPError,SubHTTPError)
          //                                       }, 'SelectOrariAllineamento');
          SystemInformation.AdvQuery.ExecuteExternalScript('ExtraGetOrariAllineamento',{Dal : Dal, Al : Al, DMSEWSito : this.ChiaveSito, FusoUtente : SystemInformation.UserInformation.FusoOrario, Catena : this.ChiaveCatena},
                                                          function(Answer) 
                                                          {
                                                            if(Answer != undefined)
                                                            {
                                                              if (Answer.QueryData.length > 0)
                                                              {
                                                                for (let i = 0; i < Answer.QueryData.length; i++)
                                                                {
                                                                  let Data = new Date(Answer.QueryData[i])
                                                                  let Ora = Data.getHours()
                                                                  if (Ora < 10)
                                                                    Ora = '0' + Ora
                                                                  let Minuti = Data.getMinutes()
                                                                  if (Minuti < 10)
                                                                    Minuti = '0' + Minuti
                                                                  Self.ObjAllineamento.ListaOre.push(Ora + ':' + Minuti)
                                                                }
                                                                if (Self.ObjAllineamento.ListaOre.length > 0)
                                                                {
                                                                  Self.ObjAllineamento.OrarioAllineamento = Self.ObjAllineamento.ListaOre[0]
                                                                }
                                                              }
                                                              else 
                                                              {
                                                                Self.PopupWarning = true
                                                                Self.TestoWarning = 'Nessun campione trovato per la data selezionata'
                                                              }
                                                            }
                                                            else SystemInformation.HandleError("Impossibile ottenere i dati della catena");
                                                            Self.RicercaInCorso = false
                                                          },
                                                          function(HTTPError,SubHTTPError,Response)
                                                          {
                                                            SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
                                                          })
        }
      },

      TrovaCampioniPerData(DataPassata = null, OnSuccess = null)
      {
        this.ObjAbbinati.ListaOre = []
        let Self = this
        let Dal = this.ObjAbbinati.NuovaDataAbbinato + ' 00:00:00' 
        let Al  = this.ObjAbbinati.NuovaDataAbbinato + ' 23:59:59'
        if (DataPassata != null)
        {
          Dal = DataPassata + ' 00:00:00'
          Al  = DataPassata + ' 23:59:59'
        }

        // SystemInformation.AdvQuerySiti.GetSQL("Catene",{Catena : this.ChiaveCatena, Dal : Dal, Al : Al, DMSEWSito : this.ChiaveSito},
        //                                       function(Results)
        //                                       {
        //                                         let ArrayInfo = SystemInformation.AdvQuerySiti.FindResults(Results,"GetOrari");
        //                                         if(ArrayInfo != undefined)
        //                                         {
        //                                           if (ArrayInfo.length > 0)
        //                                           {
        //                                             for (let i = 0; i < ArrayInfo.length; i++)
        //                                             {
        //                                               let Data = new Date(ArrayInfo[i].DATA)
        //                                               let Ora = Data.getHours()
        //                                               if (Ora < 10)
        //                                                 Ora = '0' + Ora
        //                                               let Minuti = Data.getMinutes()
        //                                               if (Minuti < 10)
        //                                                 Minuti = '0' + Minuti
        //                                               Self.ObjAbbinati.ListaOre.push(Ora + ':' + Minuti)
        //                                             }
        //                                             if (Self.ObjAbbinati.ListaOre.length > 0)
        //                                             {
        //                                               Self.ObjAbbinati.NuovoOrarioAbbinato = Self.ObjAbbinati.ListaOre[0]
        //                                               Self.ObjAbbinati.DatiTrovati = true 
        //                                             }
        //                                             else
        //                                             {
        //                                               Self.ObjAbbinati.DatiTrovati = false
        //                                             }
        //                                             if (OnSuccess != null)
        //                                             {
        //                                               OnSuccess()
        //                                             }
        //                                           }
        //                                           else
        //                                           {
        //                                             Self.PopupWarning = true
        //                                             Self.TestoWarning = Self.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_WAR_NO_CAMP_TROVATO',Self.LinguaUtente)
        //                                           }
        //                                         }
        //                                         else SystemInformation.HandleError("Impossibile ottenere i dati della catena");
        //                                       },
        //                                       function(HTTPError,SubHTTPError)
        //                                       {
        //                                         SystemInformation.HandleError(HTTPError,SubHTTPError)
        //                                       }, 'SelectDateCampioni');

        SystemInformation.AdvQuery.ExecuteExternalScript('ExtraGetOrariAbbinati',{Dal : Dal, Al : Al, DMSEWSito : this.ChiaveSito, FusoUtente : SystemInformation.UserInformation.FusoOrario, Catena : this.ChiaveCatena},
                                                          function(Results)
                                                          {
                                                            if(Results != undefined)
                                                            {
                                                              if (Results.QueryData.length > 0)
                                                              {
                                                                for (let i = 0; i < Results.QueryData.length; i++)
                                                                {
                                                                  let Data = new Date(Results.QueryData[i])
                                                                  let Ora = Data.getHours()
                                                                  if (Ora < 10)
                                                                    Ora = '0' + Ora
                                                                  let Minuti = Data.getMinutes()
                                                                  if (Minuti < 10)
                                                                    Minuti = '0' + Minuti
                                                                  Self.ObjAbbinati.ListaOre.push(Ora + ':' + Minuti)
                                                                }
                                                                if (Self.ObjAbbinati.ListaOre.length > 0)
                                                                {
                                                                  Self.ObjAbbinati.NuovoOrarioAbbinato = Self.ObjAbbinati.ListaOre[0]
                                                                  Self.ObjAbbinati.DatiTrovati = true 
                                                                }
                                                                else
                                                                {
                                                                  Self.ObjAbbinati.DatiTrovati = false
                                                                }
                                                                if (OnSuccess != null)
                                                                {
                                                                  OnSuccess()
                                                                }
                                                              }
                                                              else
                                                              {
                                                                Self.PopupWarning = true
                                                                Self.TestoWarning = 'Nessun campione trovato per la data selezionata'
                                                              }
                                                            }
                                                            else SystemInformation.HandleError("Impossibile ottenere i dati della catena");
                                                          },
                                                          function(HTTPError,SubHTTPError,Response)
                                                          {
                                                            SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
                                                          })
      },

      ChiudiAllarmi()
      {
        this.PopupAllarmi = false
      },

      AnnullaAllineamento()
      {
        this.PopupSelezioneAllineamento = false
      },

      ConfermaAllineamento()
      {
        this.ObjAllineamento.DataOraAllineamento = this.ObjAllineamento.DataAllineamento + ' ' + this.ObjAllineamento.OrarioAllineamento
        this.ObjAllineamento.PrettyDataAllineamento = TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', new Date(this.ObjAllineamento.DataOraAllineamento))
        this.CaricaDatiCatena()
        this.AnnullaAllineamento()
      },

      ApriPopupAbbinamentoMobile()
      {
        this.PopupAbbinatiPerMobile = true
      },

      ChiudiPopupAbbinamentoMobile(SelezionaAbbinato = null)
      {
        this.PopupAbbinatiPerMobile = false
        if(SelezionaAbbinato != null)
          SelezionaAbbinato()
      },

      ApriPopupGraficiAbbinati()
      {
        this.ObjAbbinati.LsGraficiAbbinatiTmp = TZGenericFunct.GetCopyOfObject(this.ObjAbbinati).LsGraficiAbbinati
        this.PopupGraficiAbbinati = true
      },

      AggiungiDataAbbinato(ConfermaOra = false)
      {
        let Data = this.ObjAbbinati.NuovaDataAbbinato + ' ' + this.ObjAbbinati.NuovoOrarioAbbinato
        let index = this.ObjAbbinati.LsGraficiAbbinatiTmp.findIndex((element) => {return element.DataCompleta == Data})
        if (index == -1)
        {
          let ObjVoce = {
                          DataCompleta       : Data,
                          PrettyDataCompleta : TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', new Date(Data)),
                          Data               : this.ObjAbbinati.NuovaDataAbbinato,
                          PrettyData         : TZDateFunct.FormatDateTime('dd/mm/yyyy', new Date(Data)),
                          Ora                : this.ObjAbbinati.NuovoOrarioAbbinato,
                          Colore             : '#0000FF',
                          Falda              : true,
                          Visibile           : true
                        }
          this.ObjAbbinati.LsGraficiAbbinatiTmp.push(ObjVoce)

          let Colore = null
          while (Colore == null)
          {
            if (COLORI_DEFAULT_GRAFICI.length > this.ObjAbbinati.LsGraficiAbbinatiTmp.length - COLORI_DEFAULT_GRAFICI.length * index)
            {
              Colore = COLORI_DEFAULT_GRAFICI[this.ObjAbbinati.LsGraficiAbbinatiTmp.length - COLORI_DEFAULT_GRAFICI.length * index]
            }
            index++
          }
          ObjVoce.Colore = Colore
          this.PopupWarning = false
          if (ConfermaOra)
            this.ConfermaAbbinati()
        }
        else
        {
          this.TestoWarning = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_WAR_GIA_PRESENTE',this.LinguaUtente)
          this.PopupWarning = true
        }
        this.ObjAbbinati.ListaOre = []
        this.ObjAbbinati.NuovaDataAbbinato = this.GetDataOdierna()
        this.ObjAbbinati.NuovoOrarioAbbinato = null
      },

      AggiungiNuovoGrafico(Giorni, ConfermaOra = false)
      {
        if (ConfermaOra)
          this.ObjAbbinati.LsGraficiAbbinatiTmp = TZGenericFunct.GetCopyOfObject(this.ObjAbbinati).LsGraficiAbbinati

        let UltimaDataDateObj = new Date(this.UltimaData.Data)
        let Data = TZDateFunct.ChangeDate(UltimaDataDateObj, 'day', -1 * Giorni)
        this.ObjAbbinati.NuovaDataAbbinato = TZDateFunct.FormatDateTime('yyyy-mm-dd', Data)
        this.TrovaCampioniPerData(TZDateFunct.FormatDateTime('yyyy-mm-dd', Data),
                                  () =>
                                  {
                                    if (this.ObjAbbinati.ListaOre.length > 0)
                                    {
                                      let Orario = TZDateFunct.FormatDateTime('hh:nn', UltimaDataDateObj)
                                      if (this.ObjAbbinati.ListaOre.includes(Orario))
                                        this.ObjAbbinati.NuovoOrarioAbbinato = Orario
                                      this.PopupWarning = false
                                      this.AggiungiDataAbbinato(ConfermaOra)
                                    }
                                    else
                                    {
                                      this.TestoWarning = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_WAR_NO_GRAF_TROVATO',this.LinguaUtente)
                                      this.PopupWarning = true
                                    }
                                  })
      },
      
      ToggleUltimaData()
      {
        let index = this.Catena.DatiCatena.Spostamenti.Date.findIndex((element) => {return element.Ultima})
        if (this.MostraUltimo)
        {
          if (index == -1)
            this.Catena.DatiCatena.Spostamenti.Date.unshift(this.UltimaData)
        }
        else
        {
          if (index != -1)
          {
            this.UltimaData = this.Catena.DatiCatena.Spostamenti.Date[index]
            this.Catena.DatiCatena.Spostamenti.Date.splice(index, 1)
          }

        }
        this.GraficiChange++
      },

      ConfermaAbbinati()
      {
        this.StatoAbbinatiPiezometri = []
        this.ObjAbbinati.LsGraficiAbbinatiTmp.forEach(Grafico => 
                                                      {
                                                        this.StatoAbbinatiPiezometri.push({Data: Grafico.DataCompleta, Visibile: true})
                                                      })
        
        this.ObjAbbinati.LsGraficiAbbinati = TZGenericFunct.GetCopyOfObject(this.ObjAbbinati).LsGraficiAbbinatiTmp
        this.PopupGraficiAbbinati = false
        this.ObjAbbinati.LsGraficiAbbinatiTmp = []
        this.ObjAbbinati.NuovaDataAbbinato = this.GetDataOdierna()
        this.ObjAbbinati.NuovoOrarioAbbinato = 0
        this.CaricaDatiCatena()
      },

      AnnullaModificaAbbinati()
      {
        this.PopupGraficiAbbinati = false
        this.ObjAbbinati.LsGraficiAbbinatiTmp = []
        this.ObjAbbinati.NuovaDataAbbinato = this.GetDataOdierna()
        this.ObjAbbinati.NuovoOrarioAbbinato = 0
        if (this.Mobile)
          setTimeout(() => {this.GraficiChange++}, 1)
      },

      CambiaCatena(ChiaveCatena)
      {
        if (ChiaveCatena == this.ChiaveCatena)
          return
        this.ChiaveCatena = ChiaveCatena
        TZGenericFunct.ChangeURLParameters({ ChiaveCatena : ChiaveCatena })
        this.CaricamentoDatiCatena = true
        this.DatiNonCaricati = false
        this.CaricaDatiCatena(this.CaricaConfigurazioneGrafici)
      },

      LoadListaCatene(OnSuccess = undefined)
      {
        let Self = this
        SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId
        SystemInformation.AdvQuerySiti.GetSQL('Catene', { DMSEWSito: this.ChiaveSito },
          function(Results)
          {
            let ArrayCatena = SystemInformation.AdvQuerySiti.FindResults(Results, 'SelectAllCatene')
            if (ArrayCatena != undefined)
            {
              Self.ListaCatene = ArrayCatena.filter((element) => { return element.ELIMINATO == 'F' }).map((element) =>
              {
                return {
                  CHIAVE      : element.CHIAVE,
                  DESCRIZIONE : TSchedaGenerica.DisponiFromString(element.DESCRIZIONE)
                }
              })
              Self.$emit('onListaCateneCaricata', Self.ListaCatene)
            }
            if (OnSuccess != undefined)
              OnSuccess()
          },
          function(HTTPError, SubHTTPError, Response)
          {
            SystemInformation.HandleError(HTTPError, SubHTTPError, Response)
          },
          'SelectDettaglioCatena')
      },

      EmettiCatenaCambiata()
      {
        this.$emit('onCatenaCambiata', { CHIAVE : this.ChiaveCatena, DESCRIZIONE : this.Catena.Descrizione })
      },

      CaricaDatiCatena(OnSuccess = undefined)
      {
        SystemInformation.DatiCatena = null
        this.MostraGrafici = false
        let Self = this
        // let MaxMinGraph = 0
        // let Parametri = {Chiave : this.ChiaveSito, ChiaveCatena : this.ChiaveCatena, Allineamento : TZDateFunct.ChangeDate(new Date(this.ObjAllineamento.DataOraAllineamento), 'hour', 1)}
        let Parametri = {Chiave : this.ChiaveSito, ChiaveCatena : this.ChiaveCatena, Allineamento : this.ObjAllineamento.DataOraAllineamento}
        Parametri.MediaAritmetica = this.MediaAttiva
        if (this.ObjAbbinati.LsGraficiAbbinati.length != 0)
        {
          Parametri.Date = []
          Parametri.Falde = []
          
          for (let i = 0; i < this.ObjAbbinati.LsGraficiAbbinati.length; i++)
          {
            Parametri.Date.push(this.ObjAbbinati.LsGraficiAbbinati[i].DataCompleta)
            Parametri.Falde.push(this.ObjAbbinati.LsGraficiAbbinati[i].Falda)
          }
        }
        if (this.MediaAttiva)
        {
          Parametri.Date = []
          let DataDal = this.ObjMedia.Data + ' ' + this.ObjMedia.Ora
          Parametri.Date.push(DataDal)
          Parametri.Date.push(TZDateFunct.FormatDateTime('yyyy-mm-dd hh:nn', TZDateFunct.ChangeDate(new Date(DataDal), 'hour', this.ObjMedia.Intervallo)))
        }

        SystemInformation.AdvQuery.ExecuteExternalScript('ExtraDatiCatene',Parametri,function(Answer) 
        {
          let ObjCatena = Answer.QueryData[0]
          Self.Catena.DatiCatena = {}
          Self.Catena.DatiCatena.CHIAVE_SITO = Self.ChiaveSito
          Self.Catena.DatiCatena.CHIAVE = Self.ChiaveCatena
          Self.Catena.DatiCatena.DESCRIZIONE     = TSchedaGenerica.DisponiFromString(ObjCatena.DESCRIZIONE)
          Self.Catena.DatiCatena.IMMAGINE_CATENA = TSchedaGenerica.DisponiFromString(ObjCatena.IMMAGINE_CATENA)
          Self.Catena.DatiCatena.PLUVIOMETRO     = TSchedaGenerica.DisponiFromBoolean(ObjCatena.PLUVIOMETRO)
          Self.Catena.DatiCatena.ANEMOMETRO      = TSchedaGenerica.DisponiFromBoolean(ObjCatena.ANEMOMETRO)
          Self.Catena.DatiCatena.TERMOMETRO      = TSchedaGenerica.DisponiFromBoolean(ObjCatena.TERMOMETRO)
          Self.Catena.DatiCatena.INTERPOLAZIONE  = TSchedaGenerica.DisponiFromBoolean(ObjCatena.INTERPOLAZIONE)
          Self.Catena.DatiCatena.INCLINOMETRI    = TSchedaGenerica.DisponiFromInteger(ObjCatena.NR_INCLINOMETRI) > 0
          if(Self.Catena.DatiCatena.TERMOMETRO || Self.Catena.DatiCatena.ANEMOMETRO || Self.Catena.DatiCatena.PLUVIOMETRO)
            Self.CurrentObjPresenzaMenu.VisualizzaStazioneMeteo = true
          Self.Catena.DatiCatena.IDENTIFICATIVO = TSchedaGenerica.DisponiFromString(ObjCatena.IDENTIFICATIVO)
          Self.Catena.DatiCatena.FUORI_SERVIZIO = TSchedaGenerica.DisponiFromBoolean(ObjCatena.FUORI_SERVIZIO)
          Self.Catena.DatiCatena.TIPO_GRAFICO_PIEZOMETRO = TSchedaGenerica.DisponiFromString(ObjCatena.TIPO_GRAFICO_PIEZOMETRO)
          Self.Catena.DatiCatena.PIEZOMETRO_DI_RIFERIMENTO = TSchedaGenerica.DisponiFromInteger(ObjCatena.PIEZOMETRO_DI_RIFERIMENTO)
          Self.Catena.DatiCatena.MOSTRA_ID_PIEZOMETRI = TSchedaGenerica.DisponiFromBoolean(ObjCatena.MOSTRA_ID_PIEZOMETRI)
          Self.Catena.DatiCatena.MinProfondita = TSchedaGenerica.DisponiFromDouble(ObjCatena.MinProfondita, 2)
          Self.Catena.DatiCatena.MaxProfondita = TSchedaGenerica.DisponiFromDouble(ObjCatena.MaxProfondita, 2)
          Self.Catena.DatiCatena.Spostamenti = ObjCatena.Spostamenti
          Self.Catena.DatiPDF = []
          
          let LsInfoCatena  = [
                                {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_CLIENTE',Self.LinguaUtente),            Valore : TSchedaGenerica.DisponiFromString(ObjCatena.CLIENTE)},
                                {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_SITO',Self.LinguaUtente),               Valore : TSchedaGenerica.DisponiFromString(ObjCatena.SITO)},
                                {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_PROGETTO_ESTESO',Self.LinguaUtente),    Valore : TSchedaGenerica.DisponiFromString(ObjCatena.PROGETTO)},
                                {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_INT_MONITORAGGIO',Self.LinguaUtente),   Valore : TSchedaGenerica.DisponiFromString(ObjCatena.MONITORAGGIO)},
                                {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_DATA_INSTALLAZIONE',Self.LinguaUtente), Valore : (ObjCatena.DATA_INSTALLAZIONE != null ? TSchedaGenerica.DisponiFromDate(TZDateFunct.FormatDateTime('dd/mm/yyyy', new Date(ObjCatena.DATA_INSTALLAZIONE))) : '')},
                                {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_ORA_INSTALLAZIONE',Self.LinguaUtente),  Valore : (ObjCatena.ORA_INSTALLAZIONE  != null ? TSchedaGenerica.DisponiFromHour(ObjCatena.ORA_INSTALLAZIONE).substring(0, 5) : '')},
                                {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_DATA_CALIBRAZIONE',Self.LinguaUtente),  Valore : (ObjCatena.DATA_CALIBRAZIONE  != null ?  TSchedaGenerica.DisponiFromDate(TZDateFunct.FormatDateTime('dd/mm/yyyy', new Date(ObjCatena.DATA_CALIBRAZIONE))) : '')},
                                {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_ORA_CALIBRAZIONE',Self.LinguaUtente),   Valore : (ObjCatena.ORA_CALIBRAZIONE   != null ? TSchedaGenerica.DisponiFromHour(ObjCatena.ORA_CALIBRAZIONE).substring(0, 5) : '')},
                                {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_NOTE',Self.LinguaUtente),               Valore : TSchedaGenerica.DisponiFromString(ObjCatena.NOTE)}
                              ]
          let LsInfoCatenaLeft  = [
                                    {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_CLIENTE',Self.LinguaUtente), Valore : TSchedaGenerica.DisponiFromString(ObjCatena.CLIENTE)},
                                    {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_SITO',Self.LinguaUtente), Valore : TSchedaGenerica.DisponiFromString(ObjCatena.SITO)},
                                    {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_PROGETTO_ESTESO',Self.LinguaUtente), Valore : TSchedaGenerica.DisponiFromString(ObjCatena.PROGETTO)},
                                    {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_INT_MONITORAGGIO',Self.LinguaUtente), Valore : TSchedaGenerica.DisponiFromString(ObjCatena.MONITORAGGIO)}, 
                                  ]
          let LsInfoCatenaRight = [
                                    {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_DATA_INSTALLAZIONE',Self.LinguaUtente), Valore : (ObjCatena.DATA_INSTALLAZIONE != null ? TSchedaGenerica.DisponiFromDate(TZDateFunct.FormatDateTime('dd/mm/yyyy', new Date(ObjCatena.DATA_INSTALLAZIONE))) : '') + " " + (ObjCatena.ORA_INSTALLAZIONE != null ? TSchedaGenerica.DisponiFromHour(ObjCatena.ORA_INSTALLAZIONE).substring(0, 5) : '')},
                                    {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_DATA_CALIBRAZIONE',Self.LinguaUtente),  Valore : (ObjCatena.DATA_CALIBRAZIONE != null  ? TSchedaGenerica.DisponiFromDate(TZDateFunct.FormatDateTime('dd/mm/yyyy', new Date(ObjCatena.DATA_CALIBRAZIONE))) : '')  + " " + (ObjCatena.ORA_CALIBRAZIONE  != null ? TSchedaGenerica.DisponiFromHour(ObjCatena.ORA_CALIBRAZIONE).substring(0, 5)  : '')},
                                    {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_NOTE',Self.LinguaUtente), Valore : TSchedaGenerica.DisponiFromString(ObjCatena.NOTE)}, 
                                  ]
          Self.Catena.Descrizione = TSchedaGenerica.DisponiFromString(ObjCatena.DESCRIZIONE)
          Self.Catena.DataCalibrazione = TSchedaGenerica.DisponiFromDate(TZDateFunct.FormatDateTime('dd/mm/yyyy', new Date(ObjCatena.DATA_CALIBRAZIONE)))
          Self.Catena.LsInfoCatena      = LsInfoCatena
          Self.Catena.LsInfoCatenaLeft  = LsInfoCatenaLeft
          Self.Catena.LsInfoCatenaRight = LsInfoCatenaRight

          Self.Catena.DatiCatena.Allineamento = ObjCatena.Allineamento      
          if (Self.Catena.DatiCatena.Spostamenti != undefined)
          {
            let index = Self.Catena.DatiCatena.Spostamenti.Date.findIndex((element) => {return element.Ultima})
            if (index != -1)
            {
              let ObjData = Self.Catena.DatiCatena.Spostamenti.Date[index] 
              ObjData.Colore = Self.ObjColore.ColoreScelto              
              ObjData.Markup = SystemInformation.GetBlobSVGMarkup('CerchioPieno', ObjData.Colore, ObjCatena.GRAPH_MARKUP_WIDTH)
              ObjData.MarkupHighlighted = SystemInformation.GetBlobSVGMarkup('CerchioPieno', 'red', ObjCatena.GRAPH_MARKUP_WIDTH)
              Self.PrettyUltimaData = TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', new Date(Self.Catena.DatiCatena.Spostamenti.Date[index].Data))
              Self.UltimaData = Self.Catena.DatiCatena.Spostamenti.Date[index]
              Self.ObjMedia.Data = TZDateFunct.FormatDateTime('dd/mm/yyyy', new Date(Self.Catena.DatiCatena.Spostamenti.Date[index].Data))
              Self.ObjMedia.Ora  = TZDateFunct.FormatDateTime('hh:nn', new Date(Self.Catena.DatiCatena.Spostamenti.Date[index].Data))
              Self.ObjMedia.Intervallo = 24
            }
            if (!Self.MostraUltimo && !Self.MediaAttiva)
              Self.Catena.DatiCatena.Spostamenti.Date.splice(index, 1)
            for (let j = 0; j < Self.Catena.DatiCatena.Spostamenti.Date.length; j++)
            { 
              let ObjData = Self.Catena.DatiCatena.Spostamenti.Date[j]
              let DatiGraficiElemento = Self.ObjAbbinati.LsGraficiAbbinati.find((element) => {return element.DataCompleta == ObjData.Data})
              if (DatiGraficiElemento != undefined)
              {
                ObjData.Colore = DatiGraficiElemento.Colore
                ObjData.Markup = SystemInformation.GetBlobSVGMarkup('CerchioPieno', ObjData.Colore, ObjCatena.GRAPH_MARKUP_WIDTH)
                ObjData.MarkupHighlighted = SystemInformation.GetBlobSVGMarkup('CerchioPieno', 'red', ObjCatena.GRAPH_MARKUP_WIDTH)
              }
            }
          }
          Self.Catena.DatiGrafici = {
                                      TITLE_COLOR          : TSchedaGenerica.DisponiFromString(ObjCatena.GRAPH_TITLE_COLOR),
                                      TITLE_FONT_SIZE      : TSchedaGenerica.DisponiFromInteger(ObjCatena.GRAPH_TITLE_FONT_SIZE),
                                      BACKGROUND           : Self.ColoreGrafico.Sfondo,        
                                      COLOR                : Self.ColoreGrafico.Grafico,
                                      MARKUP               : TSchedaGenerica.DisponiFromString(ObjCatena.GRAPH_MARKUP),
                                      MARKUP_WIDTH         : 5,
                                      PEN_WIDTH            : 2,
                                      DRAW_TITLE_STROKE    : TSchedaGenerica.DisponiFromBoolean(ObjCatena.GRAPH_DRAW_TITLE_STROKE),
                                      COLOR_TITLE_STROKE   : TSchedaGenerica.DisponiFromString(ObjCatena.GRAPH_COLOR_TITLE_STROKE),
                                      DRAW_BORDERS         : false,
                                      AXES_COLOR           : Self.ColoreGrafico.Griglia,
                                      AXES_PEN_WIDTH       : 1,
                                      AXES_MIN             : TSchedaGenerica.DisponiFromInteger(ObjCatena.GRAPH_AXES_MAX) * -1,
                                      AXES_MAX             : TSchedaGenerica.DisponiFromInteger(ObjCatena.GRAPH_AXES_MAX),
                                      NOTCH_SIZE           : TSchedaGenerica.DisponiFromInteger(ObjCatena.GRAPH_AXES_NOTCH_SIZE),
                                      NOTCH_FONT_SIZE      : TSchedaGenerica.DisponiFromInteger(ObjCatena.GRAPH_AXES_NOTCH_FONT_SIZE),
                                      NOTCH_PEN_WIDTH      : TSchedaGenerica.DisponiFromInteger(ObjCatena.GRAPH_AXES_NOTCH_PEN_WIDTH),
                                      NOTCH_COLOR          : Self.ColoreGrafico.Griglia,
                                      AXES_FONT_SIZE       : TSchedaGenerica.DisponiFromInteger(ObjCatena.GRAPH_AXES_FONT_SIZE),
                                      AXES_FONT_COLOR      : Self.ColoreGrafico.Griglia,
                                      AXES_LABEL_TYPE      : TSchedaGenerica.DisponiFromString(ObjCatena.GRAPH_AXES_LABEL_TYPE),
                                      AXES_LABELS_USE_BOLD : TSchedaGenerica.DisponiFromBoolean(ObjCatena.GRAPH_AXES_LABELS_USE_BOLD),
                                      DRAW_LATERAL_LABELS  : false,
                                      DRAW_NOTCH_LABELS    : TSchedaGenerica.DisponiFromBoolean(ObjCatena.GRAPH_DRAW_NOTCH_LABELS),
                                    }
          Self.Catena.Moduli = []
          for (let j = 0; j < ObjCatena.ModuliConfig.length; j++)
          {
            let Modulo = ObjCatena.ModuliConfig[j]
            let ObjModulo = {}
            ObjModulo = {
                          CATENA                  : Modulo.CATENA,
                          MODULO                  : Modulo.MODULO,
                          INCLINOMETRO            : Modulo.INCLINOMETRO,
                          ESTENSIMETRO            : Modulo.ESTENSIMETRO,
                          PIEZOMETRO              : Modulo.PIEZOMETRO,
                          TERMOMETRO              : Modulo.TERMOMETRO,
                          ACCELEROMETRO           : Modulo.ACCELEROMETRO,
                          MAGNETOMETRO            : Modulo.MAGNETOMETRO,
                          PROFONDITA_TESTA        : Modulo.PROFONDITA_TESTA,
                          PROFONDITA_CODA         : Modulo.PROFONDITA_CODA,
                          LUNGHEZZA_SPEZZONE      : Modulo.LUNGHEZZA_SPEZZONE,
                          ORIENTAMENTO            : Modulo.ORIENTAMENTO,
                          SEGMENTO_DEFORMAZIONE_A : Modulo.SEGMENTO_DEFORMAZIONE_A,
                          SEGMENTO_DEFORMAZIONE_B : Modulo.SEGMENTO_DEFORMAZIONE_B,
                          PRESSIONE_SECCO         : Modulo.PRESSIONE_SECCO,
                          QUOTA_PIEZOMETRO        : Modulo.QUOTA_PIEZOMETRO
                        }
            Self.Catena.Moduli.push(ObjModulo)
          }
          Self.Catena.DatiCatena.Piezometro = []
          for (let j = 0; j < ObjCatena.PiezometroConfig.length; j++)
          {
            let Piezometro = ObjCatena.PiezometroConfig[j]
            let ObjPiezometro = {}
            ObjPiezometro = {
                              NUMERO_PIEZOMETRO       : Piezometro.NUMERO_PIEZOMETRO,
                              COLORE                  : Piezometro.COLORE,
                              MOSTRA_PACKER           : Piezometro.MOSTRA_PACKER,
                            }
            Self.Catena.DatiCatena.Piezometro.push(ObjPiezometro)
          }

          Self.Catena.DatiCatena.Packer = []
          for (let j = 0; j < ObjCatena.PackerConfig.length; j++)
          {
            let Packer = ObjCatena.PackerConfig[j]
            let ObjPacker = {}
            ObjPacker = {
                          DESCRIZIONE             : Packer.DESCRIZIONE,
                          DALLA_PROFONDITA        : Packer.DALLA_PROFONDITA,
                          ALLA_PROFONDITA         : Packer.ALLA_PROFONDITA,
                          COLORE                  : Packer.COLORE,
                        }
            Self.Catena.DatiCatena.Packer.push(ObjPacker)
          }

          if(!Self.Catena.DatiCatena.INCLINOMETRI && Self.Catena.DatiCatena.Piezometro != undefined && Self.Catena.DatiCatena.Piezometro.length > 0)
            Self.CurrentObjPresenzaMenu.CatenaSoloPiezo = true

          Self.Catena.Allarmi = []
          Self.Catena.TipiAllarmiAttivi = []

          if (ObjCatena.BLACKOUT_DATA != undefined)
          {
            Self.Catena.TipiAllarmiAttivi.push({TIPO: 'Blackout', LIVELLO: 0, ListaModuli: [{MODULO: '-', VALORE: '-'}]})
          }

          let TipiAllarme = JSON.parse(JSON.stringify(TIPI_GRANDEZZE_ALLARME));
          if (!TSchedaGenerica.DisponiFromBoolean(ObjCatena.CFG_TERMOMETRO))
            delete TipiAllarme.Termometro;
          if (!TSchedaGenerica.DisponiFromBoolean(ObjCatena.CFG_PRESSIONE))
            delete TipiAllarme.Pressione;
          if (!TSchedaGenerica.DisponiFromBoolean(ObjCatena.CFG_ESTENSIMETRO))
             delete TipiAllarme.Estensimetro;
          if (!TSchedaGenerica.DisponiFromBoolean(ObjCatena.CFG_INCLINOMETRO))
            delete TipiAllarme.Inclinometro;
          if (!TSchedaGenerica.DisponiFromBoolean(ObjCatena.CFG_SGHEMBO))
            delete TipiAllarme.Sghembo;
          // if (!TSchedaGenerica.DisponiFromBoolean(ObjCatena.CFG_ACCELEROMETRO))
          //   delete TipiAllarme.Accelerometro;

          for (let j = 0; j < ObjCatena.Allarmi.length; j++)
          {
            let Allarme = ObjCatena.Allarmi[j]
            let Tipologia = TSchedaGenerica.DisponiFromString(Allarme.TIPOLOGIA)
            let PropertyName = TIPOLOGIA_ALLARME_TO_UI[Tipologia]
            if (!PropertyName || !TipiAllarme[PropertyName])
              continue

            let Decimali = 3
            if (PropertyName == 'Termometro' || PropertyName == 'Pressione')
              Decimali = 2

            let IndexAllarmeAttivo = Self.Catena.TipiAllarmiAttivi.findIndex((element)=>(element.TIPO == PropertyName))
            let LivelloAllarme = TSchedaGenerica.DisponiFromInteger(Allarme.LIVELLO_ALLARME)
            let ValoreAllarme = TSchedaGenerica.DisponiFromDouble(Allarme.VALORE, Decimali)

            if (PropertyName == "Accelerometro")
            {
              if(ValoreAllarme <= ObjCatena.CFG_ACCELEROMETRO)
              {
                continue
              }
            }

            if (IndexAllarmeAttivo != -1)
            {
              Self.Catena.TipiAllarmiAttivi[IndexAllarmeAttivo].ListaModuli.push({
                                                                                    MODULO      : TSchedaGenerica.DisponiFromListIndex(Allarme.MODULO),
                                                                                    VALORE      : ValoreAllarme.toFixed(Decimali),
                                                                                    DATA_INIZIO : TSchedaGenerica.DisponiFromString(Allarme.DATA_INIZIO),
                                                                                    GRANDEZZA   : Self.GrandezzaAllarmeToTipologia(Allarme.GRANDEZZA),
                                                                                    LIVELLO     : LivelloAllarme
                                                                                 })
            }
            else
            {
              Self.Catena.TipiAllarmiAttivi.push({
                                                  TIPO        : PropertyName,
                                                  UDM         : Self.GetUdmAllarme(Tipologia),
                                                  ListaModuli : [{
                                                                   MODULO      : TSchedaGenerica.DisponiFromListIndex(Allarme.MODULO),
                                                                   VALORE      : ValoreAllarme.toFixed(Decimali),
                                                                   DATA_INIZIO : TSchedaGenerica.DisponiFromString(Allarme.DATA_INIZIO),
                                                                   GRANDEZZA   : Self.GrandezzaAllarmeToTipologia(Allarme.GRANDEZZA),
                                                                   LIVELLO     : LivelloAllarme
                                                                }]
                                                })
            }
          }

          Self.Catena.MouseOverOnCoords = {}
          Self.Catena.DimensioniRelative =  {
                                              POS_X : TSchedaGenerica.DisponiFromDouble(ObjCatena.GRAPH_POS_X, 5),
                                              POS_Y : TSchedaGenerica.DisponiFromDouble(ObjCatena.GRAPH_POS_Y, 5),
                                              LARGHEZZA : TSchedaGenerica.DisponiFromDouble(ObjCatena.GRAPH_LARGHEZZA, 5),
                                              ALTEZZA   : TSchedaGenerica.DisponiFromDouble(ObjCatena.GRAPH_ALTEZZA, 5)
                                            }
          Self.Catena.MouseInfo.Coordinates = {x: 0, y: 0}
          Self.Catena.MouseInfo.Detail =  {
                                            xStart  : 0,
                                            yStart  : 0,
                                            xAngolo : 0,
                                            yAngolo : 0, 
                                            width   : 0, 
                                            height  : 0
                                          }
          Self.Catena.MouseInfo.Enlarge = {
                                            xStart : 0,
                                            yStart : 0,
                                          }
          Self.Catena.MouseInfo.Indice = TSchedaGenerica.DisponiFromInteger(ObjCatena.GRAPH_ORDINAMENTO)
          Self.Catena.MouseInfo.MouseDown = false
          Self.Catena.MouseInfo.MouseDownEnlarge = false
          // Self.MaxMinGraph = MaxMinGraph
          Self.AdattaGrafici()
          Self.Catena.DatiGrafici.AXES_MAX = TZMathFunct.GetMultiplo(Self.Catena.DatiGrafici.AXES_MAX, Self.Catena.DatiGrafici.NOTCH_SIZE, 'Difetto')
          
          if (OnSuccess != undefined)
          {
            OnSuccess()
          }
          Self.MostraGrafici = true
          Self.CaricamentoDatiCatena = false
          Self.EmettiCatenaCambiata()
        },
        function() //ErrorMessage,DescrErrore)
        {
          Self.CaricamentoDatiCatena = false
          Self.DatiNonCaricati       = true
          // alert(ErrorMessage + '[' + DescrErrore + ']')
        }) 
      },
      
      OnClickChiudiPopup()
      {
        this.PopupStorici = false
      },

      OnClickChiudiPopupTensioneAssorb()
      {
        this.PopupTensioneAssorbimento = false
      },

      OnClickChiudiPopupStazioneMeteo()
      {
        this.PopupStazioneMeteo = false
      },

      OnClickChiudiPopupModulazioneGrafici(ChiudiPopup, RicaricaPagina = true)
      {
        if(RicaricaPagina)
          this.CaricaConfigurazioneGrafici()
        if(ChiudiPopup)
          this.PopupModulazioneGrafici = false
      },

      OnClickApriPopupTensioneAssorbimento()
      {
        let Result = []
        if(this.Catena.Moduli.length != 0)
        {
          for(let i = 0; i < this.Catena.Moduli.length; i++)
          {
            let OggettoModulo          = {}
            OggettoModulo.Id           = this.Catena.Moduli[i].MODULO
            OggettoModulo.Catena       = this.Catena.Moduli[i].CATENA
            OggettoModulo.Profondita   = (this.Catena.Moduli[i].PROFONDITA_CODA / 100).toFixed(2)
            OggettoModulo.Piezometro   = TSchedaGenerica.DisponiFromBoolean(this.Catena.Moduli[i].PIEZOMETRO)
            OggettoModulo.Estensimetro = TSchedaGenerica.DisponiFromBoolean(this.Catena.Moduli[i].ESTENSIMETRO)
            OggettoModulo.Selezionato  = false
            OggettoModulo.Colore       = TZGenericFunct.GenerateRandomColor(['#FFFFFF, #ffffff'])

            Result.push(OggettoModulo)
          }
          this.VettoreModuli = []
          this.VettoreModuli = Result
        }
        this.PopupTensioneAssorbimento = !this.PopupTensioneAssorbimento
      },

      OnClickApriPopup()
      {
        let Result = []
        if(this.Catena.Moduli.length != 0)
        {
          for(let i = 0; i < this.Catena.Moduli.length; i++)
          {
            if (!TSchedaGenerica.DisponiFromBoolean(this.Catena.Moduli[i].INCLINOMETRO)  &&
                !TSchedaGenerica.DisponiFromBoolean(this.Catena.Moduli[i].TERMOMETRO)    &&
                !TSchedaGenerica.DisponiFromBoolean(this.Catena.Moduli[i].ACCELEROMETRO) &&
                !TSchedaGenerica.DisponiFromBoolean(this.Catena.Moduli[i].ESTENSIMETRO)  &&
                !TSchedaGenerica.DisponiFromBoolean(this.Catena.Moduli[i].MAGNETOMETRO)  &&
                !TSchedaGenerica.DisponiFromBoolean(this.Catena.Moduli[i].PIEZOMETRO))
              continue
            let OggettoModulo          = {}
            OggettoModulo.Id           = this.Catena.Moduli[i].MODULO
            OggettoModulo.Catena       = this.Catena.Moduli[i].CATENA
            OggettoModulo.Profondita   = (this.Catena.Moduli[i].PROFONDITA_CODA / 100).toFixed(2)
            OggettoModulo.Lunghezza    = (this.Catena.Moduli[i].LUNGHEZZA_SPEZZONE / 100).toFixed(2)
            OggettoModulo.Piezometro   = TSchedaGenerica.DisponiFromBoolean(this.Catena.Moduli[i].PIEZOMETRO)
            OggettoModulo.Estensimetro = TSchedaGenerica.DisponiFromBoolean(this.Catena.Moduli[i].ESTENSIMETRO)
            OggettoModulo.Selezionato  = false

            Result.push(OggettoModulo)
          }
          
          this.VettoreModuli = []
          this.VettoreModuli = Result
        }
        this.PopupStorici = !this.PopupStorici
      },

      CaricaConfigurazioneGrafici()
      {
        if(!this.CatenaInCaricamento)
        {
          let Self                     = this
          let ParametriQuery           = {}
          ParametriQuery.IdSito        = this.Catena.DatiCatena.CHIAVE_SITO,
          ParametriQuery.IdCatena      = this.Catena.DatiCatena.CHIAVE,
          ParametriQuery.NomeConf      = '',
          ParametriQuery.JSONConf      = {},
          ParametriQuery.Modifica      = false,
          ParametriQuery.CambiaModelli = false,
          this.CatenaInCaricamento     = true

          SystemInformation.AdvQuery.ExecuteExternalScript('ExtraHandleConfigurazioneGrafici', ParametriQuery, function(Answer) 
          {
            Self.JSONGraficiModulari = Answer.QueryData[0]
            Self.ObjListaModelli = Answer.QueryModelli
            let ObjConfigGrafici 
            try 
            {
              if(Answer.QueryData && Answer.QueryData.length != 0 && Answer.QueryData[0].JSONConfig != '')
                 ObjConfigGrafici = JSON.parse(Answer.QueryData[0].JSONConfig)
              else ObjConfigGrafici = null


              if (ObjConfigGrafici !== null && typeof ObjConfigGrafici === 'object' && !Array.isArray(ObjConfigGrafici) && ObjConfigGrafici.BANDE.length != 0) 
              {
                let JSONConfig = JSON.parse(Answer.QueryData[0].JSONConfig)
                Self.ObjPosizioneGrafici = JSONConfig.BANDE
                Self.ObjSommario = JSONConfig.SOMMARIO
                Self.GetDateStorici()
                Self.GetDatiCateneStoriche(Self.ElaboraDatiStorici)
              } 
              else
              {
                let TrovatoDefault = false
                for (let i = 0; i < Self.ObjListaModelli.length; i++) 
                {
                  let ModelloCorrente = Self.ObjListaModelli[i]
                  if(ModelloCorrente.IsDefaultModello)
                  {
                    Self.ObjPosizioneGrafici = JSON.parse(ModelloCorrente.JSONConfigModello).BANDE
                    TrovatoDefault = true
                  }
                  Self.CatenaInCaricamento     = false
                }
                if(!TrovatoDefault)
                {
                  Self.ObjPosizioneGrafici = {}
                  Self.JSONGraficiModulari = ''
                  Self.CatenaInCaricamento     = false
                }
                else
                {
                  Self.GetDateStorici()
                  Self.GetDatiCateneStoriche(Self.ElaboraDatiStorici)
                }
              }
            } 
            catch (e) 
            {
              Self.ObjPosizioneGrafici = {}
              Self.JSONGraficiModulari = ''
              console.error(Self.GetTraduzioneLabel('VUEAppContentGraficiVerticaliModulabili','TKN_ERR_JSON',Self.LinguaUtente), e.message);
            }

          },
          function(ErrorMessage,DescrErrore)
          {
            alert(ErrorMessage + '[' + DescrErrore + ']')
          })
        }
      },

      ElaboraDatiStorici()
      {
        for (let i = 0; i < this.ObjPosizioneGrafici.length; i++) 
        {
          let Banda = this.ObjPosizioneGrafici[i]
          for (let j = 0; j < Banda.MODULO_GRAFICO.length; j++) 
          {
            let ModuloGrafico = Banda.MODULO_GRAFICO[j]

            if(ModuloGrafico.ELEMENTO == this.ModuliGrafici.CampRilevati)
            {   
              let DataInizioGrafico = new Date()
              DataInizioGrafico.setTime(DataInizioGrafico.getTime() - (ModuloGrafico.LUNGHEZZA_TEMPORALE_GIORNI * 24 + ModuloGrafico.LUNGHEZZA_TEMPORALE_ORE) * 60 * 60 * 1000);

              ModuloGrafico.ObjDal      = {}
              ModuloGrafico.ObjDal.Data = DataInizioGrafico.toISOString().split('T')[0]
              ModuloGrafico.ObjDal.Ora = DataInizioGrafico.getUTCHours().toString()

              this.IsEstensimetro = ModuloGrafico.MOSTRA_EST
              this.IsPiezometro   = ModuloGrafico.MOSTRA_PIEZO

              ModuloGrafico.MODULI[0].Dati[0].Dati = this.FiltraDatiPerData(ModuloGrafico.MODULI[0].Dati[0].Dati, ModuloGrafico.ObjDal.Data, ModuloGrafico.ObjDal.Ora)
              setTimeout(()=>{this.MixInsSetObjGraficoCampRil(ModuloGrafico.ObjGrafico, ModuloGrafico.MODULI[0].Dati[0], true)}, 50)
            }

            if(ModuloGrafico.ELEMENTO == this.ModuliGrafici.Spostamenti ||
                ModuloGrafico.ELEMENTO == this.ModuliGrafici.Velocità ||
                ModuloGrafico.ELEMENTO == this.ModuliGrafici.Accelerazione)
            {  
              let DataInizioGrafico = new Date()
              DataInizioGrafico.setTime(DataInizioGrafico.getTime() - (ModuloGrafico.LUNGHEZZA_TEMPORALE_GIORNI * 24 + ModuloGrafico.LUNGHEZZA_TEMPORALE_ORE) * 60 * 60 * 1000);

              ModuloGrafico.ObjDal      = {}
              ModuloGrafico.ObjDal.Data = DataInizioGrafico.toISOString().split('T')[0]
              ModuloGrafico.ObjDal.Ora = DataInizioGrafico.getUTCHours().toString()

              this.IsVelocita                 = ModuloGrafico.ELEMENTO == this.ModuliGrafici.Velocità && !ModuloGrafico.IS_GIORNALIERO
              this.IsAccelerazione            = ModuloGrafico.ELEMENTO == this.ModuliGrafici.Accelerazione && !ModuloGrafico.IS_GIORNALIERO
              this.IsVelocitaGiornaliera      = ModuloGrafico.ELEMENTO == this.ModuliGrafici.Velocità && ModuloGrafico.IS_GIORNALIERO 
              this.IsAccelerazioneGiornaliera = ModuloGrafico.ELEMENTO == this.ModuliGrafici.Accelerazione && ModuloGrafico.IS_GIORNALIERO 

              if(ModuloGrafico.MOSTRA_TOTALE)
              {
                if(!this.IsVelocita && !this.IsVelocitaGiornaliera && !this.IsAccelerazione && !this.IsAccelerazioneGiornaliera)
                  ModuloGrafico.ObjTotale = this.ObjTotaleSpostamento

                if(this.IsVelocita)
                  ModuloGrafico.ObjTotale = this.ObjTotaleVelocitaH

                if(this.IsVelocitaGiornaliera)
                  ModuloGrafico.ObjTotale = this.ObjTotaleVelocitaGG

                if(this.IsAccelerazione)
                  ModuloGrafico.ObjTotale = this.ObjTotaleAccelerazioneH

                if(this.IsAccelerazioneGiornaliera)
                  ModuloGrafico.ObjTotale = this.ObjTotaleAccelerazioneGG
              }
              else
              {
                ModuloGrafico.ObjTotale = null
              }

              ModuloGrafico.MODULI[0].Dati[0].Dati = this.FiltraDatiPerData(ModuloGrafico.MODULI[0].Dati[0].Dati, ModuloGrafico.ObjDal.Data, ModuloGrafico.ObjDal.Ora)
              if(ModuloGrafico.ObjTotale != null)
                ModuloGrafico.ObjTotale.ListaTotaliSpostamento = this.FiltraDatiPerData(ModuloGrafico.ObjTotale.ListaTotaliSpostamento, ModuloGrafico.ObjDal.Data, ModuloGrafico.ObjDal.Ora)

              setTimeout(()=>{this.MixInsSetObjGraficoSpostamenti(ModuloGrafico.ObjGrafico, ModuloGrafico.ObjTotale, ModuloGrafico.MODULI[0].Dati[0])}, 50)
            }

            if(ModuloGrafico.ELEMENTO == this.ModuliGrafici.Assorbimento ||
                ModuloGrafico.ELEMENTO == this.ModuliGrafici.TensAlim)
            {  
              let DataInizioGrafico = new Date()
              DataInizioGrafico.setTime(DataInizioGrafico.getTime() - (ModuloGrafico.LUNGHEZZA_TEMPORALE_GIORNI * 24 + ModuloGrafico.LUNGHEZZA_TEMPORALE_ORE) * 60 * 60 * 1000);

              ModuloGrafico.ObjDal      = {}
              ModuloGrafico.ObjDal.Data = DataInizioGrafico.toISOString().split('T')[0]
              ModuloGrafico.ObjDal.Ora  = DataInizioGrafico.getUTCHours().toString()

              ModuloGrafico.MODULI[0].Dati[0].Dati = this.FiltraDatiPerData(ModuloGrafico.MODULI[0].Dati[0].Dati, ModuloGrafico.ObjDal.Data, ModuloGrafico.ObjDal.Ora)  
              this.MixInsSetObjGraficoTensAss(ModuloGrafico.ObjGrafico, ModuloGrafico.MODULI[0].Dati, this.GetTipoGrafico(ModuloGrafico.ELEMENTO))
            } 

            if(ModuloGrafico.ELEMENTO == this.ModuliGrafici.EvAccAmpiezza ||
               ModuloGrafico.ELEMENTO == this.ModuliGrafici.EvAccFrequenza)
            {  
              let DataInizioGrafico = new Date()
              DataInizioGrafico.setTime(DataInizioGrafico.getTime() - (ModuloGrafico.LUNGHEZZA_TEMPORALE_GIORNI * 24 + ModuloGrafico.LUNGHEZZA_TEMPORALE_ORE) * 60 * 60 * 1000);

              ModuloGrafico.ObjDal      = {}
              ModuloGrafico.ObjDal.Data = DataInizioGrafico.toISOString().split('T')[0]

              if(ModuloGrafico.ELEMENTO == this.ModuliGrafici.EvAccAmpiezza)
                ModuloGrafico.ObjDal.Ora = DataInizioGrafico.getUTCHours().toString()
              else ModuloGrafico.ObjDal.Ora = 0

              ModuloGrafico.MODULI[0].Dati[0].Dati = this.FiltraDatiPerData(ModuloGrafico.MODULI[0].Dati[0].Dati, ModuloGrafico.ObjDal.Data, ModuloGrafico.ObjDal.Ora)  

              this.MixInsSetObjGraficoEvAcc(ModuloGrafico.ObjGrafico)
            } 
          }
        }
        this.CatenaInCaricamento = false
      },

      FiltraDatiPerData(Dati, DaData, DaOra)
      {
        const dataAssegnata = new Date(DaData + ' ' + DaOra + ':00');
        const datiFiltrati = Dati.filter(item => new Date(item.Data) >= dataAssegnata);
        return datiFiltrati
      },

      GetDatiCateneStoriche(OnSuccess)
      {
        this.ObjTotaleSpostamento     = null
        this.ObjTotaleVelocitaGG      = null
        this.ObjTotaleVelocitaH       = null
        this.ObjTotaleAccelerazioneGG = null
        this.ObjTotaleAccelerazioneH  = null
        let ModuloTrovato             = false
        for (let i = 0; i < this.ObjPosizioneGrafici.length; i++) 
        {
          let Banda = this.ObjPosizioneGrafici[i]
          for (let j = 0; j < Banda.MODULO_GRAFICO.length; j++) 
          {
            let ModuloGrafico = Banda.MODULO_GRAFICO[j]
            if(ModuloGrafico.ELEMENTO == this.ModuliGrafici.CampRilevati ||
               ModuloGrafico.ELEMENTO == this.ModuliGrafici.Spostamenti ||
               ModuloGrafico.ELEMENTO == this.ModuliGrafici.Velocità ||
               ModuloGrafico.ELEMENTO == this.ModuliGrafici.Accelerazione ||
               ModuloGrafico.ELEMENTO == this.ModuliGrafici.Assorbimento ||
               ModuloGrafico.ELEMENTO == this.ModuliGrafici.TensAlim ||
               ModuloGrafico.ELEMENTO == this.ModuliGrafici.EvAccAmpiezza ||
               ModuloGrafico.ELEMENTO == this.ModuliGrafici.EvAccFrequenza)
            {
              if(!ModuloTrovato)
              {
                this.CaricaVettoreModuli()
                ModuloTrovato                     = true
                this.ObjModuliConsiderati         = {}
                this.ObjModuliConsiderati.Sensori = []
                this.ObjDati                      = {}
                this.ObjDati.IdCatena             = this.Catena.DatiCatena.CHIAVE
                this.ObjDati.IdSito               = this.Catena.DatiCatena.CHIAVE_SITO
                this.ObjDati.ListaFalde           = this.VettoreModuli.filter((element) => {return element.Piezometro})
                this.ObjDati.ListaTuttiModuli     = this.VettoreModuli
                this.ObjDati.OrientamentoAsse     = ModuloGrafico.ORIENTAMENTO
                this.ObjDati.AllineamentoTemp     = null
                this.ObjDati.AllineamentoIncl     = null
                this.ObjDati.AllineamentoDef      = null
                this.ObjDati.ListaModuli          = []
              }

              let CopiaModuliCatenaAttuale = structuredClone(this.VettoreModuli)
              for(let k = 0; k < ModuloGrafico.MODULI.length; k++) 
              {
                for(let l = 0; l < CopiaModuliCatenaAttuale.length; l++)
                {
                 if(ModuloGrafico.MODULI[k].Id == CopiaModuliCatenaAttuale[l].Id)
                  {
                    CopiaModuliCatenaAttuale[l].Colore = ModuloGrafico.MODULI[k].Colore
                    CopiaModuliCatenaAttuale[l].Selezionato = ModuloGrafico.MODULI[k].Selezionato
                  } 
                }
              } 
              ModuloGrafico.MODULI = CopiaModuliCatenaAttuale

              if(ModuloGrafico.MOSTRA_TOTALE)
              {
                ModuloGrafico.MODULI = ModuloGrafico.MODULI.filter(modulo => modulo.Selezionato === true);

                ModuloGrafico.MODULI.forEach(ModuloCorrente => 
                {
                  this.ObjModuliConsiderati.Sensori.push(ModuloCorrente)
                  this.ObjModuliConsiderati.Sensori[this.ObjModuliConsiderati.Sensori.length-1].Dati = []
                })

                if(ModuloGrafico.ELEMENTO == this.ModuliGrafici.Spostamenti)
                {
                  this.ModuliConsideratiTotaleSpost = JSON.parse(JSON.stringify(ModuloGrafico.MODULI))
                }

                if(ModuloGrafico.ELEMENTO == this.ModuliGrafici.Velocità)
                {
                  if(ModuloGrafico.IS_GIORNALIERO)  
                    this.ModuliConsideratiTotaleVelGG = JSON.parse(JSON.stringify(ModuloGrafico.MODULI))
                  else this.ModuliConsideratiTotaleVelH = JSON.parse(JSON.stringify(ModuloGrafico.MODULI))
                }

                if(ModuloGrafico.ELEMENTO == this.ModuliGrafici.Accelerazione)
                {
                  if(ModuloGrafico.IS_GIORNALIERO)
                    this.ModuliConsideratiTotaleAccGG = JSON.parse(JSON.stringify(ModuloGrafico.MODULI))
                  this.ModuliConsideratiTotaleAccH = JSON.parse(JSON.stringify(ModuloGrafico.MODULI))
                }

              }
              else
              {
                for (let k = 0; k < ModuloGrafico.MODULI.length; k++) 
                {
                  let ModuloCorrente = ModuloGrafico.MODULI[k]
  
                  if(ModuloCorrente.Selezionato)
                  {
                    this.ObjModuliConsiderati.Sensori.push(ModuloCorrente)
                    this.ObjModuliConsiderati.Sensori[this.ObjModuliConsiderati.Sensori.length-1].Dati = []
                    ModuloGrafico.MODULI = []
                    ModuloGrafico.MODULI.push(ModuloCorrente)
                  }
                }
              }
            }
          }
        }
        if(ModuloTrovato)
        {
          this.TipoGrafico            = this.TipiStorici.GRAFICI_GV
          this.ObjDati.TipoGrafico    = this.TipiStorici.GRAFICI_GV
          this.ObjDati.ListaModuli    = [] 
          this.VettoreStartValueSpost = []
          this.VettoreStartValueVelGG = []
          this.VettoreStartValueVelH  = []
          this.VettoreStartValueAccGG = []
          this.VettoreStartValueAccH  = []
          this.SommaSpostamenti       = 0
          this.ObjModuliConsiderati.OggettoTotaleSpostamento = null
          this.ObjModuliConsiderati.Sensori.forEach(element => { this.ObjDati.ListaModuli.push(element) });
          this.MixInsDownloadDatiAcquisitiModuli(this.ObjModuliConsiderati, () => {this.InserisciDatiNeiModuli(OnSuccess)}, true)
        }
        else this.CatenaInCaricamento     = false
      },

      InserisciDatiNeiModuli(OnSuccess)
      {
        for (let i = 0; i < this.ObjPosizioneGrafici.length; i++) 
        {
          let Banda = this.ObjPosizioneGrafici[i]
          for (let j = 0; j < Banda.MODULO_GRAFICO.length; j++) 
          {
            let ModuloGrafico = Banda.MODULO_GRAFICO[j]

            if(ModuloGrafico.ELEMENTO == this.ModuliGrafici.CampRilevati ||
                ModuloGrafico.ELEMENTO == this.ModuliGrafici.Spostamenti ||
                ModuloGrafico.ELEMENTO == this.ModuliGrafici.Velocità ||
                ModuloGrafico.ELEMENTO == this.ModuliGrafici.Accelerazione ||
                ModuloGrafico.ELEMENTO == this.ModuliGrafici.Assorbimento ||
                ModuloGrafico.ELEMENTO == this.ModuliGrafici.TensAlim ||
                ModuloGrafico.ELEMENTO == this.ModuliGrafici.EvAccAmpiezza ||
                ModuloGrafico.ELEMENTO == this.ModuliGrafici.EvAccFrequenza)
            {   
              for (let k = 0; k < this.ObjModuliConsiderati.Sensori.length; k++)
              {
                if(this.ObjModuliConsiderati.Sensori[k].Id == ModuloGrafico.MODULI[0].Id)
                {
                  ModuloGrafico.MODULI[0].Dati.push(structuredClone(this.ObjModuliConsiderati.Sensori[k]))
                  ModuloGrafico.ObjGrafico = structuredClone(this.ObjGrafico)
                }
              }
            }
          }
        }
        OnSuccess()
      },

      OnClickAnnullaCaricamentoDati()
      {
        this.OperazioneAnnullata = true
      },

      GetDateStorici()
      {
        let DataOggi = new Date()
        this.ObjAl  = {
                        Data : DataOggi.toISOString().split('T')[0],
                        Ora  : 0
                      }

        let DataXGiorniFa = new Date();
        DataXGiorniFa.setDate(DataOggi.getDate() - this.GiorniDaCaricare);
        this.ObjDal = {
                          Data : DataXGiorniFa.toISOString().split('T')[0],
                          Ora  : 0 
                        }

        this.GetPorzioniDiDate()
      },
      
      GetPorzioniDiDate()
      {
        if(this.ObjDal.Ora == undefined)
          this.ObjDal.Ora = 0
        if(this.ObjAl.Ora == undefined)
          this.ObjAl.Ora = 0

        if (!isNaN(parseInt(this.ObjDal.Ora)))
          this.ObjDal.Ora = parseInt(this.ObjDal.Ora)
        if (!isNaN(parseInt(this.ObjAl.Ora)))
          this.ObjAl.Ora = parseInt(this.ObjAl.Ora)

        let DallaOra = typeof this.ObjDal.Ora == 'number' ? (this.ObjDal.Ora < 10? '0' + this.ObjDal.Ora + ':00:00' : this.ObjDal.Ora + ':00:00') : this.ObjDal.Ora
        let AllaOra = typeof this.ObjAl.Ora == 'number' ? (this.ObjAl.Ora < 10? '0' + this.ObjAl.Ora + ':00:00' : this.ObjAl.Ora + ':00:00') : this.ObjAl.Ora

        let DataAl = this.ObjAl.Data + ' ' + AllaOra
        
        this.VettorePorzioniDiDate = SystemInformation.GetPorzioniDiGiorni(this.ObjDal.Data + ' ' + DallaOra, 
                                                                           DataAl)
      },

      GetCalcoloSpostNordEstAzimuth(Risultato)
      {
        let SumSpostamentoNord = 0
        let SumSpostamentoEst = 0
        let Azimuth = 0
        let Filtro = 0
        
        if(Risultato != undefined && Risultato.length > 0)
        {
          for(let i = 0; i < Risultato.length; i++)
          {
            if (!this.ObjDifferenziale.Differenziale)
            {
              Risultato[i].SpostNord = ((Risultato[i].SpostamentoNord / 1000) + SumSpostamentoNord).toFixed(2);
              Risultato[i].SpostEst = ((Risultato[i].SpostamentoEst / 1000) + SumSpostamentoEst).toFixed(2);

              SumSpostamentoNord += (Risultato[i].SpostamentoNord / 1000)
              SumSpostamentoEst += (Risultato[i].SpostamentoEst / 1000)
            }
            else
            {
              Risultato[i].SpostNord = (Risultato[i].SpostamentoNord / 1000).toFixed(2);
              Risultato[i].SpostEst = (Risultato[i].SpostamentoEst / 1000).toFixed(2);

              SumSpostamentoNord = (Risultato[i].SpostamentoNord / 1000)
              SumSpostamentoEst = (Risultato[i].SpostamentoEst / 1000)
            }
            

            if(SumSpostamentoNord != 0 && (Math.abs(Risultato[i].Roll) >= TZMathFunct.DegToRad(Filtro) || Math.abs(Risultato[i].Pitch) >= TZMathFunct.DegToRad(Filtro)))
            {
              Azimuth = Math.atan(SumSpostamentoEst / SumSpostamentoNord) * 180 / Math.PI
              if (SumSpostamentoNord < 0 && SumSpostamentoEst != 0)
                Azimuth += 180
              if (SumSpostamentoNord > 0 && SumSpostamentoEst < 0)
                Azimuth += 360
            }
            
            while (Azimuth > 360)
              Azimuth -= 360

            Risultato[i].AzimuthSpostAng = Azimuth.toFixed(1)
          }
        }
      },

      CaricaVettoreModuli()
      {
        let Result = []
        if(this.Catena.Moduli.length != 0)
        {
          for(let i = 0; i < this.Catena.Moduli.length; i++)
          {
            let OggettoModulo          = {}
            OggettoModulo.Id           = this.Catena.Moduli[i].MODULO
            OggettoModulo.Catena       = this.Catena.Moduli[i].CATENA
            OggettoModulo.Profondita   = (this.Catena.Moduli[i].PROFONDITA_CODA / 100).toFixed(2)
            OggettoModulo.Lunghezza    = (this.Catena.Moduli[i].LUNGHEZZA_SPEZZONE / 100).toFixed(2)
            OggettoModulo.Piezometro   = TSchedaGenerica.DisponiFromBoolean(this.Catena.Moduli[i].PIEZOMETRO)
            OggettoModulo.Estensimetro = TSchedaGenerica.DisponiFromBoolean(this.Catena.Moduli[i].ESTENSIMETRO)
            OggettoModulo.Selezionato  = false
            OggettoModulo.Colore       = TZGenericFunct.GenerateRandomColor(['#FFFFFF, #ffffff'])
            // OggettoModulo.Colore       = this.Marrone

            this.GetParamsModuli(OggettoModulo)
            Result.push(OggettoModulo)
          }
          
          this.GetCalcoloSpostNordEstAzimuth(Result)

          this.VettoreModuli = []
          this.VettoreModuli = Result
        }
      },

      OnClickApriPopupModulazioneGrafici()
      {
        this.CaricaVettoreModuli()
        this.PopupModulazioneGrafici = !this.PopupModulazioneGrafici
      },

      OnClickApriPopupAllarmi()
      {
        this.PopupAllarmi = !this.PopupAllarmi
      },


      GetParamsModuli(OggettoModulo)
      {
        for(let i = 0; i < this.Catena.DatiCatena.Spostamenti.Date.length; i++)
        {
          if(this.UltimaData.Data == this.Catena.DatiCatena.Spostamenti.Date[i].Data)
          {
            for(let j = 0; j < this.Catena.DatiCatena.Spostamenti.Date[i].Moduli.length; j++)
            {
              if(OggettoModulo.Id == this.Catena.DatiCatena.Spostamenti.Date[i].Moduli[j].Modulo)
              {
                OggettoModulo.Pitch = this.Catena.DatiCatena.Spostamenti.Date[i].Moduli[j].Pitch
                OggettoModulo.Roll  = this.Catena.DatiCatena.Spostamenti.Date[i].Moduli[j].Roll
                OggettoModulo.Temperatura = this.Catena.DatiCatena.Spostamenti.Date[i].Moduli[j].Temperatura
                OggettoModulo.SpostamentoNord = this.Catena.DatiCatena.Spostamenti.Date[i].Moduli[j].SpostamentoNord
                OggettoModulo.SpostamentoEst = this.Catena.DatiCatena.Spostamenti.Date[i].Moduli[j].SpostamentoEst
                break;
              }
            }
            break;
          }
        }
      },

      OnClickApriPopupStazioneMeteo()
      {
        let Result = []
        if(this.Catena.Moduli.length != 0)
        {
          for(let i = 0; i < this.Catena.Moduli.length; i++)
          {
            let OggettoModulo          = {}
            OggettoModulo.Id           = this.Catena.Moduli[i].MODULO
            OggettoModulo.Catena       = this.Catena.Moduli[i].CATENA
            OggettoModulo.Profondita   = (this.Catena.Moduli[i].PROFONDITA_CODA / 100).toFixed(2)
            OggettoModulo.Piezometro   = TSchedaGenerica.DisponiFromBoolean(this.Catena.Moduli[i].PIEZOMETRO)
            OggettoModulo.Estensimetro = TSchedaGenerica.DisponiFromBoolean(this.Catena.Moduli[i].ESTENSIMETRO)
            OggettoModulo.Selezionato  = false

            Result.push(OggettoModulo)
          }
          this.VettoreModuli = []
          this.VettoreModuli = Result
        }
        this.PopupStazioneMeteo = !this.PopupStazioneMeteo
      },

      SalvaConfigurazioni()
      {
        let ParametriQuery      = {}
        ParametriQuery.IdSito   = this.ObjCatena.DatiCatena.CHIAVE_SITO,
        ParametriQuery.IdCatena = this.ObjCatena.DatiCatena.CHIAVE,
        ParametriQuery.NomeConf = this.ObjPosizioneGrafici.NomeConfig,
        ParametriQuery.JSONConf = JSON.stringify(this.ObjPosizioneGrafici),
        ParametriQuery.Modifica = true,
        ParametriQuery.CambiaModelli = false,

        SystemInformation.AdvQuery.ExecuteExternalScript('ExtraHandleConfigurazioneGrafici', ParametriQuery, function() 
        {

        },
        function(ErrorMessage,DescrErrore)
        {
          alert(ErrorMessage + '[' + DescrErrore + ']')
        }) 
      },

      CambiaTipoCumulazione()
      {
        this.Catena.AltreInfo.CumulaDaUltimo = !this.Catena.AltreInfo.CumulaDaUltimo
        this.LabelCumulativo = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_CUM_DA_MOD',this.LinguaUtente) + ' ' + this.Catena.Moduli[0].MODULO
        if (this.Catena.AltreInfo.CumulaDaUltimo)         
        {
          let LastModulo = -1
          for (let i = this.Catena.Moduli.length - 1; i >= 0; i--)
          {
            if (this.Catena.Moduli[i].INCLINOMETRO == 'T')
            {
              LastModulo = this.Catena.Moduli[i].MODULO
              break
            }
          }
          this.LabelCumulativo = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_CUM_DA_MOD',this.LinguaUtente) + ' ' + LastModulo
        } 
        this.GraficiChange++
      },
    },
    computed:
    {
      ObjPosizioneGraficiFiltrati:
      {
        get()
        {
          let ArrayObjFiltrati = []

          for(let i = 0; i < this.ObjPosizioneGrafici.length; i++)
          {
            let Banda = this.ObjPosizioneGrafici[i]

            if(!Banda.NASCOSTO)
              ArrayObjFiltrati.push(Banda)
          }

          return ArrayObjFiltrati
        }
      },
      ObjIngrandimentiFiltrati:
      {
        get()
        {
           let ArrayGlobale = []
           let SottoArray = []
           for(let i = 0; i < this.ObjIngrandimento.Dati.length; i++)
           {
            let Dato = this.ObjIngrandimento.Dati[i]
            if(Dato.Separatore)
            {
              if(SottoArray.length > 0)
              {
                ArrayGlobale.push(
                                    {
                                      Visibile : true, 
                                      Dati : SottoArray
                                    }
                                  )
          
              }

              SottoArray = [Dato]
            }

            else
            {
              SottoArray.push(Dato)
            }

           }

           if(SottoArray.length > 0)
           {
              ArrayGlobale.push(
                                  {
                                    Visibile : true, 
                                    Dati : SottoArray
                                  }
                               )
           }

           return ArrayGlobale
        }
      },

      EsportaXLSX:
      {
        get()
        {
          return this.MenuTrigger.StampaXLSX 
        }
      },
      CurrentObjPresenzaMenu :
      {
        get()
        {
          return this.ObjPresenzaMenu
        }
      },
      ApriPopupStorici:
      {
        get()
        {
          return this.MenuTrigger.ApriPopupStorici 
        }
      },
      ApriPopupTensioneAssorbimento:
      {
        get()
        {
          return this.MenuTrigger.ApriPopupTensioneAssorbimento 
        }
      },
      ApriPopupStazioneMeteo:
      {
        get()
        {
          return this.MenuTrigger.ApriPopupStazioneMeteo 
        }
      },
      ApriPopupModulazioneGrafici:
      {
        get()
        {
          return this.MenuTrigger.ApriPopupModulazioneGrafici 
        }
      },
      ApriPopupAllarmi:
      {
        get()
        {
          return this.MenuTrigger.ApriPopupAllarmi 
        }
      },
      TriggerAdattaGrafici:
      {
        get()
        {
          return this.MenuTrigger.TriggerAdattaGrafici 
        }
      },
      TriggerEsportaPDF:
      {
        get()
        {
          return this.MenuTrigger.TriggerEsportaPDF 
        }
      },
      TriggerDifferenziale:
      {
        get()
        {
          return this.MenuTrigger.TriggerDifferenziale 
        }
      },
      ApriPopupMediaAritmetica:
      {
        get()
        {
          return this.MenuTrigger.ApriPopupMediaAritmetica 
        }
      },
      ApriPopupExportXLSXCampioniRilevati:
      {
        get()
        {
          return this.MenuTrigger.ApriPopupExportXLSXCampioniRilevati 
        }
      },
      ApriPopupExportXLSXSpostamenti:
      {
        get()
        {
          return this.MenuTrigger.ApriPopupExportXLSXSpostamenti 
        }
      },
      ApriPopupCambiaScale:
      {
        get()
        {
          return this.MenuTrigger.ApriPopupCambiaScale 
        }
      },
      TriggerMassimizza:
      {
        get()
        {
          return this.MenuTrigger.TriggerMassimizza 
        }
      },
    },
    watch:
    {
      EsportaXLSX:
      {
        handler()
        {
          this.ApriPopupEsportaExcel()
        },
        deep : true
      },
      GraficiChange:
      {
        handler()
        {
          if(this.OggettoTotaleSpostamento != undefined)
          {
            if(this.OggettoTotaleSpostamento.ModificatoAsseX)
            { 
              this.ObjGrafico.AxisX.Modificato = this.OggettoTotaleSpostamento.ModificatoAsseX
              this.ObjGrafico.AxisX.UdmX       = this.OggettoTotaleSpostamento.AdattaUdmX
              this.ObjGrafico.AxisX.TipoUdmX   = this.OggettoTotaleSpostamento.AdattaTipoUdmX
              this.Repaint++
            }
          }

          if(this.CurrentModulo != undefined)
          {
            if(this.CurrentModulo.ModificatoAsseX)
            {
              this.ObjGrafico.AxisX.Modificato = this.CurrentModulo.ModificatoAsseX
              this.ObjGrafico.AxisX.UdmX       = this.CurrentModulo.AdattaUdmX
              this.ObjGrafico.AxisX.TipoUdmX   = this.CurrentModulo.AdattaTipoUdmX
              this.Repaint++
            }
          }
        }
      },
      ApriPopupStorici:
      {
        handler()
        {
          this.OnClickApriPopup()
        },
        deep : true
      },
      ApriPopupTensioneAssorbimento:
      {
        handler()
        {
          this.OnClickApriPopupTensioneAssorbimento()
        },
        deep : true
      },
      ApriPopupStazioneMeteo:
      {
        handler()
        {
          this.OnClickApriPopupStazioneMeteo()
        },
        deep : true
      },
      ApriPopupModulazioneGrafici:
      {
        handler()
        {
          this.OnClickApriPopupModulazioneGrafici()
        },
        deep : true
      },
      ApriPopupAllarmi:
      {
        handler()
        {
          this.OnClickApriPopupAllarmi()
        },
        deep : true
      },
      TriggerAdattaGrafici:
      {
        handler()
        {
          this.AdattaGrafici()
        },
        deep : true
      },
      TriggerEsportaPDF:
      {
        handler()
        {
          this.EsportaComePDF()
        },
        deep : true
      },
      TriggerDifferenziale:
      {
        handler()
        {
          this.CambiaDifferenziale()
        },
        deep : true
      },
      ApriPopupMediaAritmetica:
      {
        handler()
        {
          this.ApriPopupMedia()
        },
        deep : true
      },
      ApriPopupExportXLSXCampioniRilevati:
      {
        handler()
        {
          this.ApriPopupXLSXStorici(true)
        },
        deep : true
      },
      ApriPopupExportXLSXSpostamenti:
      {
        handler()
        {
          this.ApriPopupXLSXStorici(false)          
        },
        deep : true
      },
      ApriPopupCambiaScale:
      {
        handler()
        {
          this.CambiaScaleAll()
        },
        deep : true
      },
      TriggerMassimizza:
      {
        handler()
        {
          this.AdattaGrafici(false)
        },
        deep : true
      },
    },

    beforeMount()
    {
      if (localStorage.getItem(LOCALSTORAGE.GraficiAbbinatiAllineati) != null)
      {
        let LocalStorageAbbinatiAllineati = JSON.parse(localStorage.getItem(LOCALSTORAGE.GraficiAbbinatiAllineati))
        this.ObjAbbinati = LocalStorageAbbinatiAllineati.ObjAbbinati
        this.ObjAllineamento = LocalStorageAbbinatiAllineati.ObjAllineamento
        this.MostraUltimo = LocalStorageAbbinatiAllineati.MostraUltimo
        for (let  i = 0; i < this.ObjAbbinati.LsGraficiAbbinati.length; i++)
        {
          let SingleGraph = this.ObjAbbinati.LsGraficiAbbinati[i]
          this.StatoAbbinati.push({Data: SingleGraph.DataCompleta, Visibile: SingleGraph.Visibile})
        } 
      }      
      this.CurrentObjPresenzaMenu.VisualizzaStazioneMeteo = false
      this.CurrentObjPresenzaMenu.CatenaSoloPiezo = false
      this.ListaOreStandard = []
      for (let i = 0; i < 24; i++)
      {
        let Ora = i
        if (i < 10)
          Ora = '0' + Ora
        this.ListaOreStandard.push(Ora + ':00')
      }
      this.Catena.MouseInfo = {}
      this.Catena.MouseInfo.Coordinates = {x : 0, y : 0}
      this.Catena.MouseInfo.Detail = {}
      this.Catena.MouseOverOnCoords = {x: 0, y : 0}
      this.Catena.AltreInfo = {}
      this.Catena.AltreInfo.CumulaDaUltimo = false
      this.Catena.TipiAllarmiAttivi = []
      let ParametriURL = TZGenericFunct.GetURLParameters()  
      if (ParametriURL.ChiaveCatena != undefined && ParametriURL.ChiaveSito != undefined)
      {
        this.CaricamentoDatiCatena = true
        
        this.ChiaveCatena = ParametriURL.ChiaveCatena
        this.ChiaveSito = ParametriURL.ChiaveSito
        this.Catena.EstensimetroPresente = ParametriURL.Estensimetri == 'true'
        SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId
        this.LoadListaCatene()
        this.CaricaDatiCatena(this.CaricaConfigurazioneGrafici)
      }

      this.ResizeGraphs()
      window.addEventListener('resize', this.ResizeGraphs)
    },

    beforeUnmount()
    {
      clearInterval(this.IntervalIDRefreshDati)
      
      if (!this.PopupStorici && !this.PopupTensioneAssorbimento && !this.PopupStazioneMeteo)
      {
        this.VettoreModuli = []
        if(this.Catena.Moduli != undefined)
        {
          for(let i = 0; i < this.Catena.Moduli.length; i++)
          {
            let OggettoModulo          = {}
            OggettoModulo.Id           = this.Catena.Moduli[i].MODULO
            OggettoModulo.Catena       = this.Catena.Moduli[i].CATENA
            OggettoModulo.Profondita   = (this.Catena.Moduli[i].PROFONDITA_CODA / 100).toFixed(2)
            this.VettoreModuli.push(OggettoModulo)
          }
        }

        let URLSalvato = SystemInformation.OggettoInfoGraficiStorici.UrlRitornoAllaCatena
        
        SystemInformation.OggettoInfoGraficiStorici = new TInfoGraficiStorici(this.Catena.DatiCatena.CHIAVE_SITO, 
                                                                              this.Catena.DatiCatena.CHIAVE,
                                                                              this.Catena.Descrizione,
                                                                              SystemInformation.TipoPopupAperto,
                                                                              this.VettoreModuli,
                                                                              TZDateFunct.ChangeDate(new Date(), 'day', -7), 
                                                                              new Date(), 
                                                                              '00:00', 
                                                                              TZDateFunct.FormatDateTime('hh:nn', new Date),
                                                                              false,
                                                                              false,
                                                                              false,
                                                                              false)

        SystemInformation.OggettoInfoGraficiStorici.UrlRitornoAllaCatena  = URLSalvato
        localStorage.removeItem(LOCALSTORAGE.OggettoInfoGraficiStorici);
        localStorage.setItem(LOCALSTORAGE.OggettoInfoGraficiStorici, JSON.stringify(SystemInformation.OggettoInfoGraficiStorici))
      }
      localStorage.removeItem(LOCALSTORAGE.GraficiAbbinatiAllineati)
      let LocalStorageAbbinatiAllineati = {ObjAbbinati : this.ObjAbbinati, MostraUltimo : this.MostraUltimo, ObjAllineamento : this.ObjAllineamento}
      localStorage.setItem(LOCALSTORAGE.GraficiAbbinatiAllineati, JSON.stringify(LocalStorageAbbinatiAllineati))
      window.removeEventListener('resize', this.ResizeGraphs)
    },
    
    mounted()
    {
      this.LabelCumulativo = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_CUM_DA_MOD',this.LinguaUtente) + ' 0'
      if (window.location.hash == '/appMainWindow/GraficiStorici')
        location.reload
      if(SystemInformation.UserInformation.AutorefreshDati != 0)
      {
        this.IntervalIDRefreshDati = setInterval(() => {
                                                      if(this.FlagAbilitaRefreshDati)
                                                        this.CaricaDatiCatena()
                                                    },SystemInformation.UserInformation.AutorefreshDati*60000)
      }
    },
}
</script>

<style scoped>

.bordo-separatore {
  position: relative;
}

.bordo-separatore.bordo-spaziatore-moduli::before {
  content: "";
  position: absolute;
  left: 0;
  top: var(--altezza-titolo);
  bottom: 0;
  width: 1px;
  background: var(--colore-spaziatore);
}

.bordo-separatore::after {
  content: "";
  position: absolute;
  left: 0px;
  top: 0px;
  width: 1px;
  height: var(--altezza-titolo);
  background: white;
}

</style>